// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from Symfony Routing & Controllers

import type { AxiosRequestConfig } from 'axios';
import { getApi } from '#lib/stores/api.js';

export interface ApiConfig extends AxiosRequestConfig {
	raw?: boolean;
}
import type { ActionTrackingSearchRequest } from './actionTrackingSearchRequest.gen';
import { hydrateActionTrackingSearch, type ActionTrackingSearch, type ActionTrackingSearchApiResponse } from './actionTrackingSearch.gen';
import { hydratePublicJwks, type PublicJwks, type PublicJwksApiResponse } from './publicJwks.gen';
import type { AdminGenerateJwsTokenRequest } from './adminGenerateJwsTokenRequest.gen';
import { hydrateAdminGenerateJwsToken, type AdminGenerateJwsToken, type AdminGenerateJwsTokenApiResponse } from './adminGenerateJwsToken.gen';
import type { EmptyRequestDto } from './emptyRequestDto.gen';
import { hydrateAdminRotateJws, type AdminRotateJws, type AdminRotateJwsApiResponse } from './adminRotateJws.gen';
import type { AdminBookingSearchRequest } from './adminBookingSearchRequest.gen';
import { hydrateAdminBookingSearch, type AdminBookingSearch, type AdminBookingSearchApiResponse } from './adminBookingSearch.gen';
import type { AdminB2cPaymentSearchRequest } from './adminB2cPaymentSearchRequest.gen';
import { hydrateAdminB2cPaymentSearch, type AdminB2cPaymentSearch, type AdminB2cPaymentSearchApiResponse } from './adminB2cPaymentSearch.gen';
import type { AdminB2bPaymentSearchRequest } from './adminB2bPaymentSearchRequest.gen';
import { hydrateAdminB2bPaymentSearch, type AdminB2bPaymentSearch, type AdminB2bPaymentSearchApiResponse } from './adminB2bPaymentSearch.gen';
import type { AdminGuaranteeSearchRequest } from './adminGuaranteeSearchRequest.gen';
import { hydrateAdminGuaranteeSearch, type AdminGuaranteeSearch, type AdminGuaranteeSearchApiResponse } from './adminGuaranteeSearch.gen';
import type { AdminLeadSearchRequest } from './adminLeadSearchRequest.gen';
import { hydrateAdminLeadSearch, type AdminLeadSearch, type AdminLeadSearchApiResponse } from './adminLeadSearch.gen';
import { hydrateBillingSettings, type BillingSettings, type BillingSettingsApiResponse } from './billingSettings.gen';
import type { AdminUpdateBillingSettingsRequest } from './adminUpdateBillingSettingsRequest.gen';
import type { AdminSaveVoucherRequest } from './adminSaveVoucherRequest.gen';
import { hydrateBillingVoucher, type BillingVoucher, type BillingVoucherApiResponse } from './billingVoucher.gen';
import type { AdminBillingVoucherSearchRequest } from './adminBillingVoucherSearchRequest.gen';
import { hydrateAdminBillingVoucherSearch, type AdminBillingVoucherSearch, type AdminBillingVoucherSearchApiResponse } from './adminBillingVoucherSearch.gen';
import type { AdminBusinessSearchRequest } from './adminBusinessSearchRequest.gen';
import { hydrateAdminBusinessSearch, type AdminBusinessSearch, type AdminBusinessSearchApiResponse } from './adminBusinessSearch.gen';
import type { AdminUpdateBusinessRequest } from './adminUpdateBusinessRequest.gen';
import { hydrateBusinessAdmin, type BusinessAdmin, type BusinessAdminApiResponse } from './businessAdmin.gen';
import { hydrateAdminBusinessStats, type AdminBusinessStats, type AdminBusinessStatsApiResponse } from './adminBusinessStats.gen';
import type { AdminEmailSearchRequest } from './adminEmailSearchRequest.gen';
import { hydrateEmailSentSearch, type EmailSentSearch, type EmailSentSearchApiResponse } from './emailSentSearch.gen';
import type { AdminTestEmailRequest } from './adminTestEmailRequest.gen';
import type { AdminEventSearchRequest } from './adminEventSearchRequest.gen';
import { hydrateAdminEventSearch, type AdminEventSearch, type AdminEventSearchApiResponse } from './adminEventSearch.gen';
import { hydrateAdminEventConsumers, type AdminEventConsumers, type AdminEventConsumersApiResponse } from './adminEventConsumers.gen';
import type { AdminMarkAllEventsConsumedRequest } from './adminMarkAllEventsConsumedRequest.gen';
import type { AdminPushTestRequest } from './adminPushTestRequest.gen';
import { hydrateAdminPushTest, type AdminPushTest, type AdminPushTestApiResponse } from './adminPushTest.gen';
import type { AdminSaveReleaseNoteRequest } from './adminSaveReleaseNoteRequest.gen';
import { hydrateReleaseNote, type ReleaseNote, type ReleaseNoteApiResponse } from './releaseNote.gen';
import { hydrateAdminReleaseNoteReactions, type AdminReleaseNoteReactions, type AdminReleaseNoteReactionsApiResponse } from './adminReleaseNoteReactions.gen';
import type { AdminSmsSearchRequest } from './adminSmsSearchRequest.gen';
import { hydrateSmsSentSearch, type SmsSentSearch, type SmsSentSearchApiResponse } from './smsSentSearch.gen';
import type { AdminSocketTestRequest } from './adminSocketTestRequest.gen';
import { hydrateAdminSystemCommand, type AdminSystemCommand, type AdminSystemCommandApiResponse } from './adminSystemCommand.gen';
import type { AdminImpersonateRequest } from './adminImpersonateRequest.gen';
import { hydrateAdminResolveBooking, type AdminResolveBooking, type AdminResolveBookingApiResponse } from './adminResolveBooking.gen';
import type { ReleaseNoteSearchRequest } from './releaseNoteSearchRequest.gen';
import { hydrateReleaseNoteSearch, type ReleaseNoteSearch, type ReleaseNoteSearchApiResponse } from './releaseNoteSearch.gen';
import type { ReactReleaseNoteRequest } from './reactReleaseNoteRequest.gen';
import { hydrateReleaseNoteReact, type ReleaseNoteReact, type ReleaseNoteReactApiResponse } from './releaseNoteReact.gen';
import type { LoginRequest } from './loginRequest.gen';
import { hydrateUser, type User, type UserApiResponse } from './user.gen';
import type { VerifyTokenRequest } from './verifyTokenRequest.gen';
import type { LogoutRequest } from './logoutRequest.gen';
import { hydrateAuthLogout, type AuthLogout, type AuthLogoutApiResponse } from './authLogout.gen';
import type { ForgotPasswordRequest } from './forgotPasswordRequest.gen';
import type { RecoverPasswordRequest } from './recoverPasswordRequest.gen';
import { hydrateAuthRecoverPassword, type AuthRecoverPassword, type AuthRecoverPasswordApiResponse } from './authRecoverPassword.gen';
import type { GoogleLoginRequest } from './googleLoginRequest.gen';
import { hydrateGoogleAuthUrl, type GoogleAuthUrl, type GoogleAuthUrlApiResponse } from './googleAuthUrl.gen';
import type { GoogleAuthSaveRequest } from './googleAuthSaveRequest.gen';
import { hydrateGoogleAuth, type GoogleAuth, type GoogleAuthApiResponse } from './googleAuth.gen';
import type { UpdateLocaleRequest } from './updateLocaleRequest.gen';
import type { UpdatePasswordRequest } from './updatePasswordRequest.gen';
import type { DoNotDisturbRequest } from './doNotDisturbRequest.gen';
import { hydrateUserNotificationSettingList, type UserNotificationSettingList, type UserNotificationSettingListApiResponse } from './userNotificationSettingList.gen';
import type { UpdateNotificationSettingsRequest } from './updateNotificationSettingsRequest.gen';
import { hydrateContract, type Contract, type ContractApiResponse } from './contract.gen';
import { hydrateBillingVatList, type BillingVatList, type BillingVatListApiResponse } from './billingVatList.gen';
import type { ApplyVoucherRequest } from './applyVoucherRequest.gen';
import { hydrateBillingPackageGroupPriceList, type BillingPackageGroupPriceList, type BillingPackageGroupPriceListApiResponse } from './billingPackageGroupPriceList.gen';
import type { UpdateBillingInfoRequest } from './updateBillingInfoRequest.gen';
import type { ContractCompanySearchRequest } from './contractCompanySearchRequest.gen';
import { hydrateContractCompanySearch, type ContractCompanySearch, type ContractCompanySearchApiResponse } from './contractCompanySearch.gen';
import type { ContractVerifyVatRequest } from './contractVerifyVatRequest.gen';
import { hydrateContractVerifyVat, type ContractVerifyVat, type ContractVerifyVatApiResponse } from './contractVerifyVat.gen';
import { hydrateBillingInvoiceList, type BillingInvoiceList, type BillingInvoiceListApiResponse } from './billingInvoiceList.gen';
import { hydrateBillingPaymentList, type BillingPaymentList, type BillingPaymentListApiResponse } from './billingPaymentList.gen';
import { hydrateBillingBalance, type BillingBalance, type BillingBalanceApiResponse } from './billingBalance.gen';
import { hydrateBillingInvoiceDetail, type BillingInvoiceDetail, type BillingInvoiceDetailApiResponse } from './billingInvoiceDetail.gen';
import { hydrateBillingInvoiceUrl, type BillingInvoiceUrl, type BillingInvoiceUrlApiResponse } from './billingInvoiceUrl.gen';
import { hydrateBillingThisMonthFees, type BillingThisMonthFees, type BillingThisMonthFeesApiResponse } from './billingThisMonthFees.gen';
import type { ListStripeBalanceRequest } from './listStripeBalanceRequest.gen';
import { hydrateStripeTransactionList, type StripeTransactionList, type StripeTransactionListApiResponse } from './stripeTransactionList.gen';
import type { ListPaymentsRequest } from './listPaymentsRequest.gen';
import { hydrateTransactionList, type TransactionList, type TransactionListApiResponse } from './transactionList.gen';
import { hydrateTransactionTotals, type TransactionTotals, type TransactionTotalsApiResponse } from './transactionTotals.gen';
import type { ListGuaranteesRequest } from './listGuaranteesRequest.gen';
import { hydrateBillingGuaranteeTransactionList, type BillingGuaranteeTransactionList, type BillingGuaranteeTransactionListApiResponse } from './billingGuaranteeTransactionList.gen';
import type { ExportTransactionsRequest } from './exportTransactionsRequest.gen';
import type { ExportPaymentsRequest } from './exportPaymentsRequest.gen';
import { hydrateBillingExport, type BillingExport, type BillingExportApiResponse } from './billingExport.gen';
import type { ExportGuaranteesRequest } from './exportGuaranteesRequest.gen';
import { hydrateBillingSetupIntent, type BillingSetupIntent, type BillingSetupIntentApiResponse } from './billingSetupIntent.gen';
import { hydrateBillingPaymentMethodList, type BillingPaymentMethodList, type BillingPaymentMethodListApiResponse } from './billingPaymentMethodList.gen';
import type { ComputeAvailabilityRequest } from './computeAvailabilityRequest.gen';
import { hydrateAvailabilityCompute, type AvailabilityCompute, type AvailabilityComputeApiResponse } from './availabilityCompute.gen';
import type { CustomerSearchRequest } from './customerSearchRequest.gen';
import { hydrateCustomerSearch, type CustomerSearch, type CustomerSearchApiResponse } from './customerSearch.gen';
import type { UpsertCustomerRequest } from './upsertCustomerRequest.gen';
import { hydrateCustomer, type Customer, type CustomerApiResponse } from './customer.gen';
import { hydrateCustomerStats, type CustomerStats, type CustomerStatsApiResponse } from './customerStats.gen';
import type { ExportCustomersRequest } from './exportCustomersRequest.gen';
import type { ReviewSearchRequest } from './reviewSearchRequest.gen';
import { hydrateReviewSearch, type ReviewSearch, type ReviewSearchApiResponse } from './reviewSearch.gen';
import type { ReviewRatingStatsRequest } from './reviewRatingStatsRequest.gen';
import { hydrateReviewRatingStats, type ReviewRatingStats, type ReviewRatingStatsApiResponse } from './reviewRatingStats.gen';
import { hydrateReviewRatingSplit, type ReviewRatingSplit, type ReviewRatingSplitApiResponse } from './reviewRatingSplit.gen';
import type { MarkReviewReadRequest } from './markReviewReadRequest.gen';
import type { MarkReviewUnreadRequest } from './markReviewUnreadRequest.gen';
import type { ReplyReviewRequest } from './replyReviewRequest.gen';
import { hydrateBooking, type Booking, type BookingApiResponse } from './booking.gen';
import type { SessionInstanceSearchRequest } from './sessionInstanceSearchRequest.gen';
import { hydrateSessionInstanceSearch, type SessionInstanceSearch, type SessionInstanceSearchApiResponse } from './sessionInstanceSearch.gen';
import type { UpdateSessionInstanceRequest } from './updateSessionInstanceRequest.gen';
import { hydrateSessionInstance, type SessionInstance, type SessionInstanceApiResponse } from './sessionInstance.gen';
import type { SaveActivityRequest } from './saveActivityRequest.gen';
import { hydrateActivity, type Activity, type ActivityApiResponse } from './activity.gen';
import { hydrateActivityList, type ActivityList, type ActivityListApiResponse } from './activityList.gen';
import type { SaveAreaRequest } from './saveAreaRequest.gen';
import { hydrateArea, type Area, type AreaApiResponse } from './area.gen';
import { hydrateAreaList, type AreaList, type AreaListApiResponse } from './areaList.gen';
import type { SaveBlockingPeriodRequest } from './saveBlockingPeriodRequest.gen';
import { hydrateBlockingPeriod, type BlockingPeriod, type BlockingPeriodApiResponse } from './blockingPeriod.gen';
import type { BlockingPeriodSearchRequest } from './blockingPeriodSearchRequest.gen';
import { hydrateBlockingPeriodSearch, type BlockingPeriodSearch, type BlockingPeriodSearchApiResponse } from './blockingPeriodSearch.gen';
import type { BookingEventLogSearchRequest } from './bookingEventLogSearchRequest.gen';
import { hydrateBookingEventLogSearch, type BookingEventLogSearch, type BookingEventLogSearchApiResponse } from './bookingEventLogSearch.gen';
import type { SaveBookingEventRequest } from './saveBookingEventRequest.gen';
import { hydrateBookingEvent, type BookingEvent, type BookingEventApiResponse } from './bookingEvent.gen';
import type { TestBookingEventRequest } from './testBookingEventRequest.gen';
import { hydrateBookingEventTest, type BookingEventTest, type BookingEventTestApiResponse } from './bookingEventTest.gen';
import { hydrateBusiness, type Business, type BusinessApiResponse } from './business.gen';
import type { UpdateBusinessRequest } from './updateBusinessRequest.gen';
import type { UpdateBusinessGoogleReviewsRequest } from './updateBusinessGoogleReviewsRequest.gen';
import { hydrateStripeConnectRegister, type StripeConnectRegister, type StripeConnectRegisterApiResponse } from './stripeConnectRegister.gen';
import type { UpdateBusinessFontRequest } from './updateBusinessFontRequest.gen';
import type { SaveCustomFieldRequest } from './saveCustomFieldRequest.gen';
import { hydrateCustomField, type CustomField, type CustomFieldApiResponse } from './customField.gen';
import type { CreateCustomerPackageRequest } from './createCustomerPackageRequest.gen';
import { hydrateCustomerPackage, type CustomerPackage, type CustomerPackageApiResponse } from './customerPackage.gen';
import type { ConsumeCustomerPackageRequest } from './consumeCustomerPackageRequest.gen';
import type { RecreditCustomerPackageRequest } from './recreditCustomerPackageRequest.gen';
import type { DeleteCustomerPackageRequest } from './deleteCustomerPackageRequest.gen';
import type { UpdateCustomerPackageRequest } from './updateCustomerPackageRequest.gen';
import { hydrateEmailSettings, type EmailSettings, type EmailSettingsApiResponse } from './emailSettings.gen';
import type { SaveEmailSettingsRequest } from './saveEmailSettingsRequest.gen';
import type { BusinessEmailSearchRequest } from './businessEmailSearchRequest.gen';
import { hydrateBusinessLoadAll, type BusinessLoadAll, type BusinessLoadAllApiResponse } from './businessLoadAll.gen';
import { hydrateWidgetMemberArea, type WidgetMemberArea, type WidgetMemberAreaApiResponse } from './widgetMemberArea.gen';
import type { SaveMemberAreaSettingsRequest } from './saveMemberAreaSettingsRequest.gen';
import { hydrateMemo, type Memo, type MemoApiResponse } from './memo.gen';
import type { SaveMemoRequest } from './saveMemoRequest.gen';
import { hydrateOfferCollectionList, type OfferCollectionList, type OfferCollectionListApiResponse } from './offerCollectionList.gen';
import type { SaveOfferCollectionRequest } from './saveOfferCollectionRequest.gen';
import { hydrateOfferCollection, type OfferCollection, type OfferCollectionApiResponse } from './offerCollection.gen';
import type { SaveOfferCollectionOrderRequest } from './saveOfferCollectionOrderRequest.gen';
import type { SaveOfferRequest } from './saveOfferRequest.gen';
import { hydrateOffer, type Offer, type OfferApiResponse } from './offer.gen';
import type { SaveOfferPricesRequest } from './saveOfferPricesRequest.gen';
import { hydrateOfferList, type OfferList, type OfferListApiResponse } from './offerList.gen';
import type { SaveOfferOrderRequest } from './saveOfferOrderRequest.gen';
import type { SaveOffersReconfirmTimeRequest } from './saveOffersReconfirmTimeRequest.gen';
import { hydrateOpeningHourList, type OpeningHourList, type OpeningHourListApiResponse } from './openingHourList.gen';
import type { SaveOpeningHourRequest } from './saveOpeningHourRequest.gen';
import { hydrateOpeningHour, type OpeningHour, type OpeningHourApiResponse } from './openingHour.gen';
import type { OpeningHourExceptionSearchRequest } from './openingHourExceptionSearchRequest.gen';
import { hydrateOpeningHourExceptionSearch, type OpeningHourExceptionSearch, type OpeningHourExceptionSearchApiResponse } from './openingHourExceptionSearch.gen';
import type { SaveOpeningHourExceptionRequest } from './saveOpeningHourExceptionRequest.gen';
import type { DeleteRangeOpeningHourExceptionRequest } from './deleteRangeOpeningHourExceptionRequest.gen';
import { hydratePackageList, type PackageList, type PackageListApiResponse } from './packageList.gen';
import type { SavePackageRequest } from './savePackageRequest.gen';
import { hydratePackage, type Package, type PackageApiResponse } from './package.gen';
import type { SaveProductRequest } from './saveProductRequest.gen';
import { hydrateProduct, type Product, type ProductApiResponse } from './product.gen';
import type { BulkGeneratePromoCodeRequest } from './bulkGeneratePromoCodeRequest.gen';
import { hydratePromoCodeBulkGenerate, type PromoCodeBulkGenerate, type PromoCodeBulkGenerateApiResponse } from './promoCodeBulkGenerate.gen';
import type { SavePromoCodeRequest } from './savePromoCodeRequest.gen';
import { hydratePromoCode, type PromoCode, type PromoCodeApiResponse } from './promoCode.gen';
import type { BulkDeletePromoCodeRequest } from './bulkDeletePromoCodeRequest.gen';
import type { BulkTogglePromoCodeRequest } from './bulkTogglePromoCodeRequest.gen';
import { hydratePromoCodeList, type PromoCodeList, type PromoCodeListApiResponse } from './promoCodeList.gen';
import type { SaveSessionRequest } from './saveSessionRequest.gen';
import { hydrateSession, type Session, type SessionApiResponse } from './session.gen';
import { hydrateSessionList, type SessionList, type SessionListApiResponse } from './sessionList.gen';
import { hydrateSmsSettings, type SmsSettings, type SmsSettingsApiResponse } from './smsSettings.gen';
import type { SaveSmsSettingsRequest } from './saveSmsSettingsRequest.gen';
import type { ManualRefillSmsRequest } from './manualRefillSmsRequest.gen';
import { hydrateSmsManualRefill, type SmsManualRefill, type SmsManualRefillApiResponse } from './smsManualRefill.gen';
import type { AdminRefillSmsRequest } from './adminRefillSmsRequest.gen';
import { hydrateSmsRefillList, type SmsRefillList, type SmsRefillListApiResponse } from './smsRefillList.gen';
import { hydrateSmsCancelRefill, type SmsCancelRefill, type SmsCancelRefillApiResponse } from './smsCancelRefill.gen';
import type { BusinessSmsSearchRequest } from './businessSmsSearchRequest.gen';
import type { UpdateWidgetRequest } from './updateWidgetRequest.gen';
import { hydrateWidget, type Widget, type WidgetApiResponse } from './widget.gen';
import type { DashboardStatsRequest } from './dashboardStatsRequest.gen';
import { hydrateDashboardStats, type DashboardStats, type DashboardStatsApiResponse } from './dashboardStats.gen';
import type { DashboardStatsExportBookingsRequest } from './dashboardStatsExportBookingsRequest.gen';
import { hydrateDashboardStatsExportBookings, type DashboardStatsExportBookings, type DashboardStatsExportBookingsApiResponse } from './dashboardStatsExportBookings.gen';
import type { ShareFeedbackRequest } from './shareFeedbackRequest.gen';
import { hydrateFeedback, type Feedback, type FeedbackApiResponse } from './feedback.gen';
import type { SaveBookableGiftcardRequest } from './saveBookableGiftcardRequest.gen';
import { hydrateBookableGiftcard, type BookableGiftcard, type BookableGiftcardApiResponse } from './bookableGiftcard.gen';
import { hydrateGiftcardBookableList, type GiftcardBookableList, type GiftcardBookableListApiResponse } from './giftcardBookableList.gen';
import type { CreateGiftcardRequest } from './createGiftcardRequest.gen';
import type { GiftcardSearchRequest } from './giftcardSearchRequest.gen';
import { hydrateGiftcardSearch, type GiftcardSearch, type GiftcardSearchApiResponse } from './giftcardSearch.gen';
import type { ConsumeGiftcardRequest } from './consumeGiftcardRequest.gen';
import { hydratePayment, type Payment, type PaymentApiResponse } from './payment.gen';
import type { RecreditGiftcardRequest } from './recreditGiftcardRequest.gen';
import type { DeleteGiftcardRequest } from './deleteGiftcardRequest.gen';
import { hydrateGiftcardStats, type GiftcardStats, type GiftcardStatsApiResponse } from './giftcardStats.gen';
import type { UpdateGiftcardRequest } from './updateGiftcardRequest.gen';
import { hydrateGiftcard, type Giftcard, type GiftcardApiResponse } from './giftcard.gen';
import { hydrateGoogleCalendarList, type GoogleCalendarList, type GoogleCalendarListApiResponse } from './googleCalendarList.gen';
import type { WatchGoogleCalendarRequest } from './watchGoogleCalendarRequest.gen';
import { hydrateGoogleCalendar, type GoogleCalendar, type GoogleCalendarApiResponse } from './googleCalendar.gen';
import { hydrateGoogleCalendarToken, type GoogleCalendarToken, type GoogleCalendarTokenApiResponse } from './googleCalendarToken.gen';
import type { SendGoogleBookingsRequest } from './sendGoogleBookingsRequest.gen';
import type { SendFutureGoogleBookingsRequest } from './sendFutureGoogleBookingsRequest.gen';
import { hydrateGoogleCalendarSendFutureBookings, type GoogleCalendarSendFutureBookings, type GoogleCalendarSendFutureBookingsApiResponse } from './googleCalendarSendFutureBookings.gen';
import type { ToggleGoogleReserveRequest } from './toggleGoogleReserveRequest.gen';
import { hydrateWidgetGoogleReserve, type WidgetGoogleReserve, type WidgetGoogleReserveApiResponse } from './widgetGoogleReserve.gen';
import type { UpdateGoogleReserveAddressRequest } from './updateGoogleReserveAddressRequest.gen';
import { hydrateAdminGoogleFeedGenerate, type AdminGoogleFeedGenerate, type AdminGoogleFeedGenerateApiResponse } from './adminGoogleFeedGenerate.gen';
import { hydrateAdminGoogleReserveDisable, type AdminGoogleReserveDisable, type AdminGoogleReserveDisableApiResponse } from './adminGoogleReserveDisable.gen';
import type { NotificationSearchRequest } from './notificationSearchRequest.gen';
import { hydrateNotificationSearch, type NotificationSearch, type NotificationSearchApiResponse } from './notificationSearch.gen';
import type { MarkNotificationReadRequest } from './markNotificationReadRequest.gen';
import type { MarkNotificationUnreadRequest } from './markNotificationUnreadRequest.gen';
import { hydrateNotificationStats, type NotificationStats, type NotificationStatsApiResponse } from './notificationStats.gen';
import type { PostDeviceTokenRequest } from './postDeviceTokenRequest.gen';
import type { DeleteDeviceTokensRequest } from './deleteDeviceTokensRequest.gen';
import type { PushTestRequest } from './pushTestRequest.gen';
import { hydratePushNotificationTest, type PushNotificationTest, type PushNotificationTestApiResponse } from './pushNotificationTest.gen';
import { hydrateSocketToken, type SocketToken, type SocketTokenApiResponse } from './socketToken.gen';
import { hydrateStripeConnectSession, type StripeConnectSession, type StripeConnectSessionApiResponse } from './stripeConnectSession.gen';
import { hydrateStripeConnectStatus, type StripeConnectStatus, type StripeConnectStatusApiResponse } from './stripeConnectStatus.gen';
import { hydratePublicQrCode, type PublicQrCode, type PublicQrCodeApiResponse } from './publicQrCode.gen';
import type { ScanQrCodeRequest } from './scanQrCodeRequest.gen';
import { hydrateQrCodeScan, type QrCodeScan, type QrCodeScanApiResponse } from './qrCodeScan.gen';
import { hydratePublicToken, type PublicToken, type PublicTokenApiResponse } from './publicToken.gen';
import type { ShareReferralRequest } from './shareReferralRequest.gen';
import { hydrateReferral, type Referral, type ReferralApiResponse } from './referral.gen';
import type { CreateBusinessRequest } from './createBusinessRequest.gen';
import type { CheckEmailExistRequest } from './checkEmailExistRequest.gen';
import { hydrateRegistrationLogoList, type RegistrationLogoList, type RegistrationLogoListApiResponse } from './registrationLogoList.gen';
import { hydratePublicReservationList, type PublicReservationList, type PublicReservationListApiResponse } from './publicReservationList.gen';
import type { SaveAgendaSettingsRequest } from './saveAgendaSettingsRequest.gen';
import { hydrateAgendaSetting, type AgendaSetting, type AgendaSettingApiResponse } from './agendaSetting.gen';
import type { FlipFeaturesRequest } from './flipFeaturesRequest.gen';
import { hydrateFeatureFlipping, type FeatureFlipping, type FeatureFlippingApiResponse } from './featureFlipping.gen';
import type { FeatureVoteRequest } from './featureVoteRequest.gen';
import { hydrateFeatureVote, type FeatureVote, type FeatureVoteApiResponse } from './featureVote.gen';
import type { FeatureAnalyticClickRequest } from './featureAnalyticClickRequest.gen';
import { hydrateFeatureAnalyticClick, type FeatureAnalyticClick, type FeatureAnalyticClickApiResponse } from './featureAnalyticClick.gen';
import type { SaveTagRequest } from './saveTagRequest.gen';
import { hydrateTag, type Tag, type TagApiResponse } from './tag.gen';
import type { AcceptTermsRequest } from './acceptTermsRequest.gen';
import type { UploadFileRequest } from './uploadFileRequest.gen';
import { hydrateUploadAsset, type UploadAsset, type UploadAssetApiResponse } from './uploadAsset.gen';
import { hydrateUploadDocument, type UploadDocument, type UploadDocumentApiResponse } from './uploadDocument.gen';
import { hydrateUploadEditorJs, type UploadEditorJs, type UploadEditorJsApiResponse } from './uploadEditorJs.gen';
import { hydrateUploadPublicToken, type UploadPublicToken, type UploadPublicTokenApiResponse } from './uploadPublicToken.gen';
import { hydrateUploadMediaList, type UploadMediaList, type UploadMediaListApiResponse } from './uploadMediaList.gen';
import type { PublicLeadDemoRequest } from './publicLeadDemoRequest.gen';
import type { PublicLeadPricingRequest } from './publicLeadPricingRequest.gen';
import type { JwsLoginRequest } from './jwsLoginRequest.gen';
import { hydrateWidgetMember, type WidgetMember, type WidgetMemberApiResponse } from './widgetMember.gen';
import type { MagicLinkRequestCodeRequest } from './magicLinkRequestCodeRequest.gen';
import type { MagicLinkLoginRequest } from './magicLinkLoginRequest.gen';
import type { OktaLoginRequest } from './oktaLoginRequest.gen';
import type { GetAvailabilityRequest } from './getAvailabilityRequest.gen';
import { hydrateWidgetAvailability, type WidgetAvailability, type WidgetAvailabilityApiResponse } from './widgetAvailability.gen';
import type { WidgetBookRequest } from './widgetBookRequest.gen';
import { hydrateWidgetBook, type WidgetBook, type WidgetBookApiResponse } from './widgetBook.gen';
import { hydrateWidgetBooking, type WidgetBooking, type WidgetBookingApiResponse } from './widgetBooking.gen';
import type { WidgetBookingStatusRequest } from './widgetBookingStatusRequest.gen';
import { hydrateWidgetBookingStatus, type WidgetBookingStatus, type WidgetBookingStatusApiResponse } from './widgetBookingStatus.gen';
import { hydrateWidgetBookingSummary, type WidgetBookingSummary, type WidgetBookingSummaryApiResponse } from './widgetBookingSummary.gen';
import type { SearchGiftcardRequest } from './searchGiftcardRequest.gen';
import { hydrateWidgetBookingGiftcardSearch, type WidgetBookingGiftcardSearch, type WidgetBookingGiftcardSearchApiResponse } from './widgetBookingGiftcardSearch.gen';
import { hydrateWidgetGuaranteePaymentSetup, type WidgetGuaranteePaymentSetup, type WidgetGuaranteePaymentSetupApiResponse } from './widgetGuaranteePaymentSetup.gen';
import { hydrateWidgetMyBooking, type WidgetMyBooking, type WidgetMyBookingApiResponse } from './widgetMyBooking.gen';
import { hydrateWidgetBookingActionStatus, type WidgetBookingActionStatus, type WidgetBookingActionStatusApiResponse } from './widgetBookingActionStatus.gen';
import { hydrateWidgetPaymentSetup, type WidgetPaymentSetup, type WidgetPaymentSetupApiResponse } from './widgetPaymentSetup.gen';
import { hydrateWidgetPaymentSplitDetails, type WidgetPaymentSplitDetails, type WidgetPaymentSplitDetailsApiResponse } from './widgetPaymentSplitDetails.gen';
import type { SetupPaymentSplitRequest } from './setupPaymentSplitRequest.gen';
import type { ApplyPromoCodeRequest } from './applyPromoCodeRequest.gen';
import { hydrateWidgetPromoCodeApplyPackage, type WidgetPromoCodeApplyPackage, type WidgetPromoCodeApplyPackageApiResponse } from './widgetPromoCodeApplyPackage.gen';
import { hydrateWidgetPromoCodeRemovePackage, type WidgetPromoCodeRemovePackage, type WidgetPromoCodeRemovePackageApiResponse } from './widgetPromoCodeRemovePackage.gen';
import { hydrateWidgetPromoCodeApplyGiftcard, type WidgetPromoCodeApplyGiftcard, type WidgetPromoCodeApplyGiftcardApiResponse } from './widgetPromoCodeApplyGiftcard.gen';
import { hydrateWidgetPromoCodeApplyBooking, type WidgetPromoCodeApplyBooking, type WidgetPromoCodeApplyBookingApiResponse } from './widgetPromoCodeApplyBooking.gen';
import { hydrateBookingRemovePromoCode, type BookingRemovePromoCode, type BookingRemovePromoCodeApiResponse } from './bookingRemovePromoCode.gen';
import { hydrateWidgetSurvey, type WidgetSurvey, type WidgetSurveyApiResponse } from './widgetSurvey.gen';
import type { PostSurveyRatingRequest } from './postSurveyRatingRequest.gen';
import { hydrateWidgetContent, type WidgetContent, type WidgetContentApiResponse } from './widgetContent.gen';
import type { WidgetPriceRequest } from './widgetPriceRequest.gen';
import { hydrateWidgetPriceList, type WidgetPriceList, type WidgetPriceListApiResponse } from './widgetPriceList.gen';
import type { BuyGiftcardRequest } from './buyGiftcardRequest.gen';
import { hydrateWidgetGiftcardOrder, type WidgetGiftcardOrder, type WidgetGiftcardOrderApiResponse } from './widgetGiftcardOrder.gen';
import { hydrateGiftcardPublic, type GiftcardPublic, type GiftcardPublicApiResponse } from './giftcardPublic.gen';
import type { AcceptGiftcardOrderTermsRequest } from './acceptGiftcardOrderTermsRequest.gen';
import { hydrateWidgetCustomerPackageDetails, type WidgetCustomerPackageDetails, type WidgetCustomerPackageDetailsApiResponse } from './widgetCustomerPackageDetails.gen';
import type { CheckPromoCodeRequest } from './checkPromoCodeRequest.gen';
import { hydrateWidgetPackageCheckPromoCode, type WidgetPackageCheckPromoCode, type WidgetPackageCheckPromoCodeApiResponse } from './widgetPackageCheckPromoCode.gen';
import type { OrderPackageRequest } from './orderPackageRequest.gen';
import { hydrateWidgetPackageOrder, type WidgetPackageOrder, type WidgetPackageOrderApiResponse } from './widgetPackageOrder.gen';
import { hydrateWidgetPackageGetOrder, type WidgetPackageGetOrder, type WidgetPackageGetOrderApiResponse } from './widgetPackageGetOrder.gen';
import type { UpdateWidgetMemberRequest } from './updateWidgetMemberRequest.gen';
import { hydrateWidgetMemberProfile, type WidgetMemberProfile, type WidgetMemberProfileApiResponse } from './widgetMemberProfile.gen';
import type { UpsertBookingRequest } from './upsertBookingRequest.gen';
import type { UpdateBookingStatusRequest } from './updateBookingStatusRequest.gen';
import type { BookingSearchRequest } from './bookingSearchRequest.gen';
import { hydrateBookingSearch, type BookingSearch, type BookingSearchApiResponse } from './bookingSearch.gen';
import type { GetBookingAggregateRequest } from './getBookingAggregateRequest.gen';
import { hydrateBookingAggregate, type BookingAggregate, type BookingAggregateApiResponse } from './bookingAggregate.gen';
import { hydrateBookingApplyPromoCode, type BookingApplyPromoCode, type BookingApplyPromoCodeApiResponse } from './bookingApplyPromoCode.gen';
import type { AskGuaranteeRequest } from './askGuaranteeRequest.gen';
import type { CaptureGuaranteeRequest } from './captureGuaranteeRequest.gen';
import type { PayGuaranteeRequest } from './payGuaranteeRequest.gen';
import type { PayBookingPaymentRequest } from './payBookingPaymentRequest.gen';
import type { RefundBookingPaymentRequest } from './refundBookingPaymentRequest.gen';
import { hydratePaymentRefundList, type PaymentRefundList, type PaymentRefundListApiResponse } from './paymentRefundList.gen';

/**
 * POST /action-tracking/search
 */
export async function apiAppActiontrackingGetactions(body: ActionTrackingSearchRequest, config: ApiConfig & { raw: true }): Promise<ActionTrackingSearchApiResponse>;
export async function apiAppActiontrackingGetactions(body: ActionTrackingSearchRequest, config?: ApiConfig): Promise<ActionTrackingSearch>;
export async function apiAppActiontrackingGetactions(body: ActionTrackingSearchRequest, config?: ApiConfig): Promise<ActionTrackingSearch | ActionTrackingSearchApiResponse> {
	const res = await getApi().post<ActionTrackingSearchApiResponse>(`/action-tracking/search`, body, config);
	return config?.raw ? res.data : hydrateActionTrackingSearch(res.data);
}

/**
 * GET /public/.well-known/jwks.json
 */
export async function apiPublicJwks(config: ApiConfig & { raw: true }): Promise<PublicJwksApiResponse>;
export async function apiPublicJwks(config?: ApiConfig): Promise<PublicJwks>;
export async function apiPublicJwks(config?: ApiConfig): Promise<PublicJwks | PublicJwksApiResponse> {
	const res = await getApi().get<PublicJwksApiResponse>(`/public/.well-known/jwks.json`, config);
	return config?.raw ? res.data : hydratePublicJwks(res.data);
}

/**
 * POST /admin/jws/token
 */
export async function apiAdminJwsToken(body: AdminGenerateJwsTokenRequest, config: ApiConfig & { raw: true }): Promise<AdminGenerateJwsTokenApiResponse>;
export async function apiAdminJwsToken(body: AdminGenerateJwsTokenRequest, config?: ApiConfig): Promise<AdminGenerateJwsToken>;
export async function apiAdminJwsToken(body: AdminGenerateJwsTokenRequest, config?: ApiConfig): Promise<AdminGenerateJwsToken | AdminGenerateJwsTokenApiResponse> {
	const res = await getApi().post<AdminGenerateJwsTokenApiResponse>(`/admin/jws/token`, body, config);
	return config?.raw ? res.data : hydrateAdminGenerateJwsToken(res.data);
}

/**
 * POST /admin/jws/rotate
 */
export async function apiAdminJwsRotate(config: ApiConfig & { raw: true }): Promise<AdminRotateJwsApiResponse>;
export async function apiAdminJwsRotate(config?: ApiConfig): Promise<AdminRotateJws>;
export async function apiAdminJwsRotate(config?: ApiConfig): Promise<AdminRotateJws | AdminRotateJwsApiResponse> {
	const res = await getApi().post<AdminRotateJwsApiResponse>(`/admin/jws/rotate`, config);
	return config?.raw ? res.data : hydrateAdminRotateJws(res.data);
}

/**
 * POST /admin/bookings/search
 */
export async function apiAdminBookingsSearch(body: AdminBookingSearchRequest, config: ApiConfig & { raw: true }): Promise<AdminBookingSearchApiResponse>;
export async function apiAdminBookingsSearch(body: AdminBookingSearchRequest, config?: ApiConfig): Promise<AdminBookingSearch>;
export async function apiAdminBookingsSearch(body: AdminBookingSearchRequest, config?: ApiConfig): Promise<AdminBookingSearch | AdminBookingSearchApiResponse> {
	const res = await getApi().post<AdminBookingSearchApiResponse>(`/admin/bookings/search`, body, config);
	return config?.raw ? res.data : hydrateAdminBookingSearch(res.data);
}

/**
 * POST /admin/payments/b2c/search
 */
export async function apiAdminPaymentsB2cSearch(body: AdminB2cPaymentSearchRequest, config: ApiConfig & { raw: true }): Promise<AdminB2cPaymentSearchApiResponse>;
export async function apiAdminPaymentsB2cSearch(body: AdminB2cPaymentSearchRequest, config?: ApiConfig): Promise<AdminB2cPaymentSearch>;
export async function apiAdminPaymentsB2cSearch(body: AdminB2cPaymentSearchRequest, config?: ApiConfig): Promise<AdminB2cPaymentSearch | AdminB2cPaymentSearchApiResponse> {
	const res = await getApi().post<AdminB2cPaymentSearchApiResponse>(`/admin/payments/b2c/search`, body, config);
	return config?.raw ? res.data : hydrateAdminB2cPaymentSearch(res.data);
}

/**
 * POST /admin/payments/b2b/search
 */
export async function apiAdminPaymentsB2bSearch(body: AdminB2bPaymentSearchRequest, config: ApiConfig & { raw: true }): Promise<AdminB2bPaymentSearchApiResponse>;
export async function apiAdminPaymentsB2bSearch(body: AdminB2bPaymentSearchRequest, config?: ApiConfig): Promise<AdminB2bPaymentSearch>;
export async function apiAdminPaymentsB2bSearch(body: AdminB2bPaymentSearchRequest, config?: ApiConfig): Promise<AdminB2bPaymentSearch | AdminB2bPaymentSearchApiResponse> {
	const res = await getApi().post<AdminB2bPaymentSearchApiResponse>(`/admin/payments/b2b/search`, body, config);
	return config?.raw ? res.data : hydrateAdminB2bPaymentSearch(res.data);
}

/**
 * POST /admin/payments/guarantees/search
 */
export async function apiAdminPaymentsGuaranteesSearch(body: AdminGuaranteeSearchRequest, config: ApiConfig & { raw: true }): Promise<AdminGuaranteeSearchApiResponse>;
export async function apiAdminPaymentsGuaranteesSearch(body: AdminGuaranteeSearchRequest, config?: ApiConfig): Promise<AdminGuaranteeSearch>;
export async function apiAdminPaymentsGuaranteesSearch(body: AdminGuaranteeSearchRequest, config?: ApiConfig): Promise<AdminGuaranteeSearch | AdminGuaranteeSearchApiResponse> {
	const res = await getApi().post<AdminGuaranteeSearchApiResponse>(`/admin/payments/guarantees/search`, body, config);
	return config?.raw ? res.data : hydrateAdminGuaranteeSearch(res.data);
}

/**
 * POST /admin/leads/search
 */
export async function apiAdminLeadsSearch(body: AdminLeadSearchRequest, config: ApiConfig & { raw: true }): Promise<AdminLeadSearchApiResponse>;
export async function apiAdminLeadsSearch(body: AdminLeadSearchRequest, config?: ApiConfig): Promise<AdminLeadSearch>;
export async function apiAdminLeadsSearch(body: AdminLeadSearchRequest, config?: ApiConfig): Promise<AdminLeadSearch | AdminLeadSearchApiResponse> {
	const res = await getApi().post<AdminLeadSearchApiResponse>(`/admin/leads/search`, body, config);
	return config?.raw ? res.data : hydrateAdminLeadSearch(res.data);
}

/**
 * GET /admin/billing/{businessId}/business-settings
 */
export async function apiAppAdminBillingGetsettings(businessId: string, config: ApiConfig & { raw: true }): Promise<BillingSettingsApiResponse>;
export async function apiAppAdminBillingGetsettings(businessId: string, config?: ApiConfig): Promise<BillingSettings>;
export async function apiAppAdminBillingGetsettings(businessId: string, config?: ApiConfig): Promise<BillingSettings | BillingSettingsApiResponse> {
	const res = await getApi().get<BillingSettingsApiResponse>(`/admin/billing/${businessId}/business-settings`, config);
	return config?.raw ? res.data : hydrateBillingSettings(res.data);
}

/**
 * POST /admin/billing/{businessId}/business-settings
 */
export async function apiAppAdminBillingUpdatesettings(businessId: string, body: AdminUpdateBillingSettingsRequest, config: ApiConfig & { raw: true }): Promise<BillingSettingsApiResponse>;
export async function apiAppAdminBillingUpdatesettings(businessId: string, body: AdminUpdateBillingSettingsRequest, config?: ApiConfig): Promise<BillingSettings>;
export async function apiAppAdminBillingUpdatesettings(businessId: string, body: AdminUpdateBillingSettingsRequest, config?: ApiConfig): Promise<BillingSettings | BillingSettingsApiResponse> {
	const res = await getApi().post<BillingSettingsApiResponse>(`/admin/billing/${businessId}/business-settings`, body, config);
	return config?.raw ? res.data : hydrateBillingSettings(res.data);
}

/**
 * POST /admin/billing/invoices/{id}/cancel
 */
export async function apiAppAdminBillingCancelinvoice(id: number, config?: ApiConfig): Promise<void> {
	await getApi().post(`/admin/billing/invoices/${id}/cancel`, config);
}

/**
 * POST /admin/billing/invoices/{id}/mark-paid
 */
export async function apiAppAdminBillingMarkpaid(id: number, config?: ApiConfig): Promise<void> {
	await getApi().post(`/admin/billing/invoices/${id}/mark-paid`, config);
}

/**
 * POST /admin/billing/invoices/{id}/mark-unpaid
 */
export async function apiAppAdminBillingMarkunpaid(id: number, config?: ApiConfig): Promise<void> {
	await getApi().post(`/admin/billing/invoices/${id}/mark-unpaid`, config);
}

/**
 * PUT /admin/billing/{id}/start-monthly-fee-invoices
 */
export async function apiAppAdminBillingGenerateforbusiness(id: string, config?: ApiConfig): Promise<void> {
	await getApi().put(`/admin/billing/${id}/start-monthly-fee-invoices`, config);
}

/**
 * GET /admin/billing/generate-des
 */
export async function apiAppAdminBillingDownloaddes(config?: ApiConfig): Promise<string> {
	const res = await getApi().get<string>(`/admin/billing/generate-des`, config);
	return res.data;
}

/**
 * POST /admin/billing/vouchers
 */
export async function apiAppAdminBillingvoucherSavevoucher(body: AdminSaveVoucherRequest, config: ApiConfig & { raw: true }): Promise<BillingVoucherApiResponse>;
export async function apiAppAdminBillingvoucherSavevoucher(body: AdminSaveVoucherRequest, config?: ApiConfig): Promise<BillingVoucher>;
export async function apiAppAdminBillingvoucherSavevoucher(body: AdminSaveVoucherRequest, config?: ApiConfig): Promise<BillingVoucher | BillingVoucherApiResponse> {
	const res = await getApi().post<BillingVoucherApiResponse>(`/admin/billing/vouchers`, body, config);
	return config?.raw ? res.data : hydrateBillingVoucher(res.data);
}

/**
 * POST /admin/billing/vouchers/search
 */
export async function apiAppAdminBillingvoucherSearchvouchers(body: AdminBillingVoucherSearchRequest, config: ApiConfig & { raw: true }): Promise<AdminBillingVoucherSearchApiResponse>;
export async function apiAppAdminBillingvoucherSearchvouchers(body: AdminBillingVoucherSearchRequest, config?: ApiConfig): Promise<AdminBillingVoucherSearch>;
export async function apiAppAdminBillingvoucherSearchvouchers(body: AdminBillingVoucherSearchRequest, config?: ApiConfig): Promise<AdminBillingVoucherSearch | AdminBillingVoucherSearchApiResponse> {
	const res = await getApi().post<AdminBillingVoucherSearchApiResponse>(`/admin/billing/vouchers/search`, body, config);
	return config?.raw ? res.data : hydrateAdminBillingVoucherSearch(res.data);
}

/**
 * POST /admin/business/search
 */
export async function apiAdminBusinesses(body: AdminBusinessSearchRequest, config: ApiConfig & { raw: true }): Promise<AdminBusinessSearchApiResponse>;
export async function apiAdminBusinesses(body: AdminBusinessSearchRequest, config?: ApiConfig): Promise<AdminBusinessSearch>;
export async function apiAdminBusinesses(body: AdminBusinessSearchRequest, config?: ApiConfig): Promise<AdminBusinessSearch | AdminBusinessSearchApiResponse> {
	const res = await getApi().post<AdminBusinessSearchApiResponse>(`/admin/business/search`, body, config);
	return config?.raw ? res.data : hydrateAdminBusinessSearch(res.data);
}

/**
 * POST /admin/business/{id}
 */
export async function apiAppAdminBusinessUpdatebusiness(id: string, body: AdminUpdateBusinessRequest, config: ApiConfig & { raw: true }): Promise<BusinessAdminApiResponse>;
export async function apiAppAdminBusinessUpdatebusiness(id: string, body: AdminUpdateBusinessRequest, config?: ApiConfig): Promise<BusinessAdmin>;
export async function apiAppAdminBusinessUpdatebusiness(id: string, body: AdminUpdateBusinessRequest, config?: ApiConfig): Promise<BusinessAdmin | BusinessAdminApiResponse> {
	const res = await getApi().post<BusinessAdminApiResponse>(`/admin/business/${id}`, body, config);
	return config?.raw ? res.data : hydrateBusinessAdmin(res.data);
}

/**
 * DELETE /admin/business/{businessId}/stripe-connect
 */
export async function apiAppAdminBusinessDelete(businessId: string, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/admin/business/${businessId}/stripe-connect`, config);
}

/**
 * GET /admin/business/stats
 */
export async function apiAppAdminBusinessGetstats(config: ApiConfig & { raw: true }): Promise<AdminBusinessStatsApiResponse>;
export async function apiAppAdminBusinessGetstats(config?: ApiConfig): Promise<AdminBusinessStats>;
export async function apiAppAdminBusinessGetstats(config?: ApiConfig): Promise<AdminBusinessStats | AdminBusinessStatsApiResponse> {
	const res = await getApi().get<AdminBusinessStatsApiResponse>(`/admin/business/stats`, config);
	return config?.raw ? res.data : hydrateAdminBusinessStats(res.data);
}

/**
 * POST /admin/email-sent/search
 */
export async function apiAdminEmails(body: AdminEmailSearchRequest, config: ApiConfig & { raw: true }): Promise<EmailSentSearchApiResponse>;
export async function apiAdminEmails(body: AdminEmailSearchRequest, config?: ApiConfig): Promise<EmailSentSearch>;
export async function apiAdminEmails(body: AdminEmailSearchRequest, config?: ApiConfig): Promise<EmailSentSearch | EmailSentSearchApiResponse> {
	const res = await getApi().post<EmailSentSearchApiResponse>(`/admin/email-sent/search`, body, config);
	return config?.raw ? res.data : hydrateEmailSentSearch(res.data);
}

/**
 * POST /admin/email
 */
export async function apiTestEmail(body: AdminTestEmailRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/admin/email`, body, config);
}

/**
 * POST /admin/events/search
 */
export async function apiAppAdminEventSearchevents(body: AdminEventSearchRequest, config: ApiConfig & { raw: true }): Promise<AdminEventSearchApiResponse>;
export async function apiAppAdminEventSearchevents(body: AdminEventSearchRequest, config?: ApiConfig): Promise<AdminEventSearch>;
export async function apiAppAdminEventSearchevents(body: AdminEventSearchRequest, config?: ApiConfig): Promise<AdminEventSearch | AdminEventSearchApiResponse> {
	const res = await getApi().post<AdminEventSearchApiResponse>(`/admin/events/search`, body, config);
	return config?.raw ? res.data : hydrateAdminEventSearch(res.data);
}

/**
 * POST /admin/events/{id}
 */
export async function apiAppAdminEventRetry(id: number, config?: ApiConfig): Promise<void> {
	await getApi().post(`/admin/events/${id}`, config);
}

/**
 * DELETE /admin/events/{id}
 */
export async function apiAppAdminEventMarkconsumed(id: number, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/admin/events/${id}`, config);
}

/**
 * GET /admin/events/consumers
 */
export async function apiAppAdminEventGetconsumers(config: ApiConfig & { raw: true }): Promise<AdminEventConsumersApiResponse>;
export async function apiAppAdminEventGetconsumers(config?: ApiConfig): Promise<AdminEventConsumers>;
export async function apiAppAdminEventGetconsumers(config?: ApiConfig): Promise<AdminEventConsumers | AdminEventConsumersApiResponse> {
	const res = await getApi().get<AdminEventConsumersApiResponse>(`/admin/events/consumers`, config);
	return config?.raw ? res.data : hydrateAdminEventConsumers(res.data);
}

/**
 * PUT /admin/events/mark-all-as-consumed
 */
export async function apiAppAdminEventMarkallasconsumed(body: AdminMarkAllEventsConsumedRequest, config?: ApiConfig): Promise<void> {
	await getApi().put(`/admin/events/mark-all-as-consumed`, body, config);
}

/**
 * POST /admin/push-test
 */
export async function apiAppAdminPushPushtest(body: AdminPushTestRequest, config: ApiConfig & { raw: true }): Promise<AdminPushTestApiResponse>;
export async function apiAppAdminPushPushtest(body: AdminPushTestRequest, config?: ApiConfig): Promise<AdminPushTest>;
export async function apiAppAdminPushPushtest(body: AdminPushTestRequest, config?: ApiConfig): Promise<AdminPushTest | AdminPushTestApiResponse> {
	const res = await getApi().post<AdminPushTestApiResponse>(`/admin/push-test`, body, config);
	return config?.raw ? res.data : hydrateAdminPushTest(res.data);
}

/**
 * POST /admin/release-notes
 */
export async function apiAppAdminReleasenoteSave(body: AdminSaveReleaseNoteRequest, config: ApiConfig & { raw: true }): Promise<ReleaseNoteApiResponse>;
export async function apiAppAdminReleasenoteSave(body: AdminSaveReleaseNoteRequest, config?: ApiConfig): Promise<ReleaseNote>;
export async function apiAppAdminReleasenoteSave(body: AdminSaveReleaseNoteRequest, config?: ApiConfig): Promise<ReleaseNote | ReleaseNoteApiResponse> {
	const res = await getApi().post<ReleaseNoteApiResponse>(`/admin/release-notes`, body, config);
	return config?.raw ? res.data : hydrateReleaseNote(res.data);
}

/**
 * GET /admin/release-notes/{id}/reactions
 */
export async function apiAppAdminReleasenoteGetreactions(id: number, config: ApiConfig & { raw: true }): Promise<AdminReleaseNoteReactionsApiResponse>;
export async function apiAppAdminReleasenoteGetreactions(id: number, config?: ApiConfig): Promise<AdminReleaseNoteReactions>;
export async function apiAppAdminReleasenoteGetreactions(id: number, config?: ApiConfig): Promise<AdminReleaseNoteReactions | AdminReleaseNoteReactionsApiResponse> {
	const res = await getApi().get<AdminReleaseNoteReactionsApiResponse>(`/admin/release-notes/${id}/reactions`, config);
	return config?.raw ? res.data : hydrateAdminReleaseNoteReactions(res.data);
}

/**
 * POST /admin/sms-sent/search
 */
export async function apiAdminSms(body: AdminSmsSearchRequest, config: ApiConfig & { raw: true }): Promise<SmsSentSearchApiResponse>;
export async function apiAdminSms(body: AdminSmsSearchRequest, config?: ApiConfig): Promise<SmsSentSearch>;
export async function apiAdminSms(body: AdminSmsSearchRequest, config?: ApiConfig): Promise<SmsSentSearch | SmsSentSearchApiResponse> {
	const res = await getApi().post<SmsSentSearchApiResponse>(`/admin/sms-sent/search`, body, config);
	return config?.raw ? res.data : hydrateSmsSentSearch(res.data);
}

/**
 * POST /admin/socket-test
 */
export async function apiAppAdminSocketSocket(body: AdminSocketTestRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/admin/socket-test`, body, config);
}

/**
 * GET /admin/system
 */
export async function apiAppAdminSystemSystem(config: ApiConfig & { raw: true }): Promise<AdminSystemCommandApiResponse>;
export async function apiAppAdminSystemSystem(config?: ApiConfig): Promise<AdminSystemCommand>;
export async function apiAppAdminSystemSystem(config?: ApiConfig): Promise<AdminSystemCommand | AdminSystemCommandApiResponse> {
	const res = await getApi().get<AdminSystemCommandApiResponse>(`/admin/system`, config);
	return config?.raw ? res.data : hydrateAdminSystemCommand(res.data);
}

/**
 * GET /admin/phpinfo
 */
export async function apiAppAdminSystemPhpinfo(config?: ApiConfig): Promise<string> {
	const res = await getApi().get<string>(`/admin/phpinfo`, config);
	return res.data;
}

/**
 * POST /admin/impersonate
 */
export async function apiAdminImpersonate(body: AdminImpersonateRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/admin/impersonate`, body, config);
}

/**
 * GET /admin/resolve-booking/{uuid}
 */
export async function apiAdminResolveBooking(uuid: string, config: ApiConfig & { raw: true }): Promise<AdminResolveBookingApiResponse>;
export async function apiAdminResolveBooking(uuid: string, config?: ApiConfig): Promise<AdminResolveBooking>;
export async function apiAdminResolveBooking(uuid: string, config?: ApiConfig): Promise<AdminResolveBooking | AdminResolveBookingApiResponse> {
	const res = await getApi().get<AdminResolveBookingApiResponse>(`/admin/resolve-booking/${uuid}`, config);
	return config?.raw ? res.data : hydrateAdminResolveBooking(res.data);
}

/**
 * POST /release-notes/search
 */
export async function apiAppAppReleasenoteSearch(body: ReleaseNoteSearchRequest, config: ApiConfig & { raw: true }): Promise<ReleaseNoteSearchApiResponse>;
export async function apiAppAppReleasenoteSearch(body: ReleaseNoteSearchRequest, config?: ApiConfig): Promise<ReleaseNoteSearch>;
export async function apiAppAppReleasenoteSearch(body: ReleaseNoteSearchRequest, config?: ApiConfig): Promise<ReleaseNoteSearch | ReleaseNoteSearchApiResponse> {
	const res = await getApi().post<ReleaseNoteSearchApiResponse>(`/release-notes/search`, body, config);
	return config?.raw ? res.data : hydrateReleaseNoteSearch(res.data);
}

/**
 * POST /release-notes/{id}/react
 */
export async function apiAppAppReleasenoteReact(id: number, body: ReactReleaseNoteRequest, config: ApiConfig & { raw: true }): Promise<ReleaseNoteReactApiResponse>;
export async function apiAppAppReleasenoteReact(id: number, body: ReactReleaseNoteRequest, config?: ApiConfig): Promise<ReleaseNoteReact>;
export async function apiAppAppReleasenoteReact(id: number, body: ReactReleaseNoteRequest, config?: ApiConfig): Promise<ReleaseNoteReact | ReleaseNoteReactApiResponse> {
	const res = await getApi().post<ReleaseNoteReactApiResponse>(`/release-notes/${id}/react`, body, config);
	return config?.raw ? res.data : hydrateReleaseNoteReact(res.data);
}

/**
 * POST /release-notes/read
 */
export async function apiAppAppReleasenoteMarkasread(config?: ApiConfig): Promise<void> {
	await getApi().post(`/release-notes/read`, config);
}

/**
 * POST /auth/login
 */
export async function apiAuthLogin(body: LoginRequest, config: ApiConfig & { raw: true }): Promise<UserApiResponse>;
export async function apiAuthLogin(body: LoginRequest, config?: ApiConfig): Promise<User>;
export async function apiAuthLogin(body: LoginRequest, config?: ApiConfig): Promise<User | UserApiResponse> {
	const res = await getApi().post<UserApiResponse>(`/auth/login`, body, config);
	return config?.raw ? res.data : hydrateUser(res.data);
}

/**
 * POST /auth/refresh
 */
export async function apiAuthRefresh(config?: ApiConfig): Promise<void> {
	await getApi().post(`/auth/refresh`, config);
}

/**
 * POST /auth/token-verify
 */
export async function apiAuthTokenVerify(body: VerifyTokenRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/auth/token-verify`, body, config);
}

/**
 * POST /auth/logout
 */
export async function apiAuthLogout(body: LogoutRequest, config: ApiConfig & { raw: true }): Promise<AuthLogoutApiResponse>;
export async function apiAuthLogout(body: LogoutRequest, config?: ApiConfig): Promise<AuthLogout>;
export async function apiAuthLogout(body: LogoutRequest, config?: ApiConfig): Promise<AuthLogout | AuthLogoutApiResponse> {
	const res = await getApi().post<AuthLogoutApiResponse>(`/auth/logout`, body, config);
	return config?.raw ? res.data : hydrateAuthLogout(res.data);
}

/**
 * POST /auth/forgot-password
 */
export async function apiAuthForgotPassword(body: ForgotPasswordRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/auth/forgot-password`, body, config);
}

/**
 * POST /auth/forgot-password/recover
 */
export async function apiAuthForgotPasswordRecover(body: RecoverPasswordRequest, config: ApiConfig & { raw: true }): Promise<AuthRecoverPasswordApiResponse>;
export async function apiAuthForgotPasswordRecover(body: RecoverPasswordRequest, config?: ApiConfig): Promise<AuthRecoverPassword>;
export async function apiAuthForgotPasswordRecover(body: RecoverPasswordRequest, config?: ApiConfig): Promise<AuthRecoverPassword | AuthRecoverPasswordApiResponse> {
	const res = await getApi().post<AuthRecoverPasswordApiResponse>(`/auth/forgot-password/recover`, body, config);
	return config?.raw ? res.data : hydrateAuthRecoverPassword(res.data);
}

/**
 * POST /auth/google-login
 */
export async function apiAuthLoginGoogle(body: GoogleLoginRequest, config: ApiConfig & { raw: true }): Promise<UserApiResponse>;
export async function apiAuthLoginGoogle(body: GoogleLoginRequest, config?: ApiConfig): Promise<User>;
export async function apiAuthLoginGoogle(body: GoogleLoginRequest, config?: ApiConfig): Promise<User | UserApiResponse> {
	const res = await getApi().post<UserApiResponse>(`/auth/google-login`, body, config);
	return config?.raw ? res.data : hydrateUser(res.data);
}

/**
 * GET /google/auth
 */
export async function apiAppAuthGoogleauthGenerateauthurl(config: ApiConfig & { raw: true }): Promise<GoogleAuthUrlApiResponse>;
export async function apiAppAuthGoogleauthGenerateauthurl(config?: ApiConfig): Promise<GoogleAuthUrl>;
export async function apiAppAuthGoogleauthGenerateauthurl(config?: ApiConfig): Promise<GoogleAuthUrl | GoogleAuthUrlApiResponse> {
	const res = await getApi().get<GoogleAuthUrlApiResponse>(`/google/auth`, config);
	return config?.raw ? res.data : hydrateGoogleAuthUrl(res.data);
}

/**
 * DELETE /google/auth/{id}
 */
export async function apiAppAuthGoogleauthDeleteauth(id: number, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/google/auth/${id}`, config);
}

/**
 * POST /google/auth-save
 */
export async function apiAppAuthGoogleauthRedirect(body: GoogleAuthSaveRequest, config: ApiConfig & { raw: true }): Promise<GoogleAuthApiResponse>;
export async function apiAppAuthGoogleauthRedirect(body: GoogleAuthSaveRequest, config?: ApiConfig): Promise<GoogleAuth>;
export async function apiAppAuthGoogleauthRedirect(body: GoogleAuthSaveRequest, config?: ApiConfig): Promise<GoogleAuth | GoogleAuthApiResponse> {
	const res = await getApi().post<GoogleAuthApiResponse>(`/google/auth-save`, body, config);
	return config?.raw ? res.data : hydrateGoogleAuth(res.data);
}

/**
 * POST /me
 */
export async function apiUserMe(config: ApiConfig & { raw: true }): Promise<UserApiResponse>;
export async function apiUserMe(config?: ApiConfig): Promise<User>;
export async function apiUserMe(config?: ApiConfig): Promise<User | UserApiResponse> {
	const res = await getApi().post<UserApiResponse>(`/me`, config);
	return config?.raw ? res.data : hydrateUser(res.data);
}

/**
 * POST /locale
 */
export async function apiUserLocale(body: UpdateLocaleRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/locale`, body, config);
}

/**
 * POST /user/update-password
 */
export async function apiUpdatePassword(body: UpdatePasswordRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/user/update-password`, body, config);
}

/**
 * POST /user/do-not-disturb
 */
export async function apiDoNotDisturb(body: DoNotDisturbRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/user/do-not-disturb`, body, config);
}

/**
 * DELETE /user/do-not-disturb
 */
export async function apiDoNotDisturbDelete(config?: ApiConfig): Promise<void> {
	await getApi().delete(`/user/do-not-disturb`, config);
}

/**
 * GET /notification-settings
 */
export async function apiNotificationSettings(config: ApiConfig & { raw: true }): Promise<UserNotificationSettingListApiResponse>;
export async function apiNotificationSettings(config?: ApiConfig): Promise<UserNotificationSettingList>;
export async function apiNotificationSettings(config?: ApiConfig): Promise<UserNotificationSettingList | UserNotificationSettingListApiResponse> {
	const res = await getApi().get<UserNotificationSettingListApiResponse>(`/notification-settings`, config);
	return config?.raw ? res.data : hydrateUserNotificationSettingList(res.data);
}

/**
 * POST /notification-settings
 */
export async function apiNotificationSettingsUpdate(body: UpdateNotificationSettingsRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/notification-settings`, body, config);
}

/**
 * GET /contract
 */
export async function apiAppBillingContractGetcontract(config: ApiConfig & { raw: true }): Promise<ContractApiResponse>;
export async function apiAppBillingContractGetcontract(config?: ApiConfig): Promise<Contract>;
export async function apiAppBillingContractGetcontract(config?: ApiConfig): Promise<Contract | ContractApiResponse> {
	const res = await getApi().get<ContractApiResponse>(`/contract`, config);
	return config?.raw ? res.data : hydrateContract(res.data);
}

/**
 * GET /contract/taxes
 */
export async function apiAppBillingContractGettaxes(config: ApiConfig & { raw: true }): Promise<BillingVatListApiResponse>;
export async function apiAppBillingContractGettaxes(config?: ApiConfig): Promise<BillingVatList>;
export async function apiAppBillingContractGettaxes(config?: ApiConfig): Promise<BillingVatList | BillingVatListApiResponse> {
	const res = await getApi().get<BillingVatListApiResponse>(`/contract/taxes`, config);
	return config?.raw ? res.data : hydrateBillingVatList(res.data);
}

/**
 * POST /contract/subscribe/{priceId}
 */
export async function apiAppBillingContractSubscribe(priceId: number, config: ApiConfig & { raw: true }): Promise<ContractApiResponse>;
export async function apiAppBillingContractSubscribe(priceId: number, config?: ApiConfig): Promise<Contract>;
export async function apiAppBillingContractSubscribe(priceId: number, config?: ApiConfig): Promise<Contract | ContractApiResponse> {
	const res = await getApi().post<ContractApiResponse>(`/contract/subscribe/${priceId}`, config);
	return config?.raw ? res.data : hydrateContract(res.data);
}

/**
 * DELETE /contract/subscribe
 */
export async function apiAppBillingContractCancelsubscription(config: ApiConfig & { raw: true }): Promise<ContractApiResponse>;
export async function apiAppBillingContractCancelsubscription(config?: ApiConfig): Promise<Contract>;
export async function apiAppBillingContractCancelsubscription(config?: ApiConfig): Promise<Contract | ContractApiResponse> {
	const res = await getApi().delete<ContractApiResponse>(`/contract/subscribe`, config);
	return config?.raw ? res.data : hydrateContract(res.data);
}

/**
 * POST /contract/subscribe
 */
export async function apiAppBillingContractReactivatesubscription(config: ApiConfig & { raw: true }): Promise<ContractApiResponse>;
export async function apiAppBillingContractReactivatesubscription(config?: ApiConfig): Promise<Contract>;
export async function apiAppBillingContractReactivatesubscription(config?: ApiConfig): Promise<Contract | ContractApiResponse> {
	const res = await getApi().post<ContractApiResponse>(`/contract/subscribe`, config);
	return config?.raw ? res.data : hydrateContract(res.data);
}

/**
 * POST /contract/voucher
 */
export async function apiAppBillingContractApplyvoucher(body: ApplyVoucherRequest, config: ApiConfig & { raw: true }): Promise<ContractApiResponse>;
export async function apiAppBillingContractApplyvoucher(body: ApplyVoucherRequest, config?: ApiConfig): Promise<Contract>;
export async function apiAppBillingContractApplyvoucher(body: ApplyVoucherRequest, config?: ApiConfig): Promise<Contract | ContractApiResponse> {
	const res = await getApi().post<ContractApiResponse>(`/contract/voucher`, body, config);
	return config?.raw ? res.data : hydrateContract(res.data);
}

/**
 * GET /contract/prices
 */
export async function apiAppBillingContractListallprices(config: ApiConfig & { raw: true }): Promise<BillingPackageGroupPriceListApiResponse>;
export async function apiAppBillingContractListallprices(config?: ApiConfig): Promise<BillingPackageGroupPriceList>;
export async function apiAppBillingContractListallprices(config?: ApiConfig): Promise<BillingPackageGroupPriceList | BillingPackageGroupPriceListApiResponse> {
	const res = await getApi().get<BillingPackageGroupPriceListApiResponse>(`/contract/prices`, config);
	return config?.raw ? res.data : hydrateBillingPackageGroupPriceList(res.data);
}

/**
 * POST /contract/info
 */
export async function apiAppBillingContractInfo(body: UpdateBillingInfoRequest, config: ApiConfig & { raw: true }): Promise<ContractApiResponse>;
export async function apiAppBillingContractInfo(body: UpdateBillingInfoRequest, config?: ApiConfig): Promise<Contract>;
export async function apiAppBillingContractInfo(body: UpdateBillingInfoRequest, config?: ApiConfig): Promise<Contract | ContractApiResponse> {
	const res = await getApi().post<ContractApiResponse>(`/contract/info`, body, config);
	return config?.raw ? res.data : hydrateContract(res.data);
}

/**
 * GET /contract/company-search
 */
export async function apiAppBillingContractCompanysearch(params: ContractCompanySearchRequest | undefined, config: ApiConfig & { raw: true }): Promise<ContractCompanySearchApiResponse>;
export async function apiAppBillingContractCompanysearch(params?: ContractCompanySearchRequest, config?: ApiConfig): Promise<ContractCompanySearch>;
export async function apiAppBillingContractCompanysearch(params?: ContractCompanySearchRequest, config?: ApiConfig): Promise<ContractCompanySearch | ContractCompanySearchApiResponse> {
	const res = await getApi().get<ContractCompanySearchApiResponse>(`/contract/company-search`, { params, ...config });
	return config?.raw ? res.data : hydrateContractCompanySearch(res.data);
}

/**
 * GET /contract/verify-vat
 */
export async function apiAppBillingContractVerifyvat(params: ContractVerifyVatRequest | undefined, config: ApiConfig & { raw: true }): Promise<ContractVerifyVatApiResponse>;
export async function apiAppBillingContractVerifyvat(params?: ContractVerifyVatRequest, config?: ApiConfig): Promise<ContractVerifyVat>;
export async function apiAppBillingContractVerifyvat(params?: ContractVerifyVatRequest, config?: ApiConfig): Promise<ContractVerifyVat | ContractVerifyVatApiResponse> {
	const res = await getApi().get<ContractVerifyVatApiResponse>(`/contract/verify-vat`, { params, ...config });
	return config?.raw ? res.data : hydrateContractVerifyVat(res.data);
}

/**
 * GET /billing/invoices
 */
export async function apiAppBillingInvoiceListinvoice(config: ApiConfig & { raw: true }): Promise<BillingInvoiceListApiResponse>;
export async function apiAppBillingInvoiceListinvoice(config?: ApiConfig): Promise<BillingInvoiceList>;
export async function apiAppBillingInvoiceListinvoice(config?: ApiConfig): Promise<BillingInvoiceList | BillingInvoiceListApiResponse> {
	const res = await getApi().get<BillingInvoiceListApiResponse>(`/billing/invoices`, config);
	return config?.raw ? res.data : hydrateBillingInvoiceList(res.data);
}

/**
 * GET /billing/payments
 */
export async function apiAppBillingInvoiceListpayments(config: ApiConfig & { raw: true }): Promise<BillingPaymentListApiResponse>;
export async function apiAppBillingInvoiceListpayments(config?: ApiConfig): Promise<BillingPaymentList>;
export async function apiAppBillingInvoiceListpayments(config?: ApiConfig): Promise<BillingPaymentList | BillingPaymentListApiResponse> {
	const res = await getApi().get<BillingPaymentListApiResponse>(`/billing/payments`, config);
	return config?.raw ? res.data : hydrateBillingPaymentList(res.data);
}

/**
 * GET /billing/balance
 */
export async function apiAppBillingInvoiceGetbalance(config: ApiConfig & { raw: true }): Promise<BillingBalanceApiResponse>;
export async function apiAppBillingInvoiceGetbalance(config?: ApiConfig): Promise<BillingBalance>;
export async function apiAppBillingInvoiceGetbalance(config?: ApiConfig): Promise<BillingBalance | BillingBalanceApiResponse> {
	const res = await getApi().get<BillingBalanceApiResponse>(`/billing/balance`, config);
	return config?.raw ? res.data : hydrateBillingBalance(res.data);
}

/**
 * GET /billing/invoices/{id}
 */
export async function apiAppBillingInvoiceGetinvoice(id: number, config: ApiConfig & { raw: true }): Promise<BillingInvoiceDetailApiResponse>;
export async function apiAppBillingInvoiceGetinvoice(id: number, config?: ApiConfig): Promise<BillingInvoiceDetail>;
export async function apiAppBillingInvoiceGetinvoice(id: number, config?: ApiConfig): Promise<BillingInvoiceDetail | BillingInvoiceDetailApiResponse> {
	const res = await getApi().get<BillingInvoiceDetailApiResponse>(`/billing/invoices/${id}`, config);
	return config?.raw ? res.data : hydrateBillingInvoiceDetail(res.data);
}

/**
 * GET /billing/invoices/{id}/url
 */
export async function apiAppBillingInvoiceGetinvoiceurl(id: number, config: ApiConfig & { raw: true }): Promise<BillingInvoiceUrlApiResponse>;
export async function apiAppBillingInvoiceGetinvoiceurl(id: number, config?: ApiConfig): Promise<BillingInvoiceUrl>;
export async function apiAppBillingInvoiceGetinvoiceurl(id: number, config?: ApiConfig): Promise<BillingInvoiceUrl | BillingInvoiceUrlApiResponse> {
	const res = await getApi().get<BillingInvoiceUrlApiResponse>(`/billing/invoices/${id}/url`, config);
	return config?.raw ? res.data : hydrateBillingInvoiceUrl(res.data);
}

/**
 * GET /billing/this-month
 */
export async function apiAppBillingInvoiceGetthismonthfees(config: ApiConfig & { raw: true }): Promise<BillingThisMonthFeesApiResponse>;
export async function apiAppBillingInvoiceGetthismonthfees(config?: ApiConfig): Promise<BillingThisMonthFees>;
export async function apiAppBillingInvoiceGetthismonthfees(config?: ApiConfig): Promise<BillingThisMonthFees | BillingThisMonthFeesApiResponse> {
	const res = await getApi().get<BillingThisMonthFeesApiResponse>(`/billing/this-month`, config);
	return config?.raw ? res.data : hydrateBillingThisMonthFees(res.data);
}

/**
 * POST /billing/retry-payment
 */
export async function apiAppBillingInvoiceRetrypayment(config?: ApiConfig): Promise<void> {
	await getApi().post(`/billing/retry-payment`, config);
}

/**
 * POST /billing/transactions
 */
export async function apiAppBillingPaymentListstripebalance(body: ListStripeBalanceRequest, config: ApiConfig & { raw: true }): Promise<StripeTransactionListApiResponse>;
export async function apiAppBillingPaymentListstripebalance(body: ListStripeBalanceRequest, config?: ApiConfig): Promise<StripeTransactionList>;
export async function apiAppBillingPaymentListstripebalance(body: ListStripeBalanceRequest, config?: ApiConfig): Promise<StripeTransactionList | StripeTransactionListApiResponse> {
	const res = await getApi().post<StripeTransactionListApiResponse>(`/billing/transactions`, body, config);
	return config?.raw ? res.data : hydrateStripeTransactionList(res.data);
}

/**
 * POST /billing/transactions/payments
 */
export async function apiAppBillingPaymentListpaymentsapp(body: ListPaymentsRequest, config: ApiConfig & { raw: true }): Promise<TransactionListApiResponse>;
export async function apiAppBillingPaymentListpaymentsapp(body: ListPaymentsRequest, config?: ApiConfig): Promise<TransactionList>;
export async function apiAppBillingPaymentListpaymentsapp(body: ListPaymentsRequest, config?: ApiConfig): Promise<TransactionList | TransactionListApiResponse> {
	const res = await getApi().post<TransactionListApiResponse>(`/billing/transactions/payments`, body, config);
	return config?.raw ? res.data : hydrateTransactionList(res.data);
}

/**
 * POST /billing/transactions/payments/totals
 */
export async function apiAppBillingPaymentGetpaymentstotalsapp(body: ListPaymentsRequest, config: ApiConfig & { raw: true }): Promise<TransactionTotalsApiResponse>;
export async function apiAppBillingPaymentGetpaymentstotalsapp(body: ListPaymentsRequest, config?: ApiConfig): Promise<TransactionTotals>;
export async function apiAppBillingPaymentGetpaymentstotalsapp(body: ListPaymentsRequest, config?: ApiConfig): Promise<TransactionTotals | TransactionTotalsApiResponse> {
	const res = await getApi().post<TransactionTotalsApiResponse>(`/billing/transactions/payments/totals`, body, config);
	return config?.raw ? res.data : hydrateTransactionTotals(res.data);
}

/**
 * POST /billing/transactions/guarantees
 */
export async function apiAppBillingPaymentListguaranteesapp(body: ListGuaranteesRequest, config: ApiConfig & { raw: true }): Promise<BillingGuaranteeTransactionListApiResponse>;
export async function apiAppBillingPaymentListguaranteesapp(body: ListGuaranteesRequest, config?: ApiConfig): Promise<BillingGuaranteeTransactionList>;
export async function apiAppBillingPaymentListguaranteesapp(body: ListGuaranteesRequest, config?: ApiConfig): Promise<BillingGuaranteeTransactionList | BillingGuaranteeTransactionListApiResponse> {
	const res = await getApi().post<BillingGuaranteeTransactionListApiResponse>(`/billing/transactions/guarantees`, body, config);
	return config?.raw ? res.data : hydrateBillingGuaranteeTransactionList(res.data);
}

/**
 * POST /billing/transactions/export
 */
export async function apiAppBillingPaymentExporttransactions(body: ExportTransactionsRequest, config?: ApiConfig): Promise<string> {
	const res = await getApi().post<string>(`/billing/transactions/export`, body, config);
	return res.data;
}

/**
 * POST /billing/transactions/payments/export
 */
export async function apiAppBillingPaymentExportpaymentsapp(body: ExportPaymentsRequest, config: ApiConfig & { raw: true }): Promise<BillingExportApiResponse>;
export async function apiAppBillingPaymentExportpaymentsapp(body: ExportPaymentsRequest, config?: ApiConfig): Promise<BillingExport>;
export async function apiAppBillingPaymentExportpaymentsapp(body: ExportPaymentsRequest, config?: ApiConfig): Promise<BillingExport | BillingExportApiResponse> {
	const res = await getApi().post<BillingExportApiResponse>(`/billing/transactions/payments/export`, body, config);
	return config?.raw ? res.data : hydrateBillingExport(res.data);
}

/**
 * POST /billing/transactions/guarantees/export
 */
export async function apiAppBillingPaymentExportguaranteesapp(body: ExportGuaranteesRequest, config?: ApiConfig): Promise<string> {
	const res = await getApi().post<string>(`/billing/transactions/guarantees/export`, body, config);
	return res.data;
}

/**
 * GET /billing/payment-methods/add
 */
export async function apiAppBillingPaymentAddpaymentmethod(config: ApiConfig & { raw: true }): Promise<BillingSetupIntentApiResponse>;
export async function apiAppBillingPaymentAddpaymentmethod(config?: ApiConfig): Promise<BillingSetupIntent>;
export async function apiAppBillingPaymentAddpaymentmethod(config?: ApiConfig): Promise<BillingSetupIntent | BillingSetupIntentApiResponse> {
	const res = await getApi().get<BillingSetupIntentApiResponse>(`/billing/payment-methods/add`, config);
	return config?.raw ? res.data : hydrateBillingSetupIntent(res.data);
}

/**
 * GET /billing/payment-methods
 */
export async function apiAppBillingPaymentListpaymentmethods(config: ApiConfig & { raw: true }): Promise<BillingPaymentMethodListApiResponse>;
export async function apiAppBillingPaymentListpaymentmethods(config?: ApiConfig): Promise<BillingPaymentMethodList>;
export async function apiAppBillingPaymentListpaymentmethods(config?: ApiConfig): Promise<BillingPaymentMethodList | BillingPaymentMethodListApiResponse> {
	const res = await getApi().get<BillingPaymentMethodListApiResponse>(`/billing/payment-methods`, config);
	return config?.raw ? res.data : hydrateBillingPaymentMethodList(res.data);
}

/**
 * POST /availability/compute
 */
export async function apiAppBookingAvailabilityCompute(body: ComputeAvailabilityRequest, config: ApiConfig & { raw: true }): Promise<AvailabilityComputeApiResponse>;
export async function apiAppBookingAvailabilityCompute(body: ComputeAvailabilityRequest, config?: ApiConfig): Promise<AvailabilityCompute>;
export async function apiAppBookingAvailabilityCompute(body: ComputeAvailabilityRequest, config?: ApiConfig): Promise<AvailabilityCompute | AvailabilityComputeApiResponse> {
	const res = await getApi().post<AvailabilityComputeApiResponse>(`/availability/compute`, body, config);
	return config?.raw ? res.data : hydrateAvailabilityCompute(res.data);
}

/**
 * POST /customer/search
 */
export async function apiAppBookingCustomerSearchcustomer(body: CustomerSearchRequest, config: ApiConfig & { raw: true }): Promise<CustomerSearchApiResponse>;
export async function apiAppBookingCustomerSearchcustomer(body: CustomerSearchRequest, config?: ApiConfig): Promise<CustomerSearch>;
export async function apiAppBookingCustomerSearchcustomer(body: CustomerSearchRequest, config?: ApiConfig): Promise<CustomerSearch | CustomerSearchApiResponse> {
	const res = await getApi().post<CustomerSearchApiResponse>(`/customer/search`, body, config);
	return config?.raw ? res.data : hydrateCustomerSearch(res.data);
}

/**
 * POST /customer
 */
export async function apiAppBookingCustomerUpsertcustomer(body: UpsertCustomerRequest, config: ApiConfig & { raw: true }): Promise<CustomerApiResponse>;
export async function apiAppBookingCustomerUpsertcustomer(body: UpsertCustomerRequest, config?: ApiConfig): Promise<Customer>;
export async function apiAppBookingCustomerUpsertcustomer(body: UpsertCustomerRequest, config?: ApiConfig): Promise<Customer | CustomerApiResponse> {
	const res = await getApi().post<CustomerApiResponse>(`/customer`, body, config);
	return config?.raw ? res.data : hydrateCustomer(res.data);
}

/**
 * GET /customer/stats
 */
export async function apiAppBookingCustomerGetagregate(config: ApiConfig & { raw: true }): Promise<CustomerStatsApiResponse>;
export async function apiAppBookingCustomerGetagregate(config?: ApiConfig): Promise<CustomerStats>;
export async function apiAppBookingCustomerGetagregate(config?: ApiConfig): Promise<CustomerStats | CustomerStatsApiResponse> {
	const res = await getApi().get<CustomerStatsApiResponse>(`/customer/stats`, config);
	return config?.raw ? res.data : hydrateCustomerStats(res.data);
}

/**
 * POST /customer/export
 */
export async function apiAppBookingCustomerExportcustomers(body: ExportCustomersRequest, config?: ApiConfig): Promise<string> {
	const res = await getApi().post<string>(`/customer/export`, body, config);
	return res.data;
}

/**
 * DELETE /customer/{id}
 */
export async function apiAppBookingCustomerDeletecustomer(id: string, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/customer/${id}`, config);
}

/**
 * POST /survey-result/search
 */
export async function apiAppBookingReviewSearch(body: ReviewSearchRequest, config: ApiConfig & { raw: true }): Promise<ReviewSearchApiResponse>;
export async function apiAppBookingReviewSearch(body: ReviewSearchRequest, config?: ApiConfig): Promise<ReviewSearch>;
export async function apiAppBookingReviewSearch(body: ReviewSearchRequest, config?: ApiConfig): Promise<ReviewSearch | ReviewSearchApiResponse> {
	const res = await getApi().post<ReviewSearchApiResponse>(`/survey-result/search`, body, config);
	return config?.raw ? res.data : hydrateReviewSearch(res.data);
}

/**
 * GET /survey-result/stats
 */
export async function apiAppBookingReviewGetratingstats(params: ReviewRatingStatsRequest | undefined, config: ApiConfig & { raw: true }): Promise<ReviewRatingStatsApiResponse>;
export async function apiAppBookingReviewGetratingstats(params?: ReviewRatingStatsRequest, config?: ApiConfig): Promise<ReviewRatingStats>;
export async function apiAppBookingReviewGetratingstats(params?: ReviewRatingStatsRequest, config?: ApiConfig): Promise<ReviewRatingStats | ReviewRatingStatsApiResponse> {
	const res = await getApi().get<ReviewRatingStatsApiResponse>(`/survey-result/stats`, { params, ...config });
	return config?.raw ? res.data : hydrateReviewRatingStats(res.data);
}

/**
 * GET /survey-result/stats/split
 */
export async function apiAppBookingReviewGetratingsplit(config: ApiConfig & { raw: true }): Promise<ReviewRatingSplitApiResponse>;
export async function apiAppBookingReviewGetratingsplit(config?: ApiConfig): Promise<ReviewRatingSplit>;
export async function apiAppBookingReviewGetratingsplit(config?: ApiConfig): Promise<ReviewRatingSplit | ReviewRatingSplitApiResponse> {
	const res = await getApi().get<ReviewRatingSplitApiResponse>(`/survey-result/stats/split`, config);
	return config?.raw ? res.data : hydrateReviewRatingSplit(res.data);
}

/**
 * POST /survey-result/read
 */
export async function apiAppBookingReviewMarkasread(body: MarkReviewReadRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/survey-result/read`, body, config);
}

/**
 * POST /survey-result/unread
 */
export async function apiAppBookingReviewMarkasunread(body: MarkReviewUnreadRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/survey-result/unread`, body, config);
}

/**
 * POST /survey-result/{surveyResultId}/reply
 */
export async function apiAppBookingReviewPostreply(surveyResultId: number, body: ReplyReviewRequest, config: ApiConfig & { raw: true }): Promise<BookingApiResponse>;
export async function apiAppBookingReviewPostreply(surveyResultId: number, body: ReplyReviewRequest, config?: ApiConfig): Promise<Booking>;
export async function apiAppBookingReviewPostreply(surveyResultId: number, body: ReplyReviewRequest, config?: ApiConfig): Promise<Booking | BookingApiResponse> {
	const res = await getApi().post<BookingApiResponse>(`/survey-result/${surveyResultId}/reply`, body, config);
	return config?.raw ? res.data : hydrateBooking(res.data);
}

/**
 * POST /survey-result/{surveyResultId}/not-replied
 */
export async function apiAppBookingReviewPostunreply(surveyResultId: number, config: ApiConfig & { raw: true }): Promise<BookingApiResponse>;
export async function apiAppBookingReviewPostunreply(surveyResultId: number, config?: ApiConfig): Promise<Booking>;
export async function apiAppBookingReviewPostunreply(surveyResultId: number, config?: ApiConfig): Promise<Booking | BookingApiResponse> {
	const res = await getApi().post<BookingApiResponse>(`/survey-result/${surveyResultId}/not-replied`, config);
	return config?.raw ? res.data : hydrateBooking(res.data);
}

/**
 * POST /session-instance/search
 */
export async function apiAppBookingSessioninstanceSearch(body: SessionInstanceSearchRequest, config: ApiConfig & { raw: true }): Promise<SessionInstanceSearchApiResponse>;
export async function apiAppBookingSessioninstanceSearch(body: SessionInstanceSearchRequest, config?: ApiConfig): Promise<SessionInstanceSearch>;
export async function apiAppBookingSessioninstanceSearch(body: SessionInstanceSearchRequest, config?: ApiConfig): Promise<SessionInstanceSearch | SessionInstanceSearchApiResponse> {
	const res = await getApi().post<SessionInstanceSearchApiResponse>(`/session-instance/search`, body, config);
	return config?.raw ? res.data : hydrateSessionInstanceSearch(res.data);
}

/**
 * PUT /session-instance/{id}
 */
export async function apiAppBookingSessioninstanceUpdate(id: string, body: UpdateSessionInstanceRequest, config: ApiConfig & { raw: true }): Promise<SessionInstanceApiResponse>;
export async function apiAppBookingSessioninstanceUpdate(id: string, body: UpdateSessionInstanceRequest, config?: ApiConfig): Promise<SessionInstance>;
export async function apiAppBookingSessioninstanceUpdate(id: string, body: UpdateSessionInstanceRequest, config?: ApiConfig): Promise<SessionInstance | SessionInstanceApiResponse> {
	const res = await getApi().put<SessionInstanceApiResponse>(`/session-instance/${id}`, body, config);
	return config?.raw ? res.data : hydrateSessionInstance(res.data);
}

/**
 * POST /business/activity/{id}
 */
export async function apiAppBusinessActivityUpsertactivity(id: string, body: SaveActivityRequest, config: ApiConfig & { raw: true }): Promise<ActivityApiResponse>;
export async function apiAppBusinessActivityUpsertactivity(id: string, body: SaveActivityRequest, config?: ApiConfig): Promise<Activity>;
export async function apiAppBusinessActivityUpsertactivity(id: string, body: SaveActivityRequest, config?: ApiConfig): Promise<Activity | ActivityApiResponse> {
	const res = await getApi().post<ActivityApiResponse>(`/business/activity/${id}`, body, config);
	return config?.raw ? res.data : hydrateActivity(res.data);
}

/**
 * DELETE /business/activity/{id}
 */
export async function apiAppBusinessActivityDeleteactivity(id: string, config: ApiConfig & { raw: true }): Promise<ActivityApiResponse>;
export async function apiAppBusinessActivityDeleteactivity(id: string, config?: ApiConfig): Promise<Activity>;
export async function apiAppBusinessActivityDeleteactivity(id: string, config?: ApiConfig): Promise<Activity | ActivityApiResponse> {
	const res = await getApi().delete<ActivityApiResponse>(`/business/activity/${id}`, config);
	return config?.raw ? res.data : hydrateActivity(res.data);
}

/**
 * GET /business/activity
 */
export async function apiAppBusinessActivityList(config: ApiConfig & { raw: true }): Promise<ActivityListApiResponse>;
export async function apiAppBusinessActivityList(config?: ApiConfig): Promise<ActivityList>;
export async function apiAppBusinessActivityList(config?: ApiConfig): Promise<ActivityList | ActivityListApiResponse> {
	const res = await getApi().get<ActivityListApiResponse>(`/business/activity`, config);
	return config?.raw ? res.data : hydrateActivityList(res.data);
}

/**
 * POST /business/area/{id}
 */
export async function apiAppBusinessAreaUpsert(id: string, body: SaveAreaRequest, config: ApiConfig & { raw: true }): Promise<AreaApiResponse>;
export async function apiAppBusinessAreaUpsert(id: string, body: SaveAreaRequest, config?: ApiConfig): Promise<Area>;
export async function apiAppBusinessAreaUpsert(id: string, body: SaveAreaRequest, config?: ApiConfig): Promise<Area | AreaApiResponse> {
	const res = await getApi().post<AreaApiResponse>(`/business/area/${id}`, body, config);
	return config?.raw ? res.data : hydrateArea(res.data);
}

/**
 * DELETE /business/area/{id}
 */
export async function apiAppBusinessAreaDelete(id: string, config: ApiConfig & { raw: true }): Promise<AreaApiResponse>;
export async function apiAppBusinessAreaDelete(id: string, config?: ApiConfig): Promise<Area>;
export async function apiAppBusinessAreaDelete(id: string, config?: ApiConfig): Promise<Area | AreaApiResponse> {
	const res = await getApi().delete<AreaApiResponse>(`/business/area/${id}`, config);
	return config?.raw ? res.data : hydrateArea(res.data);
}

/**
 * GET /business/area
 */
export async function apiAppBusinessAreaList(config: ApiConfig & { raw: true }): Promise<AreaListApiResponse>;
export async function apiAppBusinessAreaList(config?: ApiConfig): Promise<AreaList>;
export async function apiAppBusinessAreaList(config?: ApiConfig): Promise<AreaList | AreaListApiResponse> {
	const res = await getApi().get<AreaListApiResponse>(`/business/area`, config);
	return config?.raw ? res.data : hydrateAreaList(res.data);
}

/**
 * PUT /business/blocking-period/{id}
 */
export async function apiAppBusinessBlockingperiodUpsert(id: string, body: SaveBlockingPeriodRequest, config: ApiConfig & { raw: true }): Promise<BlockingPeriodApiResponse>;
export async function apiAppBusinessBlockingperiodUpsert(id: string, body: SaveBlockingPeriodRequest, config?: ApiConfig): Promise<BlockingPeriod>;
export async function apiAppBusinessBlockingperiodUpsert(id: string, body: SaveBlockingPeriodRequest, config?: ApiConfig): Promise<BlockingPeriod | BlockingPeriodApiResponse> {
	const res = await getApi().put<BlockingPeriodApiResponse>(`/business/blocking-period/${id}`, body, config);
	return config?.raw ? res.data : hydrateBlockingPeriod(res.data);
}

/**
 * DELETE /business/blocking-period/{id}
 */
export async function apiAppBusinessBlockingperiodDelete(id: string, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/business/blocking-period/${id}`, config);
}

/**
 * POST /business/blocking-period/search
 */
export async function apiAppBusinessBlockingperiodSearch(body: BlockingPeriodSearchRequest, config: ApiConfig & { raw: true }): Promise<BlockingPeriodSearchApiResponse>;
export async function apiAppBusinessBlockingperiodSearch(body: BlockingPeriodSearchRequest, config?: ApiConfig): Promise<BlockingPeriodSearch>;
export async function apiAppBusinessBlockingperiodSearch(body: BlockingPeriodSearchRequest, config?: ApiConfig): Promise<BlockingPeriodSearch | BlockingPeriodSearchApiResponse> {
	const res = await getApi().post<BlockingPeriodSearchApiResponse>(`/business/blocking-period/search`, body, config);
	return config?.raw ? res.data : hydrateBlockingPeriodSearch(res.data);
}

/**
 * POST /business/booking-events/logs/search
 */
export async function apiAppBusinessBookingeventSearchlogs(body: BookingEventLogSearchRequest, config: ApiConfig & { raw: true }): Promise<BookingEventLogSearchApiResponse>;
export async function apiAppBusinessBookingeventSearchlogs(body: BookingEventLogSearchRequest, config?: ApiConfig): Promise<BookingEventLogSearch>;
export async function apiAppBusinessBookingeventSearchlogs(body: BookingEventLogSearchRequest, config?: ApiConfig): Promise<BookingEventLogSearch | BookingEventLogSearchApiResponse> {
	const res = await getApi().post<BookingEventLogSearchApiResponse>(`/business/booking-events/logs/search`, body, config);
	return config?.raw ? res.data : hydrateBookingEventLogSearch(res.data);
}

/**
 * POST /business/booking-events/{id}
 */
export async function apiAppBusinessBookingeventSave(id: string, body: SaveBookingEventRequest, config: ApiConfig & { raw: true }): Promise<BookingEventApiResponse>;
export async function apiAppBusinessBookingeventSave(id: string, body: SaveBookingEventRequest, config?: ApiConfig): Promise<BookingEvent>;
export async function apiAppBusinessBookingeventSave(id: string, body: SaveBookingEventRequest, config?: ApiConfig): Promise<BookingEvent | BookingEventApiResponse> {
	const res = await getApi().post<BookingEventApiResponse>(`/business/booking-events/${id}`, body, config);
	return config?.raw ? res.data : hydrateBookingEvent(res.data);
}

/**
 * DELETE /business/booking-events/{id}
 */
export async function apiAppBusinessBookingeventDelete(id: string, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/business/booking-events/${id}`, config);
}

/**
 * POST /business/booking-events/{id}/test
 */
export async function apiAppBusinessBookingeventTest(id: string, body: TestBookingEventRequest, config: ApiConfig & { raw: true }): Promise<BookingEventTestApiResponse>;
export async function apiAppBusinessBookingeventTest(id: string, body: TestBookingEventRequest, config?: ApiConfig): Promise<BookingEventTest>;
export async function apiAppBusinessBookingeventTest(id: string, body: TestBookingEventRequest, config?: ApiConfig): Promise<BookingEventTest | BookingEventTestApiResponse> {
	const res = await getApi().post<BookingEventTestApiResponse>(`/business/booking-events/${id}/test`, body, config);
	return config?.raw ? res.data : hydrateBookingEventTest(res.data);
}

/**
 * GET /business
 */
export async function apiAppBusinessBusinessGetbusinesssettings(config: ApiConfig & { raw: true }): Promise<BusinessApiResponse>;
export async function apiAppBusinessBusinessGetbusinesssettings(config?: ApiConfig): Promise<Business>;
export async function apiAppBusinessBusinessGetbusinesssettings(config?: ApiConfig): Promise<Business | BusinessApiResponse> {
	const res = await getApi().get<BusinessApiResponse>(`/business`, config);
	return config?.raw ? res.data : hydrateBusiness(res.data);
}

/**
 * POST /business
 */
export async function apiAppBusinessBusinessUpdatebusiness(body: UpdateBusinessRequest, config: ApiConfig & { raw: true }): Promise<BusinessApiResponse>;
export async function apiAppBusinessBusinessUpdatebusiness(body: UpdateBusinessRequest, config?: ApiConfig): Promise<Business>;
export async function apiAppBusinessBusinessUpdatebusiness(body: UpdateBusinessRequest, config?: ApiConfig): Promise<Business | BusinessApiResponse> {
	const res = await getApi().post<BusinessApiResponse>(`/business`, body, config);
	return config?.raw ? res.data : hydrateBusiness(res.data);
}

/**
 * POST /business/google-reviews-url
 */
export async function apiAppBusinessBusinessUpdatebusinessgooglereviews(body: UpdateBusinessGoogleReviewsRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/business/google-reviews-url`, body, config);
}

/**
 * POST /business/stripe/upgrade-direct-charges
 */
export async function apiBusinessStripeUpgradeDirectCharges(config: ApiConfig & { raw: true }): Promise<StripeConnectRegisterApiResponse>;
export async function apiBusinessStripeUpgradeDirectCharges(config?: ApiConfig): Promise<StripeConnectRegister>;
export async function apiBusinessStripeUpgradeDirectCharges(config?: ApiConfig): Promise<StripeConnectRegister | StripeConnectRegisterApiResponse> {
	const res = await getApi().post<StripeConnectRegisterApiResponse>(`/business/stripe/upgrade-direct-charges`, config);
	return config?.raw ? res.data : hydrateStripeConnectRegister(res.data);
}

/**
 * POST /business/font
 */
export async function apiBusinessFontUpdate(body: UpdateBusinessFontRequest, config: ApiConfig & { raw: true }): Promise<BusinessApiResponse>;
export async function apiBusinessFontUpdate(body: UpdateBusinessFontRequest, config?: ApiConfig): Promise<Business>;
export async function apiBusinessFontUpdate(body: UpdateBusinessFontRequest, config?: ApiConfig): Promise<Business | BusinessApiResponse> {
	const res = await getApi().post<BusinessApiResponse>(`/business/font`, body, config);
	return config?.raw ? res.data : hydrateBusiness(res.data);
}

/**
 * POST /business/custom-fields/{id}
 */
export async function apiAppBusinessCustomfieldUpsertactivity(id: string, body: SaveCustomFieldRequest, config: ApiConfig & { raw: true }): Promise<CustomFieldApiResponse>;
export async function apiAppBusinessCustomfieldUpsertactivity(id: string, body: SaveCustomFieldRequest, config?: ApiConfig): Promise<CustomField>;
export async function apiAppBusinessCustomfieldUpsertactivity(id: string, body: SaveCustomFieldRequest, config?: ApiConfig): Promise<CustomField | CustomFieldApiResponse> {
	const res = await getApi().post<CustomFieldApiResponse>(`/business/custom-fields/${id}`, body, config);
	return config?.raw ? res.data : hydrateCustomField(res.data);
}

/**
 * DELETE /business/custom-fields/{id}
 */
export async function apiAppBusinessCustomfieldDeleteactivity(id: string, config: ApiConfig & { raw: true }): Promise<CustomFieldApiResponse>;
export async function apiAppBusinessCustomfieldDeleteactivity(id: string, config?: ApiConfig): Promise<CustomField>;
export async function apiAppBusinessCustomfieldDeleteactivity(id: string, config?: ApiConfig): Promise<CustomField | CustomFieldApiResponse> {
	const res = await getApi().delete<CustomFieldApiResponse>(`/business/custom-fields/${id}`, config);
	return config?.raw ? res.data : hydrateCustomField(res.data);
}

/**
 * POST /business/customer-packages
 */
export async function apiAppBusinessCustomerpackageCreate(body: CreateCustomerPackageRequest, config: ApiConfig & { raw: true }): Promise<CustomerPackageApiResponse>;
export async function apiAppBusinessCustomerpackageCreate(body: CreateCustomerPackageRequest, config?: ApiConfig): Promise<CustomerPackage>;
export async function apiAppBusinessCustomerpackageCreate(body: CreateCustomerPackageRequest, config?: ApiConfig): Promise<CustomerPackage | CustomerPackageApiResponse> {
	const res = await getApi().post<CustomerPackageApiResponse>(`/business/customer-packages`, body, config);
	return config?.raw ? res.data : hydrateCustomerPackage(res.data);
}

/**
 * PUT /business/customer-packages/{id}/consume
 */
export async function apiAppBusinessCustomerpackageConsume(id: string, body: ConsumeCustomerPackageRequest, config: ApiConfig & { raw: true }): Promise<CustomerPackageApiResponse>;
export async function apiAppBusinessCustomerpackageConsume(id: string, body: ConsumeCustomerPackageRequest, config?: ApiConfig): Promise<CustomerPackage>;
export async function apiAppBusinessCustomerpackageConsume(id: string, body: ConsumeCustomerPackageRequest, config?: ApiConfig): Promise<CustomerPackage | CustomerPackageApiResponse> {
	const res = await getApi().put<CustomerPackageApiResponse>(`/business/customer-packages/${id}/consume`, body, config);
	return config?.raw ? res.data : hydrateCustomerPackage(res.data);
}

/**
 * DELETE /business/customer-packages/{id}/usages/{usageId}
 */
export async function apiAppBusinessCustomerpackageRemoveusage(id: string, usageId: string, config: ApiConfig & { raw: true }): Promise<CustomerPackageApiResponse>;
export async function apiAppBusinessCustomerpackageRemoveusage(id: string, usageId: string, config?: ApiConfig): Promise<CustomerPackage>;
export async function apiAppBusinessCustomerpackageRemoveusage(id: string, usageId: string, config?: ApiConfig): Promise<CustomerPackage | CustomerPackageApiResponse> {
	const res = await getApi().delete<CustomerPackageApiResponse>(`/business/customer-packages/${id}/usages/${usageId}`, config);
	return config?.raw ? res.data : hydrateCustomerPackage(res.data);
}

/**
 * POST /business/customer-packages/{id}/recredit
 */
export async function apiAppBusinessCustomerpackageRecredit(id: string, body: RecreditCustomerPackageRequest, config: ApiConfig & { raw: true }): Promise<CustomerPackageApiResponse>;
export async function apiAppBusinessCustomerpackageRecredit(id: string, body: RecreditCustomerPackageRequest, config?: ApiConfig): Promise<CustomerPackage>;
export async function apiAppBusinessCustomerpackageRecredit(id: string, body: RecreditCustomerPackageRequest, config?: ApiConfig): Promise<CustomerPackage | CustomerPackageApiResponse> {
	const res = await getApi().post<CustomerPackageApiResponse>(`/business/customer-packages/${id}/recredit`, body, config);
	return config?.raw ? res.data : hydrateCustomerPackage(res.data);
}

/**
 * DELETE /business/customer-packages/{id}
 */
export async function apiAppBusinessCustomerpackageDelete(id: string, body: DeleteCustomerPackageRequest, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/business/customer-packages/${id}`, { ...config, data: body });
}

/**
 * PATCH /business/customer-packages/{id}
 */
export async function apiAppBusinessCustomerpackageUpdate(id: string, body: UpdateCustomerPackageRequest, config: ApiConfig & { raw: true }): Promise<CustomerPackageApiResponse>;
export async function apiAppBusinessCustomerpackageUpdate(id: string, body: UpdateCustomerPackageRequest, config?: ApiConfig): Promise<CustomerPackage>;
export async function apiAppBusinessCustomerpackageUpdate(id: string, body: UpdateCustomerPackageRequest, config?: ApiConfig): Promise<CustomerPackage | CustomerPackageApiResponse> {
	const res = await getApi().patch<CustomerPackageApiResponse>(`/business/customer-packages/${id}`, body, config);
	return config?.raw ? res.data : hydrateCustomerPackage(res.data);
}

/**
 * POST /business/customer-packages/{id}/resend-email
 */
export async function apiAppBusinessCustomerpackageResendemail(id: string, config?: ApiConfig): Promise<void> {
	await getApi().post(`/business/customer-packages/${id}/resend-email`, config);
}

/**
 * GET /business/email-settings
 */
export async function apiAppBusinessEmailsettingsGetemailsettings(config: ApiConfig & { raw: true }): Promise<EmailSettingsApiResponse>;
export async function apiAppBusinessEmailsettingsGetemailsettings(config?: ApiConfig): Promise<EmailSettings>;
export async function apiAppBusinessEmailsettingsGetemailsettings(config?: ApiConfig): Promise<EmailSettings | EmailSettingsApiResponse> {
	const res = await getApi().get<EmailSettingsApiResponse>(`/business/email-settings`, config);
	return config?.raw ? res.data : hydrateEmailSettings(res.data);
}

/**
 * POST /business/email-settings
 */
export async function apiAppBusinessEmailsettingsPostemailsettings(body: SaveEmailSettingsRequest, config: ApiConfig & { raw: true }): Promise<EmailSettingsApiResponse>;
export async function apiAppBusinessEmailsettingsPostemailsettings(body: SaveEmailSettingsRequest, config?: ApiConfig): Promise<EmailSettings>;
export async function apiAppBusinessEmailsettingsPostemailsettings(body: SaveEmailSettingsRequest, config?: ApiConfig): Promise<EmailSettings | EmailSettingsApiResponse> {
	const res = await getApi().post<EmailSettingsApiResponse>(`/business/email-settings`, body, config);
	return config?.raw ? res.data : hydrateEmailSettings(res.data);
}

/**
 * POST /business/email-settings/email-sent/search
 */
export async function apiAppBusinessEmailsettingsSearchemails(body: BusinessEmailSearchRequest, config: ApiConfig & { raw: true }): Promise<EmailSentSearchApiResponse>;
export async function apiAppBusinessEmailsettingsSearchemails(body: BusinessEmailSearchRequest, config?: ApiConfig): Promise<EmailSentSearch>;
export async function apiAppBusinessEmailsettingsSearchemails(body: BusinessEmailSearchRequest, config?: ApiConfig): Promise<EmailSentSearch | EmailSentSearchApiResponse> {
	const res = await getApi().post<EmailSentSearchApiResponse>(`/business/email-settings/email-sent/search`, body, config);
	return config?.raw ? res.data : hydrateEmailSentSearch(res.data);
}

/**
 * GET /business/all
 */
export async function apiAppBusinessLoadingappLoadall(config: ApiConfig & { raw: true }): Promise<BusinessLoadAllApiResponse>;
export async function apiAppBusinessLoadingappLoadall(config?: ApiConfig): Promise<BusinessLoadAll>;
export async function apiAppBusinessLoadingappLoadall(config?: ApiConfig): Promise<BusinessLoadAll | BusinessLoadAllApiResponse> {
	const res = await getApi().get<BusinessLoadAllApiResponse>(`/business/all`, config);
	return config?.raw ? res.data : hydrateBusinessLoadAll(res.data);
}

/**
 * GET /business/member-area-settings
 */
export async function apiAppBusinessMemberareasettingsGetsettings(config: ApiConfig & { raw: true }): Promise<WidgetMemberAreaApiResponse>;
export async function apiAppBusinessMemberareasettingsGetsettings(config?: ApiConfig): Promise<WidgetMemberArea>;
export async function apiAppBusinessMemberareasettingsGetsettings(config?: ApiConfig): Promise<WidgetMemberArea | WidgetMemberAreaApiResponse> {
	const res = await getApi().get<WidgetMemberAreaApiResponse>(`/business/member-area-settings`, config);
	return config?.raw ? res.data : hydrateWidgetMemberArea(res.data);
}

/**
 * POST /business/member-area-settings
 */
export async function apiAppBusinessMemberareasettingsPostsettings(body: SaveMemberAreaSettingsRequest, config: ApiConfig & { raw: true }): Promise<WidgetMemberAreaApiResponse>;
export async function apiAppBusinessMemberareasettingsPostsettings(body: SaveMemberAreaSettingsRequest, config?: ApiConfig): Promise<WidgetMemberArea>;
export async function apiAppBusinessMemberareasettingsPostsettings(body: SaveMemberAreaSettingsRequest, config?: ApiConfig): Promise<WidgetMemberArea | WidgetMemberAreaApiResponse> {
	const res = await getApi().post<WidgetMemberAreaApiResponse>(`/business/member-area-settings`, body, config);
	return config?.raw ? res.data : hydrateWidgetMemberArea(res.data);
}

/**
 * GET /business/memos/{id}
 */
export async function apiBusinessMemosShow(id: string, config: ApiConfig & { raw: true }): Promise<MemoApiResponse>;
export async function apiBusinessMemosShow(id: string, config?: ApiConfig): Promise<Memo>;
export async function apiBusinessMemosShow(id: string, config?: ApiConfig): Promise<Memo | MemoApiResponse> {
	const res = await getApi().get<MemoApiResponse>(`/business/memos/${id}`, config);
	return config?.raw ? res.data : hydrateMemo(res.data);
}

/**
 * POST /business/memos/{id}
 */
export async function apiBusinessMemosUpsert(id: string, body: SaveMemoRequest, config: ApiConfig & { raw: true }): Promise<MemoApiResponse>;
export async function apiBusinessMemosUpsert(id: string, body: SaveMemoRequest, config?: ApiConfig): Promise<Memo>;
export async function apiBusinessMemosUpsert(id: string, body: SaveMemoRequest, config?: ApiConfig): Promise<Memo | MemoApiResponse> {
	const res = await getApi().post<MemoApiResponse>(`/business/memos/${id}`, body, config);
	return config?.raw ? res.data : hydrateMemo(res.data);
}

/**
 * DELETE /business/memos/{id}
 */
export async function apiBusinessMemosDelete(id: string, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/business/memos/${id}`, config);
}

/**
 * GET /business/offers/collection
 */
export async function apiAppBusinessOffercollectionList(config: ApiConfig & { raw: true }): Promise<OfferCollectionListApiResponse>;
export async function apiAppBusinessOffercollectionList(config?: ApiConfig): Promise<OfferCollectionList>;
export async function apiAppBusinessOffercollectionList(config?: ApiConfig): Promise<OfferCollectionList | OfferCollectionListApiResponse> {
	const res = await getApi().get<OfferCollectionListApiResponse>(`/business/offers/collection`, config);
	return config?.raw ? res.data : hydrateOfferCollectionList(res.data);
}

/**
 * POST /business/offers/collection/{id}
 */
export async function apiAppBusinessOffercollectionUpsert(id: string, body: SaveOfferCollectionRequest, config: ApiConfig & { raw: true }): Promise<OfferCollectionApiResponse>;
export async function apiAppBusinessOffercollectionUpsert(id: string, body: SaveOfferCollectionRequest, config?: ApiConfig): Promise<OfferCollection>;
export async function apiAppBusinessOffercollectionUpsert(id: string, body: SaveOfferCollectionRequest, config?: ApiConfig): Promise<OfferCollection | OfferCollectionApiResponse> {
	const res = await getApi().post<OfferCollectionApiResponse>(`/business/offers/collection/${id}`, body, config);
	return config?.raw ? res.data : hydrateOfferCollection(res.data);
}

/**
 * DELETE /business/offers/collection/{id}
 */
export async function apiAppBusinessOffercollectionDelete(id: string, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/business/offers/collection/${id}`, config);
}

/**
 * PUT /business/offers/collection/sort
 */
export async function apiAppBusinessOffercollectionSaveorder(body: SaveOfferCollectionOrderRequest, config: ApiConfig & { raw: true }): Promise<OfferCollectionListApiResponse>;
export async function apiAppBusinessOffercollectionSaveorder(body: SaveOfferCollectionOrderRequest, config?: ApiConfig): Promise<OfferCollectionList>;
export async function apiAppBusinessOffercollectionSaveorder(body: SaveOfferCollectionOrderRequest, config?: ApiConfig): Promise<OfferCollectionList | OfferCollectionListApiResponse> {
	const res = await getApi().put<OfferCollectionListApiResponse>(`/business/offers/collection/sort`, body, config);
	return config?.raw ? res.data : hydrateOfferCollectionList(res.data);
}

/**
 * POST /business/offer/{id}
 */
export async function apiAppBusinessOfferUpsert(id: string, body: SaveOfferRequest, config: ApiConfig & { raw: true }): Promise<OfferApiResponse>;
export async function apiAppBusinessOfferUpsert(id: string, body: SaveOfferRequest, config?: ApiConfig): Promise<Offer>;
export async function apiAppBusinessOfferUpsert(id: string, body: SaveOfferRequest, config?: ApiConfig): Promise<Offer | OfferApiResponse> {
	const res = await getApi().post<OfferApiResponse>(`/business/offer/${id}`, body, config);
	return config?.raw ? res.data : hydrateOffer(res.data);
}

/**
 * POST /business/offer/{id}/prices
 */
export async function apiAppBusinessOfferUpsertprices(id: string, body: SaveOfferPricesRequest, config: ApiConfig & { raw: true }): Promise<OfferApiResponse>;
export async function apiAppBusinessOfferUpsertprices(id: string, body: SaveOfferPricesRequest, config?: ApiConfig): Promise<Offer>;
export async function apiAppBusinessOfferUpsertprices(id: string, body: SaveOfferPricesRequest, config?: ApiConfig): Promise<Offer | OfferApiResponse> {
	const res = await getApi().post<OfferApiResponse>(`/business/offer/${id}/prices`, body, config);
	return config?.raw ? res.data : hydrateOffer(res.data);
}

/**
 * POST /business/offer/{id}/publish
 */
export async function apiAppBusinessOfferPublish(id: string, config?: ApiConfig): Promise<void> {
	await getApi().post(`/business/offer/${id}/publish`, config);
}

/**
 * POST /business/offer/{id}/unpublish
 */
export async function apiAppBusinessOfferUnpublish(id: string, config?: ApiConfig): Promise<void> {
	await getApi().post(`/business/offer/${id}/unpublish`, config);
}

/**
 * POST /business/offer/{id}/duplicate
 */
export async function apiAppBusinessOfferDuplicate(id: string, config: ApiConfig & { raw: true }): Promise<OfferApiResponse>;
export async function apiAppBusinessOfferDuplicate(id: string, config?: ApiConfig): Promise<Offer>;
export async function apiAppBusinessOfferDuplicate(id: string, config?: ApiConfig): Promise<Offer | OfferApiResponse> {
	const res = await getApi().post<OfferApiResponse>(`/business/offer/${id}/duplicate`, config);
	return config?.raw ? res.data : hydrateOffer(res.data);
}

/**
 * DELETE /business/offer/{id}
 */
export async function apiAppBusinessOfferDelete(id: string, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/business/offer/${id}`, config);
}

/**
 * GET /business/offer
 */
export async function apiAppBusinessOfferList(config: ApiConfig & { raw: true }): Promise<OfferListApiResponse>;
export async function apiAppBusinessOfferList(config?: ApiConfig): Promise<OfferList>;
export async function apiAppBusinessOfferList(config?: ApiConfig): Promise<OfferList | OfferListApiResponse> {
	const res = await getApi().get<OfferListApiResponse>(`/business/offer`, config);
	return config?.raw ? res.data : hydrateOfferList(res.data);
}

/**
 * PUT /business/offer/sort
 */
export async function apiAppBusinessOfferSaveorder(body: SaveOfferOrderRequest, config: ApiConfig & { raw: true }): Promise<OfferListApiResponse>;
export async function apiAppBusinessOfferSaveorder(body: SaveOfferOrderRequest, config?: ApiConfig): Promise<OfferList>;
export async function apiAppBusinessOfferSaveorder(body: SaveOfferOrderRequest, config?: ApiConfig): Promise<OfferList | OfferListApiResponse> {
	const res = await getApi().put<OfferListApiResponse>(`/business/offer/sort`, body, config);
	return config?.raw ? res.data : hydrateOfferList(res.data);
}

/**
 * PUT /business/offer/reconfirm-settings
 */
export async function apiAppBusinessOfferSavereconfirmsettings(body: SaveOffersReconfirmTimeRequest, config: ApiConfig & { raw: true }): Promise<OfferListApiResponse>;
export async function apiAppBusinessOfferSavereconfirmsettings(body: SaveOffersReconfirmTimeRequest, config?: ApiConfig): Promise<OfferList>;
export async function apiAppBusinessOfferSavereconfirmsettings(body: SaveOffersReconfirmTimeRequest, config?: ApiConfig): Promise<OfferList | OfferListApiResponse> {
	const res = await getApi().put<OfferListApiResponse>(`/business/offer/reconfirm-settings`, body, config);
	return config?.raw ? res.data : hydrateOfferList(res.data);
}

/**
 * GET /opening-hours
 */
export async function apiAppBusinessOpeninghourGetopeninghours(config: ApiConfig & { raw: true }): Promise<OpeningHourListApiResponse>;
export async function apiAppBusinessOpeninghourGetopeninghours(config?: ApiConfig): Promise<OpeningHourList>;
export async function apiAppBusinessOpeninghourGetopeninghours(config?: ApiConfig): Promise<OpeningHourList | OpeningHourListApiResponse> {
	const res = await getApi().get<OpeningHourListApiResponse>(`/opening-hours`, config);
	return config?.raw ? res.data : hydrateOpeningHourList(res.data);
}

/**
 * POST /opening-hours/{id}
 */
export async function apiAppBusinessOpeninghourUpsertopeninghour(id: string, body: SaveOpeningHourRequest, config: ApiConfig & { raw: true }): Promise<OpeningHourApiResponse>;
export async function apiAppBusinessOpeninghourUpsertopeninghour(id: string, body: SaveOpeningHourRequest, config?: ApiConfig): Promise<OpeningHour>;
export async function apiAppBusinessOpeninghourUpsertopeninghour(id: string, body: SaveOpeningHourRequest, config?: ApiConfig): Promise<OpeningHour | OpeningHourApiResponse> {
	const res = await getApi().post<OpeningHourApiResponse>(`/opening-hours/${id}`, body, config);
	return config?.raw ? res.data : hydrateOpeningHour(res.data);
}

/**
 * DELETE /opening-hours/{id}
 */
export async function apiAppBusinessOpeninghourDeleteopeninghour(id: string, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/opening-hours/${id}`, config);
}

/**
 * POST /opening-hours/exceptions/search
 */
export async function apiAppBusinessOpeninghourSearchspecialopeninghours(body: OpeningHourExceptionSearchRequest, config: ApiConfig & { raw: true }): Promise<OpeningHourExceptionSearchApiResponse>;
export async function apiAppBusinessOpeninghourSearchspecialopeninghours(body: OpeningHourExceptionSearchRequest, config?: ApiConfig): Promise<OpeningHourExceptionSearch>;
export async function apiAppBusinessOpeninghourSearchspecialopeninghours(body: OpeningHourExceptionSearchRequest, config?: ApiConfig): Promise<OpeningHourExceptionSearch | OpeningHourExceptionSearchApiResponse> {
	const res = await getApi().post<OpeningHourExceptionSearchApiResponse>(`/opening-hours/exceptions/search`, body, config);
	return config?.raw ? res.data : hydrateOpeningHourExceptionSearch(res.data);
}

/**
 * POST /opening-hours/exceptions/upsert
 */
export async function apiAppBusinessOpeninghourCreatespecialopeninghour(body: SaveOpeningHourExceptionRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/opening-hours/exceptions/upsert`, body, config);
}

/**
 * POST /opening-hours/exceptions/delete-range
 */
export async function apiAppBusinessOpeninghourDeleterangespecialopeninghour(body: DeleteRangeOpeningHourExceptionRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/opening-hours/exceptions/delete-range`, body, config);
}

/**
 * GET /business/packages
 */
export async function apiAppBusinessPackageList(config: ApiConfig & { raw: true }): Promise<PackageListApiResponse>;
export async function apiAppBusinessPackageList(config?: ApiConfig): Promise<PackageList>;
export async function apiAppBusinessPackageList(config?: ApiConfig): Promise<PackageList | PackageListApiResponse> {
	const res = await getApi().get<PackageListApiResponse>(`/business/packages`, config);
	return config?.raw ? res.data : hydratePackageList(res.data);
}

/**
 * POST /business/packages/{id}
 */
export async function apiAppBusinessPackageUpsert(id: string, body: SavePackageRequest, config: ApiConfig & { raw: true }): Promise<PackageApiResponse>;
export async function apiAppBusinessPackageUpsert(id: string, body: SavePackageRequest, config?: ApiConfig): Promise<Package>;
export async function apiAppBusinessPackageUpsert(id: string, body: SavePackageRequest, config?: ApiConfig): Promise<Package | PackageApiResponse> {
	const res = await getApi().post<PackageApiResponse>(`/business/packages/${id}`, body, config);
	return config?.raw ? res.data : hydratePackage(res.data);
}

/**
 * POST /business/products/{id}
 */
export async function apiAppBusinessProductUpsert(id: string, body: SaveProductRequest, config: ApiConfig & { raw: true }): Promise<ProductApiResponse>;
export async function apiAppBusinessProductUpsert(id: string, body: SaveProductRequest, config?: ApiConfig): Promise<Product>;
export async function apiAppBusinessProductUpsert(id: string, body: SaveProductRequest, config?: ApiConfig): Promise<Product | ProductApiResponse> {
	const res = await getApi().post<ProductApiResponse>(`/business/products/${id}`, body, config);
	return config?.raw ? res.data : hydrateProduct(res.data);
}

/**
 * DELETE /business/products/{id}
 */
export async function apiAppBusinessProductDelete(id: string, config: ApiConfig & { raw: true }): Promise<ProductApiResponse>;
export async function apiAppBusinessProductDelete(id: string, config?: ApiConfig): Promise<Product>;
export async function apiAppBusinessProductDelete(id: string, config?: ApiConfig): Promise<Product | ProductApiResponse> {
	const res = await getApi().delete<ProductApiResponse>(`/business/products/${id}`, config);
	return config?.raw ? res.data : hydrateProduct(res.data);
}

/**
 * POST /business/promo-codes/bulk-generate
 */
export async function apiAppBusinessPromocodeBulkgenerate(body: BulkGeneratePromoCodeRequest, config: ApiConfig & { raw: true }): Promise<PromoCodeBulkGenerateApiResponse>;
export async function apiAppBusinessPromocodeBulkgenerate(body: BulkGeneratePromoCodeRequest, config?: ApiConfig): Promise<PromoCodeBulkGenerate>;
export async function apiAppBusinessPromocodeBulkgenerate(body: BulkGeneratePromoCodeRequest, config?: ApiConfig): Promise<PromoCodeBulkGenerate | PromoCodeBulkGenerateApiResponse> {
	const res = await getApi().post<PromoCodeBulkGenerateApiResponse>(`/business/promo-codes/bulk-generate`, body, config);
	return config?.raw ? res.data : hydratePromoCodeBulkGenerate(res.data);
}

/**
 * POST /business/promo-codes/{id}
 */
export async function apiAppBusinessPromocodeUpsert(id: string, body: SavePromoCodeRequest, config: ApiConfig & { raw: true }): Promise<PromoCodeApiResponse>;
export async function apiAppBusinessPromocodeUpsert(id: string, body: SavePromoCodeRequest, config?: ApiConfig): Promise<PromoCode>;
export async function apiAppBusinessPromocodeUpsert(id: string, body: SavePromoCodeRequest, config?: ApiConfig): Promise<PromoCode | PromoCodeApiResponse> {
	const res = await getApi().post<PromoCodeApiResponse>(`/business/promo-codes/${id}`, body, config);
	return config?.raw ? res.data : hydratePromoCode(res.data);
}

/**
 * DELETE /business/promo-codes/{id}
 */
export async function apiAppBusinessPromocodeDelete(id: string, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/business/promo-codes/${id}`, config);
}

/**
 * DELETE /business/promo-codes
 */
export async function apiAppBusinessPromocodeDeletebulk(body: BulkDeletePromoCodeRequest, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/business/promo-codes`, { ...config, data: body });
}

/**
 * PATCH /business/promo-codes/active
 */
export async function apiAppBusinessPromocodeToggleactivebulk(body: BulkTogglePromoCodeRequest, config?: ApiConfig): Promise<void> {
	await getApi().patch(`/business/promo-codes/active`, body, config);
}

/**
 * GET /business/promo-codes
 */
export async function apiAppBusinessPromocodeList(config: ApiConfig & { raw: true }): Promise<PromoCodeListApiResponse>;
export async function apiAppBusinessPromocodeList(config?: ApiConfig): Promise<PromoCodeList>;
export async function apiAppBusinessPromocodeList(config?: ApiConfig): Promise<PromoCodeList | PromoCodeListApiResponse> {
	const res = await getApi().get<PromoCodeListApiResponse>(`/business/promo-codes`, config);
	return config?.raw ? res.data : hydratePromoCodeList(res.data);
}

/**
 * POST /business/session/{id}
 */
export async function apiAppBusinessSessionUpsert(id: string, body: SaveSessionRequest, config: ApiConfig & { raw: true }): Promise<SessionApiResponse>;
export async function apiAppBusinessSessionUpsert(id: string, body: SaveSessionRequest, config?: ApiConfig): Promise<Session>;
export async function apiAppBusinessSessionUpsert(id: string, body: SaveSessionRequest, config?: ApiConfig): Promise<Session | SessionApiResponse> {
	const res = await getApi().post<SessionApiResponse>(`/business/session/${id}`, body, config);
	return config?.raw ? res.data : hydrateSession(res.data);
}

/**
 * DELETE /business/session/{id}
 */
export async function apiAppBusinessSessionDelete(id: string, config: ApiConfig & { raw: true }): Promise<SessionApiResponse>;
export async function apiAppBusinessSessionDelete(id: string, config?: ApiConfig): Promise<Session>;
export async function apiAppBusinessSessionDelete(id: string, config?: ApiConfig): Promise<Session | SessionApiResponse> {
	const res = await getApi().delete<SessionApiResponse>(`/business/session/${id}`, config);
	return config?.raw ? res.data : hydrateSession(res.data);
}

/**
 * GET /business/session
 */
export async function apiAppBusinessSessionList(config: ApiConfig & { raw: true }): Promise<SessionListApiResponse>;
export async function apiAppBusinessSessionList(config?: ApiConfig): Promise<SessionList>;
export async function apiAppBusinessSessionList(config?: ApiConfig): Promise<SessionList | SessionListApiResponse> {
	const res = await getApi().get<SessionListApiResponse>(`/business/session`, config);
	return config?.raw ? res.data : hydrateSessionList(res.data);
}

/**
 * GET /business/sms-settings
 */
export async function apiAppBusinessSmssettingsGetsmssettings(config: ApiConfig & { raw: true }): Promise<SmsSettingsApiResponse>;
export async function apiAppBusinessSmssettingsGetsmssettings(config?: ApiConfig): Promise<SmsSettings>;
export async function apiAppBusinessSmssettingsGetsmssettings(config?: ApiConfig): Promise<SmsSettings | SmsSettingsApiResponse> {
	const res = await getApi().get<SmsSettingsApiResponse>(`/business/sms-settings`, config);
	return config?.raw ? res.data : hydrateSmsSettings(res.data);
}

/**
 * POST /business/sms-settings
 */
export async function apiAppBusinessSmssettingsPostsmssettings(body: SaveSmsSettingsRequest, config: ApiConfig & { raw: true }): Promise<SmsSettingsApiResponse>;
export async function apiAppBusinessSmssettingsPostsmssettings(body: SaveSmsSettingsRequest, config?: ApiConfig): Promise<SmsSettings>;
export async function apiAppBusinessSmssettingsPostsmssettings(body: SaveSmsSettingsRequest, config?: ApiConfig): Promise<SmsSettings | SmsSettingsApiResponse> {
	const res = await getApi().post<SmsSettingsApiResponse>(`/business/sms-settings`, body, config);
	return config?.raw ? res.data : hydrateSmsSettings(res.data);
}

/**
 * POST /business/sms-settings/manual-refill
 */
export async function apiAppBusinessSmssettingsPostmanualrefill(body: ManualRefillSmsRequest, config: ApiConfig & { raw: true }): Promise<SmsManualRefillApiResponse>;
export async function apiAppBusinessSmssettingsPostmanualrefill(body: ManualRefillSmsRequest, config?: ApiConfig): Promise<SmsManualRefill>;
export async function apiAppBusinessSmssettingsPostmanualrefill(body: ManualRefillSmsRequest, config?: ApiConfig): Promise<SmsManualRefill | SmsManualRefillApiResponse> {
	const res = await getApi().post<SmsManualRefillApiResponse>(`/business/sms-settings/manual-refill`, body, config);
	return config?.raw ? res.data : hydrateSmsManualRefill(res.data);
}

/**
 * POST /business/sms-settings/admin-refill
 */
export async function apiAppBusinessSmssettingsPostsmscredits(body: AdminRefillSmsRequest, config: ApiConfig & { raw: true }): Promise<SmsSettingsApiResponse>;
export async function apiAppBusinessSmssettingsPostsmscredits(body: AdminRefillSmsRequest, config?: ApiConfig): Promise<SmsSettings>;
export async function apiAppBusinessSmssettingsPostsmscredits(body: AdminRefillSmsRequest, config?: ApiConfig): Promise<SmsSettings | SmsSettingsApiResponse> {
	const res = await getApi().post<SmsSettingsApiResponse>(`/business/sms-settings/admin-refill`, body, config);
	return config?.raw ? res.data : hydrateSmsSettings(res.data);
}

/**
 * GET /business/sms-settings/refills
 */
export async function apiAppBusinessSmssettingsListrefills(config: ApiConfig & { raw: true }): Promise<SmsRefillListApiResponse>;
export async function apiAppBusinessSmssettingsListrefills(config?: ApiConfig): Promise<SmsRefillList>;
export async function apiAppBusinessSmssettingsListrefills(config?: ApiConfig): Promise<SmsRefillList | SmsRefillListApiResponse> {
	const res = await getApi().get<SmsRefillListApiResponse>(`/business/sms-settings/refills`, config);
	return config?.raw ? res.data : hydrateSmsRefillList(res.data);
}

/**
 * POST /business/sms-settings/cancel-refill/{id}
 */
export async function apiAppBusinessSmssettingsCancelrefill(id: number, config: ApiConfig & { raw: true }): Promise<SmsCancelRefillApiResponse>;
export async function apiAppBusinessSmssettingsCancelrefill(id: number, config?: ApiConfig): Promise<SmsCancelRefill>;
export async function apiAppBusinessSmssettingsCancelrefill(id: number, config?: ApiConfig): Promise<SmsCancelRefill | SmsCancelRefillApiResponse> {
	const res = await getApi().post<SmsCancelRefillApiResponse>(`/business/sms-settings/cancel-refill/${id}`, config);
	return config?.raw ? res.data : hydrateSmsCancelRefill(res.data);
}

/**
 * POST /business/sms-settings/sms-sent/search
 */
export async function apiAppBusinessSmssettingsSearchemails(body: BusinessSmsSearchRequest, config: ApiConfig & { raw: true }): Promise<SmsSentSearchApiResponse>;
export async function apiAppBusinessSmssettingsSearchemails(body: BusinessSmsSearchRequest, config?: ApiConfig): Promise<SmsSentSearch>;
export async function apiAppBusinessSmssettingsSearchemails(body: BusinessSmsSearchRequest, config?: ApiConfig): Promise<SmsSentSearch | SmsSentSearchApiResponse> {
	const res = await getApi().post<SmsSentSearchApiResponse>(`/business/sms-settings/sms-sent/search`, body, config);
	return config?.raw ? res.data : hydrateSmsSentSearch(res.data);
}

/**
 * POST /business/widget/{id}
 */
export async function apiAppBusinessWidgetPostwidgetconfigbyid(id: number, body: UpdateWidgetRequest, config: ApiConfig & { raw: true }): Promise<WidgetApiResponse>;
export async function apiAppBusinessWidgetPostwidgetconfigbyid(id: number, body: UpdateWidgetRequest, config?: ApiConfig): Promise<Widget>;
export async function apiAppBusinessWidgetPostwidgetconfigbyid(id: number, body: UpdateWidgetRequest, config?: ApiConfig): Promise<Widget | WidgetApiResponse> {
	const res = await getApi().post<WidgetApiResponse>(`/business/widget/${id}`, body, config);
	return config?.raw ? res.data : hydrateWidget(res.data);
}

/**
 * POST /business/widget
 */
export async function apiAppBusinessWidgetCreatewidget(config: ApiConfig & { raw: true }): Promise<WidgetApiResponse>;
export async function apiAppBusinessWidgetCreatewidget(config?: ApiConfig): Promise<Widget>;
export async function apiAppBusinessWidgetCreatewidget(config?: ApiConfig): Promise<Widget | WidgetApiResponse> {
	const res = await getApi().post<WidgetApiResponse>(`/business/widget`, config);
	return config?.raw ? res.data : hydrateWidget(res.data);
}

/**
 * DELETE /business/widget/{id}
 */
export async function apiAppBusinessWidgetDeletewidget(id: number, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/business/widget/${id}`, config);
}

/**
 * GET /dashboard/stats
 */
export async function apiAppDashboardStatsGetstats(params: DashboardStatsRequest | undefined, config: ApiConfig & { raw: true }): Promise<DashboardStatsApiResponse>;
export async function apiAppDashboardStatsGetstats(params?: DashboardStatsRequest, config?: ApiConfig): Promise<DashboardStats>;
export async function apiAppDashboardStatsGetstats(params?: DashboardStatsRequest, config?: ApiConfig): Promise<DashboardStats | DashboardStatsApiResponse> {
	const res = await getApi().get<DashboardStatsApiResponse>(`/dashboard/stats`, { params, ...config });
	return config?.raw ? res.data : hydrateDashboardStats(res.data);
}

/**
 * POST /dashboard/stats/export/bookings
 */
export async function apiAppDashboardStatsExportbookings(body: DashboardStatsExportBookingsRequest, config: ApiConfig & { raw: true }): Promise<DashboardStatsExportBookingsApiResponse>;
export async function apiAppDashboardStatsExportbookings(body: DashboardStatsExportBookingsRequest, config?: ApiConfig): Promise<DashboardStatsExportBookings>;
export async function apiAppDashboardStatsExportbookings(body: DashboardStatsExportBookingsRequest, config?: ApiConfig): Promise<DashboardStatsExportBookings | DashboardStatsExportBookingsApiResponse> {
	const res = await getApi().post<DashboardStatsExportBookingsApiResponse>(`/dashboard/stats/export/bookings`, body, config);
	return config?.raw ? res.data : hydrateDashboardStatsExportBookings(res.data);
}

/**
 * POST /feedback
 */
export async function apiAppFeedbackSharefeedback(body: ShareFeedbackRequest, config: ApiConfig & { raw: true }): Promise<FeedbackApiResponse>;
export async function apiAppFeedbackSharefeedback(body: ShareFeedbackRequest, config?: ApiConfig): Promise<Feedback>;
export async function apiAppFeedbackSharefeedback(body: ShareFeedbackRequest, config?: ApiConfig): Promise<Feedback | FeedbackApiResponse> {
	const res = await getApi().post<FeedbackApiResponse>(`/feedback`, body, config);
	return config?.raw ? res.data : hydrateFeedback(res.data);
}

/**
 * POST /giftcard/bookable
 */
export async function apiAppGiftcardGiftcardbookableNewbookablegiftcard(body: SaveBookableGiftcardRequest, config: ApiConfig & { raw: true }): Promise<BookableGiftcardApiResponse>;
export async function apiAppGiftcardGiftcardbookableNewbookablegiftcard(body: SaveBookableGiftcardRequest, config?: ApiConfig): Promise<BookableGiftcard>;
export async function apiAppGiftcardGiftcardbookableNewbookablegiftcard(body: SaveBookableGiftcardRequest, config?: ApiConfig): Promise<BookableGiftcard | BookableGiftcardApiResponse> {
	const res = await getApi().post<BookableGiftcardApiResponse>(`/giftcard/bookable`, body, config);
	return config?.raw ? res.data : hydrateBookableGiftcard(res.data);
}

/**
 * GET /giftcard/bookable/{id}
 */
export async function apiAppGiftcardGiftcardbookableGetbookablegiftcard(id: string, config: ApiConfig & { raw: true }): Promise<BookableGiftcardApiResponse>;
export async function apiAppGiftcardGiftcardbookableGetbookablegiftcard(id: string, config?: ApiConfig): Promise<BookableGiftcard>;
export async function apiAppGiftcardGiftcardbookableGetbookablegiftcard(id: string, config?: ApiConfig): Promise<BookableGiftcard | BookableGiftcardApiResponse> {
	const res = await getApi().get<BookableGiftcardApiResponse>(`/giftcard/bookable/${id}`, config);
	return config?.raw ? res.data : hydrateBookableGiftcard(res.data);
}

/**
 * GET /giftcard/bookable
 */
export async function apiAppGiftcardGiftcardbookableGetbookablegiftcards(config: ApiConfig & { raw: true }): Promise<GiftcardBookableListApiResponse>;
export async function apiAppGiftcardGiftcardbookableGetbookablegiftcards(config?: ApiConfig): Promise<GiftcardBookableList>;
export async function apiAppGiftcardGiftcardbookableGetbookablegiftcards(config?: ApiConfig): Promise<GiftcardBookableList | GiftcardBookableListApiResponse> {
	const res = await getApi().get<GiftcardBookableListApiResponse>(`/giftcard/bookable`, config);
	return config?.raw ? res.data : hydrateGiftcardBookableList(res.data);
}

/**
 * DELETE /giftcard/bookable/{id}
 */
export async function apiAppGiftcardGiftcardbookableDeletebookablegiftcard(id: string, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/giftcard/bookable/${id}`, config);
}

/**
 * POST /giftcard
 */
export async function apiAppGiftcardGiftcardCreategiftcard(body: CreateGiftcardRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/giftcard`, body, config);
}

/**
 * POST /giftcard/search
 */
export async function apiAppGiftcardGiftcardGetgiftcards(body: GiftcardSearchRequest, config: ApiConfig & { raw: true }): Promise<GiftcardSearchApiResponse>;
export async function apiAppGiftcardGiftcardGetgiftcards(body: GiftcardSearchRequest, config?: ApiConfig): Promise<GiftcardSearch>;
export async function apiAppGiftcardGiftcardGetgiftcards(body: GiftcardSearchRequest, config?: ApiConfig): Promise<GiftcardSearch | GiftcardSearchApiResponse> {
	const res = await getApi().post<GiftcardSearchApiResponse>(`/giftcard/search`, body, config);
	return config?.raw ? res.data : hydrateGiftcardSearch(res.data);
}

/**
 * POST /giftcard/{giftcardId}/consume
 */
export async function apiAppGiftcardGiftcardConsumegiftcard(giftcardId: string, body: ConsumeGiftcardRequest, config: ApiConfig & { raw: true }): Promise<PaymentApiResponse>;
export async function apiAppGiftcardGiftcardConsumegiftcard(giftcardId: string, body: ConsumeGiftcardRequest, config?: ApiConfig): Promise<Payment>;
export async function apiAppGiftcardGiftcardConsumegiftcard(giftcardId: string, body: ConsumeGiftcardRequest, config?: ApiConfig): Promise<Payment | PaymentApiResponse> {
	const res = await getApi().post<PaymentApiResponse>(`/giftcard/${giftcardId}/consume`, body, config);
	return config?.raw ? res.data : hydratePayment(res.data);
}

/**
 * POST /giftcard/{giftcardId}/recredit
 */
export async function apiAppGiftcardGiftcardRecreditgiftcard(giftcardId: string, body: RecreditGiftcardRequest, config: ApiConfig & { raw: true }): Promise<PaymentApiResponse>;
export async function apiAppGiftcardGiftcardRecreditgiftcard(giftcardId: string, body: RecreditGiftcardRequest, config?: ApiConfig): Promise<Payment>;
export async function apiAppGiftcardGiftcardRecreditgiftcard(giftcardId: string, body: RecreditGiftcardRequest, config?: ApiConfig): Promise<Payment | PaymentApiResponse> {
	const res = await getApi().post<PaymentApiResponse>(`/giftcard/${giftcardId}/recredit`, body, config);
	return config?.raw ? res.data : hydratePayment(res.data);
}

/**
 * DELETE /giftcard/{giftcardId}
 */
export async function apiAppGiftcardGiftcardDeletegiftcard(giftcardId: string, body: DeleteGiftcardRequest, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/giftcard/${giftcardId}`, { ...config, data: body });
}

/**
 * GET /giftcard/stats
 */
export async function apiAppGiftcardGiftcardGetgiftcardstats(config: ApiConfig & { raw: true }): Promise<GiftcardStatsApiResponse>;
export async function apiAppGiftcardGiftcardGetgiftcardstats(config?: ApiConfig): Promise<GiftcardStats>;
export async function apiAppGiftcardGiftcardGetgiftcardstats(config?: ApiConfig): Promise<GiftcardStats | GiftcardStatsApiResponse> {
	const res = await getApi().get<GiftcardStatsApiResponse>(`/giftcard/stats`, config);
	return config?.raw ? res.data : hydrateGiftcardStats(res.data);
}

/**
 * PATCH /giftcard/{giftcardId}
 */
export async function apiAppGiftcardGiftcardUpdategiftcard(giftcardId: string, body: UpdateGiftcardRequest, config: ApiConfig & { raw: true }): Promise<GiftcardApiResponse>;
export async function apiAppGiftcardGiftcardUpdategiftcard(giftcardId: string, body: UpdateGiftcardRequest, config?: ApiConfig): Promise<Giftcard>;
export async function apiAppGiftcardGiftcardUpdategiftcard(giftcardId: string, body: UpdateGiftcardRequest, config?: ApiConfig): Promise<Giftcard | GiftcardApiResponse> {
	const res = await getApi().patch<GiftcardApiResponse>(`/giftcard/${giftcardId}`, body, config);
	return config?.raw ? res.data : hydrateGiftcard(res.data);
}

/**
 * POST /giftcard/{giftcardId}/resend-email
 */
export async function apiAppGiftcardGiftcardResendemail(giftcardId: string, config?: ApiConfig): Promise<void> {
	await getApi().post(`/giftcard/${giftcardId}/resend-email`, config);
}

/**
 * POST /google/calendar/list
 */
export async function apiAppGoogleGooglecalendarListcalendars(config: ApiConfig & { raw: true }): Promise<GoogleCalendarListApiResponse>;
export async function apiAppGoogleGooglecalendarListcalendars(config?: ApiConfig): Promise<GoogleCalendarList>;
export async function apiAppGoogleGooglecalendarListcalendars(config?: ApiConfig): Promise<GoogleCalendarList | GoogleCalendarListApiResponse> {
	const res = await getApi().post<GoogleCalendarListApiResponse>(`/google/calendar/list`, config);
	return config?.raw ? res.data : hydrateGoogleCalendarList(res.data);
}

/**
 * POST /google/calendar/watch
 */
export async function apiAppGoogleGooglecalendarWatch(body: WatchGoogleCalendarRequest, config: ApiConfig & { raw: true }): Promise<GoogleCalendarApiResponse>;
export async function apiAppGoogleGooglecalendarWatch(body: WatchGoogleCalendarRequest, config?: ApiConfig): Promise<GoogleCalendar>;
export async function apiAppGoogleGooglecalendarWatch(body: WatchGoogleCalendarRequest, config?: ApiConfig): Promise<GoogleCalendar | GoogleCalendarApiResponse> {
	const res = await getApi().post<GoogleCalendarApiResponse>(`/google/calendar/watch`, body, config);
	return config?.raw ? res.data : hydrateGoogleCalendar(res.data);
}

/**
 * DELETE /google/calendar/watch/{id}
 */
export async function apiAppGoogleGooglecalendarDeletewatch(id: number, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/google/calendar/watch/${id}`, config);
}

/**
 * POST /google/calendar/token
 */
export async function apiAppGoogleGooglecalendarGeneratepublictoken(config: ApiConfig & { raw: true }): Promise<GoogleCalendarTokenApiResponse>;
export async function apiAppGoogleGooglecalendarGeneratepublictoken(config?: ApiConfig): Promise<GoogleCalendarToken>;
export async function apiAppGoogleGooglecalendarGeneratepublictoken(config?: ApiConfig): Promise<GoogleCalendarToken | GoogleCalendarTokenApiResponse> {
	const res = await getApi().post<GoogleCalendarTokenApiResponse>(`/google/calendar/token`, config);
	return config?.raw ? res.data : hydrateGoogleCalendarToken(res.data);
}

/**
 * POST /google/calendar/send-bookings
 */
export async function apiAppGoogleGooglecalendarSendbookings(body: SendGoogleBookingsRequest, config: ApiConfig & { raw: true }): Promise<AreaApiResponse>;
export async function apiAppGoogleGooglecalendarSendbookings(body: SendGoogleBookingsRequest, config?: ApiConfig): Promise<Area>;
export async function apiAppGoogleGooglecalendarSendbookings(body: SendGoogleBookingsRequest, config?: ApiConfig): Promise<Area | AreaApiResponse> {
	const res = await getApi().post<AreaApiResponse>(`/google/calendar/send-bookings`, body, config);
	return config?.raw ? res.data : hydrateArea(res.data);
}

/**
 * POST /google/calendar/send-future-bookings
 */
export async function apiAppGoogleGooglecalendarSendfuturebookings(body: SendFutureGoogleBookingsRequest, config: ApiConfig & { raw: true }): Promise<GoogleCalendarSendFutureBookingsApiResponse>;
export async function apiAppGoogleGooglecalendarSendfuturebookings(body: SendFutureGoogleBookingsRequest, config?: ApiConfig): Promise<GoogleCalendarSendFutureBookings>;
export async function apiAppGoogleGooglecalendarSendfuturebookings(body: SendFutureGoogleBookingsRequest, config?: ApiConfig): Promise<GoogleCalendarSendFutureBookings | GoogleCalendarSendFutureBookingsApiResponse> {
	const res = await getApi().post<GoogleCalendarSendFutureBookingsApiResponse>(`/google/calendar/send-future-bookings`, body, config);
	return config?.raw ? res.data : hydrateGoogleCalendarSendFutureBookings(res.data);
}

/**
 * POST /business/widget/{widgetId}/google/reserve
 */
export async function apiAppGoogleGooglefeedUpsert(widgetId: number, body: ToggleGoogleReserveRequest, config: ApiConfig & { raw: true }): Promise<WidgetGoogleReserveApiResponse>;
export async function apiAppGoogleGooglefeedUpsert(widgetId: number, body: ToggleGoogleReserveRequest, config?: ApiConfig): Promise<WidgetGoogleReserve>;
export async function apiAppGoogleGooglefeedUpsert(widgetId: number, body: ToggleGoogleReserveRequest, config?: ApiConfig): Promise<WidgetGoogleReserve | WidgetGoogleReserveApiResponse> {
	const res = await getApi().post<WidgetGoogleReserveApiResponse>(`/business/widget/${widgetId}/google/reserve`, body, config);
	return config?.raw ? res.data : hydrateWidgetGoogleReserve(res.data);
}

/**
 * GET /business/widget/{widgetId}/google/reserve
 */
export async function apiAppGoogleGooglefeedGet(widgetId: number, config: ApiConfig & { raw: true }): Promise<WidgetGoogleReserveApiResponse>;
export async function apiAppGoogleGooglefeedGet(widgetId: number, config?: ApiConfig): Promise<WidgetGoogleReserve>;
export async function apiAppGoogleGooglefeedGet(widgetId: number, config?: ApiConfig): Promise<WidgetGoogleReserve | WidgetGoogleReserveApiResponse> {
	const res = await getApi().get<WidgetGoogleReserveApiResponse>(`/business/widget/${widgetId}/google/reserve`, config);
	return config?.raw ? res.data : hydrateWidgetGoogleReserve(res.data);
}

/**
 * PUT /business/widget/{widgetId}/google/reserve/address
 */
export async function apiAppGoogleGooglefeedUpdateaddress(widgetId: number, body: UpdateGoogleReserveAddressRequest, config: ApiConfig & { raw: true }): Promise<WidgetGoogleReserveApiResponse>;
export async function apiAppGoogleGooglefeedUpdateaddress(widgetId: number, body: UpdateGoogleReserveAddressRequest, config?: ApiConfig): Promise<WidgetGoogleReserve>;
export async function apiAppGoogleGooglefeedUpdateaddress(widgetId: number, body: UpdateGoogleReserveAddressRequest, config?: ApiConfig): Promise<WidgetGoogleReserve | WidgetGoogleReserveApiResponse> {
	const res = await getApi().put<WidgetGoogleReserveApiResponse>(`/business/widget/${widgetId}/google/reserve/address`, body, config);
	return config?.raw ? res.data : hydrateWidgetGoogleReserve(res.data);
}

/**
 * POST /admin/google-feed
 */
export async function apiAppGoogleGooglefeedIndex(config: ApiConfig & { raw: true }): Promise<AdminGoogleFeedGenerateApiResponse>;
export async function apiAppGoogleGooglefeedIndex(config?: ApiConfig): Promise<AdminGoogleFeedGenerate>;
export async function apiAppGoogleGooglefeedIndex(config?: ApiConfig): Promise<AdminGoogleFeedGenerate | AdminGoogleFeedGenerateApiResponse> {
	const res = await getApi().post<AdminGoogleFeedGenerateApiResponse>(`/admin/google-feed`, config);
	return config?.raw ? res.data : hydrateAdminGoogleFeedGenerate(res.data);
}

/**
 * POST /admin/google-reserve/disabler
 */
export async function apiAppGoogleGooglefeedDisablenonbookablebusinesses(config: ApiConfig & { raw: true }): Promise<AdminGoogleReserveDisableApiResponse>;
export async function apiAppGoogleGooglefeedDisablenonbookablebusinesses(config?: ApiConfig): Promise<AdminGoogleReserveDisable>;
export async function apiAppGoogleGooglefeedDisablenonbookablebusinesses(config?: ApiConfig): Promise<AdminGoogleReserveDisable | AdminGoogleReserveDisableApiResponse> {
	const res = await getApi().post<AdminGoogleReserveDisableApiResponse>(`/admin/google-reserve/disabler`, config);
	return config?.raw ? res.data : hydrateAdminGoogleReserveDisable(res.data);
}

/**
 * POST /notification/search
 */
export async function apiAppNotificationNotificationGetnotifications(body: NotificationSearchRequest, config: ApiConfig & { raw: true }): Promise<NotificationSearchApiResponse>;
export async function apiAppNotificationNotificationGetnotifications(body: NotificationSearchRequest, config?: ApiConfig): Promise<NotificationSearch>;
export async function apiAppNotificationNotificationGetnotifications(body: NotificationSearchRequest, config?: ApiConfig): Promise<NotificationSearch | NotificationSearchApiResponse> {
	const res = await getApi().post<NotificationSearchApiResponse>(`/notification/search`, body, config);
	return config?.raw ? res.data : hydrateNotificationSearch(res.data);
}

/**
 * POST /notification/read
 */
export async function apiAppNotificationNotificationMarkasread(body: MarkNotificationReadRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/notification/read`, body, config);
}

/**
 * POST /notification/unread
 */
export async function apiAppNotificationNotificationMarkasunread(body: MarkNotificationUnreadRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/notification/unread`, body, config);
}

/**
 * GET /notification/stats
 */
export async function apiAppNotificationNotificationGetstats(config: ApiConfig & { raw: true }): Promise<NotificationStatsApiResponse>;
export async function apiAppNotificationNotificationGetstats(config?: ApiConfig): Promise<NotificationStats>;
export async function apiAppNotificationNotificationGetstats(config?: ApiConfig): Promise<NotificationStats | NotificationStatsApiResponse> {
	const res = await getApi().get<NotificationStatsApiResponse>(`/notification/stats`, config);
	return config?.raw ? res.data : hydrateNotificationStats(res.data);
}

/**
 * POST /push-notification/token
 */
export async function apiPostToken(body: PostDeviceTokenRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/push-notification/token`, body, config);
}

/**
 * DELETE /push-notification/token
 */
export async function apiDeleteTokens(body: DeleteDeviceTokensRequest, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/push-notification/token`, { ...config, data: body });
}

/**
 * POST /push-notification/test
 */
export async function apiPushTest(body: PushTestRequest, config: ApiConfig & { raw: true }): Promise<PushNotificationTestApiResponse>;
export async function apiPushTest(body: PushTestRequest, config?: ApiConfig): Promise<PushNotificationTest>;
export async function apiPushTest(body: PushTestRequest, config?: ApiConfig): Promise<PushNotificationTest | PushNotificationTestApiResponse> {
	const res = await getApi().post<PushNotificationTestApiResponse>(`/push-notification/test`, body, config);
	return config?.raw ? res.data : hydratePushNotificationTest(res.data);
}

/**
 * GET /socket/token
 */
export async function apiSocketToken(config: ApiConfig & { raw: true }): Promise<SocketTokenApiResponse>;
export async function apiSocketToken(config?: ApiConfig): Promise<SocketToken>;
export async function apiSocketToken(config?: ApiConfig): Promise<SocketToken | SocketTokenApiResponse> {
	const res = await getApi().get<SocketTokenApiResponse>(`/socket/token`, config);
	return config?.raw ? res.data : hydrateSocketToken(res.data);
}

/**
 * GET /business/payment/stripe-connect/register
 */
export async function apiAppPaymentStripeconnectStartregistration(config: ApiConfig & { raw: true }): Promise<StripeConnectRegisterApiResponse>;
export async function apiAppPaymentStripeconnectStartregistration(config?: ApiConfig): Promise<StripeConnectRegister>;
export async function apiAppPaymentStripeconnectStartregistration(config?: ApiConfig): Promise<StripeConnectRegister | StripeConnectRegisterApiResponse> {
	const res = await getApi().get<StripeConnectRegisterApiResponse>(`/business/payment/stripe-connect/register`, config);
	return config?.raw ? res.data : hydrateStripeConnectRegister(res.data);
}

/**
 * GET /business/payment/stripe-connect/session
 */
export async function apiAppPaymentStripeconnectCreatesession(config: ApiConfig & { raw: true }): Promise<StripeConnectSessionApiResponse>;
export async function apiAppPaymentStripeconnectCreatesession(config?: ApiConfig): Promise<StripeConnectSession>;
export async function apiAppPaymentStripeconnectCreatesession(config?: ApiConfig): Promise<StripeConnectSession | StripeConnectSessionApiResponse> {
	const res = await getApi().get<StripeConnectSessionApiResponse>(`/business/payment/stripe-connect/session`, config);
	return config?.raw ? res.data : hydrateStripeConnectSession(res.data);
}

/**
 * GET /business/payment/stripe-connect/status
 */
export async function apiAppPaymentStripeconnectGetstatus(config: ApiConfig & { raw: true }): Promise<StripeConnectStatusApiResponse>;
export async function apiAppPaymentStripeconnectGetstatus(config?: ApiConfig): Promise<StripeConnectStatus>;
export async function apiAppPaymentStripeconnectGetstatus(config?: ApiConfig): Promise<StripeConnectStatus | StripeConnectStatusApiResponse> {
	const res = await getApi().get<StripeConnectStatusApiResponse>(`/business/payment/stripe-connect/status`, config);
	return config?.raw ? res.data : hydrateStripeConnectStatus(res.data);
}

/**
 * GET /public/qr-code/{token}/{date}
 */
export async function apiAppQrcodeGetscans(token: string, date: string, config: ApiConfig & { raw: true }): Promise<PublicQrCodeApiResponse>;
export async function apiAppQrcodeGetscans(token: string, date: string, config?: ApiConfig): Promise<PublicQrCode>;
export async function apiAppQrcodeGetscans(token: string, date: string, config?: ApiConfig): Promise<PublicQrCode | PublicQrCodeApiResponse> {
	const res = await getApi().get<PublicQrCodeApiResponse>(`/public/qr-code/${token}/${date}`, config);
	return config?.raw ? res.data : hydratePublicQrCode(res.data);
}

/**
 * POST /public/qr-code/{token}
 */
export async function apiAppQrcodeScan(token: string, body: ScanQrCodeRequest, config: ApiConfig & { raw: true }): Promise<QrCodeScanApiResponse>;
export async function apiAppQrcodeScan(token: string, body: ScanQrCodeRequest, config?: ApiConfig): Promise<QrCodeScan>;
export async function apiAppQrcodeScan(token: string, body: ScanQrCodeRequest, config?: ApiConfig): Promise<QrCodeScan | QrCodeScanApiResponse> {
	const res = await getApi().post<QrCodeScanApiResponse>(`/public/qr-code/${token}`, body, config);
	return config?.raw ? res.data : hydrateQrCodeScan(res.data);
}

/**
 * GET /qr-code/public-token
 */
export async function apiAppQrcodeGeneratepublictoken(config: ApiConfig & { raw: true }): Promise<PublicTokenApiResponse>;
export async function apiAppQrcodeGeneratepublictoken(config?: ApiConfig): Promise<PublicToken>;
export async function apiAppQrcodeGeneratepublictoken(config?: ApiConfig): Promise<PublicToken | PublicTokenApiResponse> {
	const res = await getApi().get<PublicTokenApiResponse>(`/qr-code/public-token`, config);
	return config?.raw ? res.data : hydratePublicToken(res.data);
}

/**
 * POST /referral
 */
export async function apiAppReferralSharefeedback(body: ShareReferralRequest, config: ApiConfig & { raw: true }): Promise<ReferralApiResponse>;
export async function apiAppReferralSharefeedback(body: ShareReferralRequest, config?: ApiConfig): Promise<Referral>;
export async function apiAppReferralSharefeedback(body: ShareReferralRequest, config?: ApiConfig): Promise<Referral | ReferralApiResponse> {
	const res = await getApi().post<ReferralApiResponse>(`/referral`, body, config);
	return config?.raw ? res.data : hydrateReferral(res.data);
}

/**
 * POST /registration/business
 */
export async function apiAppRegistrationCreatebusiness(body: CreateBusinessRequest, config: ApiConfig & { raw: true }): Promise<BusinessApiResponse>;
export async function apiAppRegistrationCreatebusiness(body: CreateBusinessRequest, config?: ApiConfig): Promise<Business>;
export async function apiAppRegistrationCreatebusiness(body: CreateBusinessRequest, config?: ApiConfig): Promise<Business | BusinessApiResponse> {
	const res = await getApi().post<BusinessApiResponse>(`/registration/business`, body, config);
	return config?.raw ? res.data : hydrateBusiness(res.data);
}

/**
 * POST /registration/email-exist
 */
export async function apiAppRegistrationEmailexist(body: CheckEmailExistRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/registration/email-exist`, body, config);
}

/**
 * GET /registration/logos
 */
export async function apiAppRegistrationGetlogos(config: ApiConfig & { raw: true }): Promise<RegistrationLogoListApiResponse>;
export async function apiAppRegistrationGetlogos(config?: ApiConfig): Promise<RegistrationLogoList>;
export async function apiAppRegistrationGetlogos(config?: ApiConfig): Promise<RegistrationLogoList | RegistrationLogoListApiResponse> {
	const res = await getApi().get<RegistrationLogoListApiResponse>(`/registration/logos`, config);
	return config?.raw ? res.data : hydrateRegistrationLogoList(res.data);
}

/**
 * GET /public/reservation-list/{token}/{date}
 */
export async function apiAppReservationlistGetreservations(token: string, date: string, config: ApiConfig & { raw: true }): Promise<PublicReservationListApiResponse>;
export async function apiAppReservationlistGetreservations(token: string, date: string, config?: ApiConfig): Promise<PublicReservationList>;
export async function apiAppReservationlistGetreservations(token: string, date: string, config?: ApiConfig): Promise<PublicReservationList | PublicReservationListApiResponse> {
	const res = await getApi().get<PublicReservationListApiResponse>(`/public/reservation-list/${token}/${date}`, config);
	return config?.raw ? res.data : hydratePublicReservationList(res.data);
}

/**
 * POST /reservation-list/public-token
 */
export async function apiAppReservationlistGeneratepublictoken(config: ApiConfig & { raw: true }): Promise<PublicTokenApiResponse>;
export async function apiAppReservationlistGeneratepublictoken(config?: ApiConfig): Promise<PublicToken>;
export async function apiAppReservationlistGeneratepublictoken(config?: ApiConfig): Promise<PublicToken | PublicTokenApiResponse> {
	const res = await getApi().post<PublicTokenApiResponse>(`/reservation-list/public-token`, config);
	return config?.raw ? res.data : hydratePublicToken(res.data);
}

/**
 * POST /business/agenda-settings
 */
export async function apiAppSettingsAgendasettingUpsert(body: SaveAgendaSettingsRequest, config: ApiConfig & { raw: true }): Promise<AgendaSettingApiResponse>;
export async function apiAppSettingsAgendasettingUpsert(body: SaveAgendaSettingsRequest, config?: ApiConfig): Promise<AgendaSetting>;
export async function apiAppSettingsAgendasettingUpsert(body: SaveAgendaSettingsRequest, config?: ApiConfig): Promise<AgendaSetting | AgendaSettingApiResponse> {
	const res = await getApi().post<AgendaSettingApiResponse>(`/business/agenda-settings`, body, config);
	return config?.raw ? res.data : hydrateAgendaSetting(res.data);
}

/**
 * GET /business/agenda-settings
 */
export async function apiAppSettingsAgendasettingGet(config: ApiConfig & { raw: true }): Promise<AgendaSettingApiResponse>;
export async function apiAppSettingsAgendasettingGet(config?: ApiConfig): Promise<AgendaSetting>;
export async function apiAppSettingsAgendasettingGet(config?: ApiConfig): Promise<AgendaSetting | AgendaSettingApiResponse> {
	const res = await getApi().get<AgendaSettingApiResponse>(`/business/agenda-settings`, config);
	return config?.raw ? res.data : hydrateAgendaSetting(res.data);
}

/**
 * POST /feature-flipping
 */
export async function apiAppSettingsFeatureflippingFlip(body: FlipFeaturesRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/feature-flipping`, body, config);
}

/**
 * GET /feature-flipping
 */
export async function apiAppSettingsFeatureflippingRead(config: ApiConfig & { raw: true }): Promise<FeatureFlippingApiResponse>;
export async function apiAppSettingsFeatureflippingRead(config?: ApiConfig): Promise<FeatureFlipping>;
export async function apiAppSettingsFeatureflippingRead(config?: ApiConfig): Promise<FeatureFlipping | FeatureFlippingApiResponse> {
	const res = await getApi().get<FeatureFlippingApiResponse>(`/feature-flipping`, config);
	return config?.raw ? res.data : hydrateFeatureFlipping(res.data);
}

/**
 * POST /features/vote
 */
export async function apiAppSettingsFeaturesVote(body: FeatureVoteRequest, config: ApiConfig & { raw: true }): Promise<FeatureVoteApiResponse>;
export async function apiAppSettingsFeaturesVote(body: FeatureVoteRequest, config?: ApiConfig): Promise<FeatureVote>;
export async function apiAppSettingsFeaturesVote(body: FeatureVoteRequest, config?: ApiConfig): Promise<FeatureVote | FeatureVoteApiResponse> {
	const res = await getApi().post<FeatureVoteApiResponse>(`/features/vote`, body, config);
	return config?.raw ? res.data : hydrateFeatureVote(res.data);
}

/**
 * POST /features/analytics/click
 */
export async function apiAppSettingsFeaturesAnalyticclick(body: FeatureAnalyticClickRequest, config: ApiConfig & { raw: true }): Promise<FeatureAnalyticClickApiResponse>;
export async function apiAppSettingsFeaturesAnalyticclick(body: FeatureAnalyticClickRequest, config?: ApiConfig): Promise<FeatureAnalyticClick>;
export async function apiAppSettingsFeaturesAnalyticclick(body: FeatureAnalyticClickRequest, config?: ApiConfig): Promise<FeatureAnalyticClick | FeatureAnalyticClickApiResponse> {
	const res = await getApi().post<FeatureAnalyticClickApiResponse>(`/features/analytics/click`, body, config);
	return config?.raw ? res.data : hydrateFeatureAnalyticClick(res.data);
}

/**
 * POST /business/tags
 */
export async function apiAppSettingsTagUpsert(body: SaveTagRequest, config: ApiConfig & { raw: true }): Promise<TagApiResponse>;
export async function apiAppSettingsTagUpsert(body: SaveTagRequest, config?: ApiConfig): Promise<Tag>;
export async function apiAppSettingsTagUpsert(body: SaveTagRequest, config?: ApiConfig): Promise<Tag | TagApiResponse> {
	const res = await getApi().post<TagApiResponse>(`/business/tags`, body, config);
	return config?.raw ? res.data : hydrateTag(res.data);
}

/**
 * DELETE /business/tags/{label}
 */
export async function apiAppSettingsTagDelete(label: string, config: ApiConfig & { raw: true }): Promise<TagApiResponse>;
export async function apiAppSettingsTagDelete(label: string, config?: ApiConfig): Promise<Tag>;
export async function apiAppSettingsTagDelete(label: string, config?: ApiConfig): Promise<Tag | TagApiResponse> {
	const res = await getApi().delete<TagApiResponse>(`/business/tags/${label}`, config);
	return config?.raw ? res.data : hydrateTag(res.data);
}

/**
 * GET /business/tags
 */
export async function apiAppSettingsTagGet(config: ApiConfig & { raw: true }): Promise<TagApiResponse>;
export async function apiAppSettingsTagGet(config?: ApiConfig): Promise<Tag>;
export async function apiAppSettingsTagGet(config?: ApiConfig): Promise<Tag | TagApiResponse> {
	const res = await getApi().get<TagApiResponse>(`/business/tags`, config);
	return config?.raw ? res.data : hydrateTag(res.data);
}

/**
 * POST /settings/accept-terms
 */
export async function apiAppSettingsTermsAcceptterms(body: AcceptTermsRequest, config: ApiConfig & { raw: true }): Promise<BusinessApiResponse>;
export async function apiAppSettingsTermsAcceptterms(body: AcceptTermsRequest, config?: ApiConfig): Promise<Business>;
export async function apiAppSettingsTermsAcceptterms(body: AcceptTermsRequest, config?: ApiConfig): Promise<Business | BusinessApiResponse> {
	const res = await getApi().post<BusinessApiResponse>(`/settings/accept-terms`, body, config);
	return config?.raw ? res.data : hydrateBusiness(res.data);
}

/**
 * GET /hc.php
 */
export async function apiAppSystemAppHealthcheck(config?: ApiConfig): Promise<void> {
	await getApi().get(`/hc.php`, config);
}

/**
 * POST /upload
 */
export async function apiAppUploadUploadimage(body: UploadFileRequest, config: ApiConfig & { raw: true }): Promise<UploadAssetApiResponse>;
export async function apiAppUploadUploadimage(body: UploadFileRequest, config?: ApiConfig): Promise<UploadAsset>;
export async function apiAppUploadUploadimage(body: UploadFileRequest, config?: ApiConfig): Promise<UploadAsset | UploadAssetApiResponse> {
	const res = await getApi().post<UploadAssetApiResponse>(`/upload`, body, config);
	return config?.raw ? res.data : hydrateUploadAsset(res.data);
}

/**
 * POST /upload/document
 */
export async function apiAppUploadUploaddocument(body: UploadFileRequest, config: ApiConfig & { raw: true }): Promise<UploadDocumentApiResponse>;
export async function apiAppUploadUploaddocument(body: UploadFileRequest, config?: ApiConfig): Promise<UploadDocument>;
export async function apiAppUploadUploaddocument(body: UploadFileRequest, config?: ApiConfig): Promise<UploadDocument | UploadDocumentApiResponse> {
	const res = await getApi().post<UploadDocumentApiResponse>(`/upload/document`, body, config);
	return config?.raw ? res.data : hydrateUploadDocument(res.data);
}

/**
 * POST /public/upload/editorjs/{token}
 */
export async function apiAppUploadUploadeditorjs(token: string, body: UploadFileRequest, config: ApiConfig & { raw: true }): Promise<UploadEditorJsApiResponse>;
export async function apiAppUploadUploadeditorjs(token: string, body: UploadFileRequest, config?: ApiConfig): Promise<UploadEditorJs>;
export async function apiAppUploadUploadeditorjs(token: string, body: UploadFileRequest, config?: ApiConfig): Promise<UploadEditorJs | UploadEditorJsApiResponse> {
	const res = await getApi().post<UploadEditorJsApiResponse>(`/public/upload/editorjs/${token}`, body, config);
	return config?.raw ? res.data : hydrateUploadEditorJs(res.data);
}

/**
 * GET /upload/public-token
 */
export async function apiAppUploadGeneratepublictoken(config: ApiConfig & { raw: true }): Promise<UploadPublicTokenApiResponse>;
export async function apiAppUploadGeneratepublictoken(config?: ApiConfig): Promise<UploadPublicToken>;
export async function apiAppUploadGeneratepublictoken(config?: ApiConfig): Promise<UploadPublicToken | UploadPublicTokenApiResponse> {
	const res = await getApi().get<UploadPublicTokenApiResponse>(`/upload/public-token`, config);
	return config?.raw ? res.data : hydrateUploadPublicToken(res.data);
}

/**
 * GET /business/media
 */
export async function apiAppUploadGetmedialist(config: ApiConfig & { raw: true }): Promise<UploadMediaListApiResponse>;
export async function apiAppUploadGetmedialist(config?: ApiConfig): Promise<UploadMediaList>;
export async function apiAppUploadGetmedialist(config?: ApiConfig): Promise<UploadMediaList | UploadMediaListApiResponse> {
	const res = await getApi().get<UploadMediaListApiResponse>(`/business/media`, config);
	return config?.raw ? res.data : hydrateUploadMediaList(res.data);
}

/**
 * DELETE /business/media/{id}
 */
export async function apiAppUploadDeletemedia(id: number, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/business/media/${id}`, config);
}

/**
 * POST /business/media/{id}/replace
 */
export async function apiAppUploadReplacemedia(id: number, body: UploadFileRequest, config: ApiConfig & { raw: true }): Promise<UploadAssetApiResponse>;
export async function apiAppUploadReplacemedia(id: number, body: UploadFileRequest, config?: ApiConfig): Promise<UploadAsset>;
export async function apiAppUploadReplacemedia(id: number, body: UploadFileRequest, config?: ApiConfig): Promise<UploadAsset | UploadAssetApiResponse> {
	const res = await getApi().post<UploadAssetApiResponse>(`/business/media/${id}/replace`, body, config);
	return config?.raw ? res.data : hydrateUploadAsset(res.data);
}

/**
 * GET /shrinker/{token}
 */
export async function apiAppUrlshrinkerRedirectfromtoken(token: string, config?: ApiConfig): Promise<string> {
	const res = await getApi().get<string>(`/shrinker/${token}`, config);
	return res.data;
}

/**
 * POST /public/lead-demo
 */
export async function apiPublicLeadDemo(body: PublicLeadDemoRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/public/lead-demo`, body, config);
}

/**
 * POST /public/lead-pricing
 */
export async function apiPublicLeadPricing(body: PublicLeadPricingRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/public/lead-pricing`, body, config);
}

/**
 * POST /widget/{hash}/auth/jws
 */
export async function apiWidgetAuthJwsLogin(hash: string, body: JwsLoginRequest, config: ApiConfig & { raw: true }): Promise<WidgetMemberApiResponse>;
export async function apiWidgetAuthJwsLogin(hash: string, body: JwsLoginRequest, config?: ApiConfig): Promise<WidgetMember>;
export async function apiWidgetAuthJwsLogin(hash: string, body: JwsLoginRequest, config?: ApiConfig): Promise<WidgetMember | WidgetMemberApiResponse> {
	const res = await getApi().post<WidgetMemberApiResponse>(`/widget/${hash}/auth/jws`, body, config);
	return config?.raw ? res.data : hydrateWidgetMember(res.data);
}

/**
 * POST /widget/{hash}/auth/logout
 */
export async function apiWidgetAuthJwsLogout(hash: string, config: ApiConfig & { raw: true }): Promise<AuthLogoutApiResponse>;
export async function apiWidgetAuthJwsLogout(hash: string, config?: ApiConfig): Promise<AuthLogout>;
export async function apiWidgetAuthJwsLogout(hash: string, config?: ApiConfig): Promise<AuthLogout | AuthLogoutApiResponse> {
	const res = await getApi().post<AuthLogoutApiResponse>(`/widget/${hash}/auth/logout`, config);
	return config?.raw ? res.data : hydrateAuthLogout(res.data);
}

/**
 * POST /widget/{hash}/auth/magic-link/request
 */
export async function apiWidgetAuthMagicRequestCode(hash: string, body: MagicLinkRequestCodeRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/widget/${hash}/auth/magic-link/request`, body, config);
}

/**
 * POST /widget/{hash}/auth/login
 */
export async function apiWidgetAuthMagicLogin(hash: string, body: MagicLinkLoginRequest, config: ApiConfig & { raw: true }): Promise<WidgetMemberApiResponse>;
export async function apiWidgetAuthMagicLogin(hash: string, body: MagicLinkLoginRequest, config?: ApiConfig): Promise<WidgetMember>;
export async function apiWidgetAuthMagicLogin(hash: string, body: MagicLinkLoginRequest, config?: ApiConfig): Promise<WidgetMember | WidgetMemberApiResponse> {
	const res = await getApi().post<WidgetMemberApiResponse>(`/widget/${hash}/auth/login`, body, config);
	return config?.raw ? res.data : hydrateWidgetMember(res.data);
}

/**
 * POST /widget/{hash}/auth/logout
 */
export async function apiWidgetAuthMagicLogout(hash: string, config: ApiConfig & { raw: true }): Promise<AuthLogoutApiResponse>;
export async function apiWidgetAuthMagicLogout(hash: string, config?: ApiConfig): Promise<AuthLogout>;
export async function apiWidgetAuthMagicLogout(hash: string, config?: ApiConfig): Promise<AuthLogout | AuthLogoutApiResponse> {
	const res = await getApi().post<AuthLogoutApiResponse>(`/widget/${hash}/auth/logout`, config);
	return config?.raw ? res.data : hydrateAuthLogout(res.data);
}

/**
 * POST /widget/{hash}/auth/okta
 */
export async function apiWidgetAuthOktaLogin(hash: string, body: OktaLoginRequest, config: ApiConfig & { raw: true }): Promise<WidgetMemberApiResponse>;
export async function apiWidgetAuthOktaLogin(hash: string, body: OktaLoginRequest, config?: ApiConfig): Promise<WidgetMember>;
export async function apiWidgetAuthOktaLogin(hash: string, body: OktaLoginRequest, config?: ApiConfig): Promise<WidgetMember | WidgetMemberApiResponse> {
	const res = await getApi().post<WidgetMemberApiResponse>(`/widget/${hash}/auth/okta`, body, config);
	return config?.raw ? res.data : hydrateWidgetMember(res.data);
}

/**
 * POST /widget/{hash}/auth/logout
 */
export async function apiWidgetAuthOktaLogout(hash: string, config: ApiConfig & { raw: true }): Promise<AuthLogoutApiResponse>;
export async function apiWidgetAuthOktaLogout(hash: string, config?: ApiConfig): Promise<AuthLogout>;
export async function apiWidgetAuthOktaLogout(hash: string, config?: ApiConfig): Promise<AuthLogout | AuthLogoutApiResponse> {
	const res = await getApi().post<AuthLogoutApiResponse>(`/widget/${hash}/auth/logout`, config);
	return config?.raw ? res.data : hydrateAuthLogout(res.data);
}

/**
 * POST /widget/{hash}/availability
 */
export async function apiAppWidgetAvailabilityGetavailability(hash: string, body: GetAvailabilityRequest, config: ApiConfig & { raw: true }): Promise<WidgetAvailabilityApiResponse>;
export async function apiAppWidgetAvailabilityGetavailability(hash: string, body: GetAvailabilityRequest, config?: ApiConfig): Promise<WidgetAvailability>;
export async function apiAppWidgetAvailabilityGetavailability(hash: string, body: GetAvailabilityRequest, config?: ApiConfig): Promise<WidgetAvailability | WidgetAvailabilityApiResponse> {
	const res = await getApi().post<WidgetAvailabilityApiResponse>(`/widget/${hash}/availability`, body, config);
	return config?.raw ? res.data : hydrateWidgetAvailability(res.data);
}

/**
 * POST /widget/{hash}/booking
 */
export async function apiWidgetBook(hash: string, body: WidgetBookRequest, config: ApiConfig & { raw: true }): Promise<WidgetBookApiResponse>;
export async function apiWidgetBook(hash: string, body: WidgetBookRequest, config?: ApiConfig): Promise<WidgetBook>;
export async function apiWidgetBook(hash: string, body: WidgetBookRequest, config?: ApiConfig): Promise<WidgetBook | WidgetBookApiResponse> {
	const res = await getApi().post<WidgetBookApiResponse>(`/widget/${hash}/booking`, body, config);
	return config?.raw ? res.data : hydrateWidgetBook(res.data);
}

/**
 * GET /widget/{hash}/booking/{bookingId}
 */
export async function apiWidgetGetBooking(hash: string, bookingId: string, config: ApiConfig & { raw: true }): Promise<WidgetBookingApiResponse>;
export async function apiWidgetGetBooking(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBooking>;
export async function apiWidgetGetBooking(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBooking | WidgetBookingApiResponse> {
	const res = await getApi().get<WidgetBookingApiResponse>(`/widget/${hash}/booking/${bookingId}`, config);
	return config?.raw ? res.data : hydrateWidgetBooking(res.data);
}

/**
 * DELETE /widget/{hash}/booking/{bookingId}
 */
export async function apiWidgetCancel(hash: string, bookingId: string, config: ApiConfig & { raw: true }): Promise<WidgetBookingApiResponse>;
export async function apiWidgetCancel(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBooking>;
export async function apiWidgetCancel(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBooking | WidgetBookingApiResponse> {
	const res = await getApi().delete<WidgetBookingApiResponse>(`/widget/${hash}/booking/${bookingId}`, config);
	return config?.raw ? res.data : hydrateWidgetBooking(res.data);
}

/**
 * GET /widget/{hash}/booking/{bookingId}/status
 */
export async function apiWidgetGetBookingStatus(hash: string, bookingId: string, params: WidgetBookingStatusRequest | undefined, config: ApiConfig & { raw: true }): Promise<WidgetBookingStatusApiResponse>;
export async function apiWidgetGetBookingStatus(hash: string, bookingId: string, params?: WidgetBookingStatusRequest, config?: ApiConfig): Promise<WidgetBookingStatus>;
export async function apiWidgetGetBookingStatus(hash: string, bookingId: string, params?: WidgetBookingStatusRequest, config?: ApiConfig): Promise<WidgetBookingStatus | WidgetBookingStatusApiResponse> {
	const res = await getApi().get<WidgetBookingStatusApiResponse>(`/widget/${hash}/booking/${bookingId}/status`, { params, ...config });
	return config?.raw ? res.data : hydrateWidgetBookingStatus(res.data);
}

/**
 * GET /widget/{hash}/booking/{bookingId}/summary
 */
export async function apiWidgetSummary(hash: string, bookingId: string, config: ApiConfig & { raw: true }): Promise<WidgetBookingSummaryApiResponse>;
export async function apiWidgetSummary(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBookingSummary>;
export async function apiWidgetSummary(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBookingSummary | WidgetBookingSummaryApiResponse> {
	const res = await getApi().get<WidgetBookingSummaryApiResponse>(`/widget/${hash}/booking/${bookingId}/summary`, config);
	return config?.raw ? res.data : hydrateWidgetBookingSummary(res.data);
}

/**
 * POST /widget/{hash}/booking/{bookingId}/booked
 */
export async function apiWidgetConfirm(hash: string, bookingId: string, config: ApiConfig & { raw: true }): Promise<WidgetBookApiResponse>;
export async function apiWidgetConfirm(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBook>;
export async function apiWidgetConfirm(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBook | WidgetBookApiResponse> {
	const res = await getApi().post<WidgetBookApiResponse>(`/widget/${hash}/booking/${bookingId}/booked`, config);
	return config?.raw ? res.data : hydrateWidgetBook(res.data);
}

/**
 * POST /widget/{hash}/booking/{bookingId}/to_be_paid
 */
export async function apiAppWidgetBookingBookingPosttobepaid(hash: string, bookingId: string, config: ApiConfig & { raw: true }): Promise<WidgetBookApiResponse>;
export async function apiAppWidgetBookingBookingPosttobepaid(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBook>;
export async function apiAppWidgetBookingBookingPosttobepaid(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBook | WidgetBookApiResponse> {
	const res = await getApi().post<WidgetBookApiResponse>(`/widget/${hash}/booking/${bookingId}/to_be_paid`, config);
	return config?.raw ? res.data : hydrateWidgetBook(res.data);
}

/**
 * POST /widget/{hash}/giftcard/{bookingId}/search
 */
export async function apiAppWidgetBookingGiftcardSearchgiftcard(hash: string, bookingId: string, body: SearchGiftcardRequest, config: ApiConfig & { raw: true }): Promise<WidgetBookingGiftcardSearchApiResponse>;
export async function apiAppWidgetBookingGiftcardSearchgiftcard(hash: string, bookingId: string, body: SearchGiftcardRequest, config?: ApiConfig): Promise<WidgetBookingGiftcardSearch>;
export async function apiAppWidgetBookingGiftcardSearchgiftcard(hash: string, bookingId: string, body: SearchGiftcardRequest, config?: ApiConfig): Promise<WidgetBookingGiftcardSearch | WidgetBookingGiftcardSearchApiResponse> {
	const res = await getApi().post<WidgetBookingGiftcardSearchApiResponse>(`/widget/${hash}/giftcard/${bookingId}/search`, body, config);
	return config?.raw ? res.data : hydrateWidgetBookingGiftcardSearch(res.data);
}

/**
 * DELETE /widget/{hash}/giftcard/{bookingId}/unlink
 */
export async function apiAppWidgetBookingGiftcardUnlink(hash: string, bookingId: string, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/widget/${hash}/giftcard/${bookingId}/unlink`, config);
}

/**
 * GET /widget/{hash}/guarantee/{bookingId}
 */
export async function apiAppWidgetBookingGuaranteeSetupguaranteepayment(hash: string, bookingId: string, config: ApiConfig & { raw: true }): Promise<WidgetGuaranteePaymentSetupApiResponse>;
export async function apiAppWidgetBookingGuaranteeSetupguaranteepayment(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetGuaranteePaymentSetup>;
export async function apiAppWidgetBookingGuaranteeSetupguaranteepayment(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetGuaranteePaymentSetup | WidgetGuaranteePaymentSetupApiResponse> {
	const res = await getApi().get<WidgetGuaranteePaymentSetupApiResponse>(`/widget/${hash}/guarantee/${bookingId}`, config);
	return config?.raw ? res.data : hydrateWidgetGuaranteePaymentSetup(res.data);
}

/**
 * GET /widget/{hash}/guarantee/{bookingId}/damage
 */
export async function apiAppWidgetBookingGuaranteeSetupdamageguaranteepayment(hash: string, bookingId: string, config: ApiConfig & { raw: true }): Promise<WidgetGuaranteePaymentSetupApiResponse>;
export async function apiAppWidgetBookingGuaranteeSetupdamageguaranteepayment(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetGuaranteePaymentSetup>;
export async function apiAppWidgetBookingGuaranteeSetupdamageguaranteepayment(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetGuaranteePaymentSetup | WidgetGuaranteePaymentSetupApiResponse> {
	const res = await getApi().get<WidgetGuaranteePaymentSetupApiResponse>(`/widget/${hash}/guarantee/${bookingId}/damage`, config);
	return config?.raw ? res.data : hydrateWidgetGuaranteePaymentSetup(res.data);
}

/**
 * GET /widget/my-booking/{hash}/{bookingId}
 */
export async function apiWidgetGetMyBooking(hash: string, bookingId: string, config: ApiConfig & { raw: true }): Promise<WidgetMyBookingApiResponse>;
export async function apiWidgetGetMyBooking(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetMyBooking>;
export async function apiWidgetGetMyBooking(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetMyBooking | WidgetMyBookingApiResponse> {
	const res = await getApi().get<WidgetMyBookingApiResponse>(`/widget/my-booking/${hash}/${bookingId}`, config);
	return config?.raw ? res.data : hydrateWidgetMyBooking(res.data);
}

/**
 * POST /widget/my-booking/{hash}/{bookingId}/cancel
 */
export async function apiWidgetCancelMyBooking(hash: string, bookingId: string, config: ApiConfig & { raw: true }): Promise<WidgetBookingActionStatusApiResponse>;
export async function apiWidgetCancelMyBooking(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBookingActionStatus>;
export async function apiWidgetCancelMyBooking(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBookingActionStatus | WidgetBookingActionStatusApiResponse> {
	const res = await getApi().post<WidgetBookingActionStatusApiResponse>(`/widget/my-booking/${hash}/${bookingId}/cancel`, config);
	return config?.raw ? res.data : hydrateWidgetBookingActionStatus(res.data);
}

/**
 * POST /widget/my-booking/{hash}/{bookingId}/reconfirm
 */
export async function apiWidgetReconfirmMyBooking(hash: string, bookingId: string, config: ApiConfig & { raw: true }): Promise<WidgetBookingActionStatusApiResponse>;
export async function apiWidgetReconfirmMyBooking(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBookingActionStatus>;
export async function apiWidgetReconfirmMyBooking(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetBookingActionStatus | WidgetBookingActionStatusApiResponse> {
	const res = await getApi().post<WidgetBookingActionStatusApiResponse>(`/widget/my-booking/${hash}/${bookingId}/reconfirm`, config);
	return config?.raw ? res.data : hydrateWidgetBookingActionStatus(res.data);
}

/**
 * GET /widget/{hash}/payment/pay/{bookingId}/{paymentType}
 */
export async function apiAppWidgetBookingPaymentSetuppaymentintent(hash: string, bookingId: string, paymentType: string, config: ApiConfig & { raw: true }): Promise<WidgetPaymentSetupApiResponse>;
export async function apiAppWidgetBookingPaymentSetuppaymentintent(hash: string, bookingId: string, paymentType: string, config?: ApiConfig): Promise<WidgetPaymentSetup>;
export async function apiAppWidgetBookingPaymentSetuppaymentintent(hash: string, bookingId: string, paymentType: string, config?: ApiConfig): Promise<WidgetPaymentSetup | WidgetPaymentSetupApiResponse> {
	const res = await getApi().get<WidgetPaymentSetupApiResponse>(`/widget/${hash}/payment/pay/${bookingId}/${paymentType}`, config);
	return config?.raw ? res.data : hydrateWidgetPaymentSetup(res.data);
}

/**
 * GET /widget/{hash}/payment/pay-deposit/{bookingId}/{paymentId}
 */
export async function apiAppWidgetBookingPaymentSetuppaymentintentfordeposit(hash: string, bookingId: string, paymentId: string, config: ApiConfig & { raw: true }): Promise<WidgetPaymentSetupApiResponse>;
export async function apiAppWidgetBookingPaymentSetuppaymentintentfordeposit(hash: string, bookingId: string, paymentId: string, config?: ApiConfig): Promise<WidgetPaymentSetup>;
export async function apiAppWidgetBookingPaymentSetuppaymentintentfordeposit(hash: string, bookingId: string, paymentId: string, config?: ApiConfig): Promise<WidgetPaymentSetup | WidgetPaymentSetupApiResponse> {
	const res = await getApi().get<WidgetPaymentSetupApiResponse>(`/widget/${hash}/payment/pay-deposit/${bookingId}/${paymentId}`, config);
	return config?.raw ? res.data : hydrateWidgetPaymentSetup(res.data);
}

/**
 * GET /widget/{hash}/booking/{id}/payment-split
 */
export async function apiAppWidgetBookingPaymentsplitGetdetails(hash: string, id: string, config: ApiConfig & { raw: true }): Promise<WidgetPaymentSplitDetailsApiResponse>;
export async function apiAppWidgetBookingPaymentsplitGetdetails(hash: string, id: string, config?: ApiConfig): Promise<WidgetPaymentSplitDetails>;
export async function apiAppWidgetBookingPaymentsplitGetdetails(hash: string, id: string, config?: ApiConfig): Promise<WidgetPaymentSplitDetails | WidgetPaymentSplitDetailsApiResponse> {
	const res = await getApi().get<WidgetPaymentSplitDetailsApiResponse>(`/widget/${hash}/booking/${id}/payment-split`, config);
	return config?.raw ? res.data : hydrateWidgetPaymentSplitDetails(res.data);
}

/**
 * POST /widget/{hash}/booking/{id}/payment-split
 */
export async function apiAppWidgetBookingPaymentsplitSetuppayment(hash: string, id: string, body: SetupPaymentSplitRequest, config: ApiConfig & { raw: true }): Promise<WidgetPaymentSetupApiResponse>;
export async function apiAppWidgetBookingPaymentsplitSetuppayment(hash: string, id: string, body: SetupPaymentSplitRequest, config?: ApiConfig): Promise<WidgetPaymentSetup>;
export async function apiAppWidgetBookingPaymentsplitSetuppayment(hash: string, id: string, body: SetupPaymentSplitRequest, config?: ApiConfig): Promise<WidgetPaymentSetup | WidgetPaymentSetupApiResponse> {
	const res = await getApi().post<WidgetPaymentSetupApiResponse>(`/widget/${hash}/booking/${id}/payment-split`, body, config);
	return config?.raw ? res.data : hydrateWidgetPaymentSetup(res.data);
}

/**
 * POST /widget/{hash}/promo-code/package/{packageOrderId}
 */
export async function apiAppWidgetBookingPromocodeApplyforpackage(hash: string, packageOrderId: string, body: ApplyPromoCodeRequest, config: ApiConfig & { raw: true }): Promise<WidgetPromoCodeApplyPackageApiResponse>;
export async function apiAppWidgetBookingPromocodeApplyforpackage(hash: string, packageOrderId: string, body: ApplyPromoCodeRequest, config?: ApiConfig): Promise<WidgetPromoCodeApplyPackage>;
export async function apiAppWidgetBookingPromocodeApplyforpackage(hash: string, packageOrderId: string, body: ApplyPromoCodeRequest, config?: ApiConfig): Promise<WidgetPromoCodeApplyPackage | WidgetPromoCodeApplyPackageApiResponse> {
	const res = await getApi().post<WidgetPromoCodeApplyPackageApiResponse>(`/widget/${hash}/promo-code/package/${packageOrderId}`, body, config);
	return config?.raw ? res.data : hydrateWidgetPromoCodeApplyPackage(res.data);
}

/**
 * DELETE /widget/{hash}/promo-code/package/{packageOrderId}
 */
export async function apiAppWidgetBookingPromocodeRemoveforpackage(hash: string, packageOrderId: string, config: ApiConfig & { raw: true }): Promise<WidgetPromoCodeRemovePackageApiResponse>;
export async function apiAppWidgetBookingPromocodeRemoveforpackage(hash: string, packageOrderId: string, config?: ApiConfig): Promise<WidgetPromoCodeRemovePackage>;
export async function apiAppWidgetBookingPromocodeRemoveforpackage(hash: string, packageOrderId: string, config?: ApiConfig): Promise<WidgetPromoCodeRemovePackage | WidgetPromoCodeRemovePackageApiResponse> {
	const res = await getApi().delete<WidgetPromoCodeRemovePackageApiResponse>(`/widget/${hash}/promo-code/package/${packageOrderId}`, config);
	return config?.raw ? res.data : hydrateWidgetPromoCodeRemovePackage(res.data);
}

/**
 * POST /widget/{hash}/promo-code/giftcard/{giftcardOrderId}
 */
export async function apiAppWidgetBookingPromocodeApplyforgiftcard(hash: string, giftcardOrderId: number, body: ApplyPromoCodeRequest, config: ApiConfig & { raw: true }): Promise<WidgetPromoCodeApplyGiftcardApiResponse>;
export async function apiAppWidgetBookingPromocodeApplyforgiftcard(hash: string, giftcardOrderId: number, body: ApplyPromoCodeRequest, config?: ApiConfig): Promise<WidgetPromoCodeApplyGiftcard>;
export async function apiAppWidgetBookingPromocodeApplyforgiftcard(hash: string, giftcardOrderId: number, body: ApplyPromoCodeRequest, config?: ApiConfig): Promise<WidgetPromoCodeApplyGiftcard | WidgetPromoCodeApplyGiftcardApiResponse> {
	const res = await getApi().post<WidgetPromoCodeApplyGiftcardApiResponse>(`/widget/${hash}/promo-code/giftcard/${giftcardOrderId}`, body, config);
	return config?.raw ? res.data : hydrateWidgetPromoCodeApplyGiftcard(res.data);
}

/**
 * DELETE /widget/{hash}/promo-code/giftcard/{giftcardOrderId}
 */
export async function apiAppWidgetBookingPromocodeRemoveforgiftcard(hash: string, giftcardOrderId: number, config?: ApiConfig): Promise<void> {
	await getApi().delete(`/widget/${hash}/promo-code/giftcard/${giftcardOrderId}`, config);
}

/**
 * POST /widget/{hash}/promo-code/booking/{bookingId}
 */
export async function apiAppWidgetBookingPromocodeApply(hash: string, bookingId: string, body: ApplyPromoCodeRequest, config: ApiConfig & { raw: true }): Promise<WidgetPromoCodeApplyBookingApiResponse>;
export async function apiAppWidgetBookingPromocodeApply(hash: string, bookingId: string, body: ApplyPromoCodeRequest, config?: ApiConfig): Promise<WidgetPromoCodeApplyBooking>;
export async function apiAppWidgetBookingPromocodeApply(hash: string, bookingId: string, body: ApplyPromoCodeRequest, config?: ApiConfig): Promise<WidgetPromoCodeApplyBooking | WidgetPromoCodeApplyBookingApiResponse> {
	const res = await getApi().post<WidgetPromoCodeApplyBookingApiResponse>(`/widget/${hash}/promo-code/booking/${bookingId}`, body, config);
	return config?.raw ? res.data : hydrateWidgetPromoCodeApplyBooking(res.data);
}

/**
 * DELETE /widget/{hash}/promo-code/booking/{bookingId}
 */
export async function apiAppWidgetBookingPromocodeRemove(hash: string, bookingId: string, config: ApiConfig & { raw: true }): Promise<BookingRemovePromoCodeApiResponse>;
export async function apiAppWidgetBookingPromocodeRemove(hash: string, bookingId: string, config?: ApiConfig): Promise<BookingRemovePromoCode>;
export async function apiAppWidgetBookingPromocodeRemove(hash: string, bookingId: string, config?: ApiConfig): Promise<BookingRemovePromoCode | BookingRemovePromoCodeApiResponse> {
	const res = await getApi().delete<BookingRemovePromoCodeApiResponse>(`/widget/${hash}/promo-code/booking/${bookingId}`, config);
	return config?.raw ? res.data : hydrateBookingRemovePromoCode(res.data);
}

/**
 * GET /widget/survey/{hash}/{bookingId}
 */
export async function apiWidgetGetSurvey(hash: string, bookingId: string, config: ApiConfig & { raw: true }): Promise<WidgetSurveyApiResponse>;
export async function apiWidgetGetSurvey(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetSurvey>;
export async function apiWidgetGetSurvey(hash: string, bookingId: string, config?: ApiConfig): Promise<WidgetSurvey | WidgetSurveyApiResponse> {
	const res = await getApi().get<WidgetSurveyApiResponse>(`/widget/survey/${hash}/${bookingId}`, config);
	return config?.raw ? res.data : hydrateWidgetSurvey(res.data);
}

/**
 * POST /widget/survey/{hash}/{bookingId}/rating
 */
export async function apiWidgetPostSurveyRating(hash: string, bookingId: string, body: PostSurveyRatingRequest, config: ApiConfig & { raw: true }): Promise<WidgetSurveyApiResponse>;
export async function apiWidgetPostSurveyRating(hash: string, bookingId: string, body: PostSurveyRatingRequest, config?: ApiConfig): Promise<WidgetSurvey>;
export async function apiWidgetPostSurveyRating(hash: string, bookingId: string, body: PostSurveyRatingRequest, config?: ApiConfig): Promise<WidgetSurvey | WidgetSurveyApiResponse> {
	const res = await getApi().post<WidgetSurveyApiResponse>(`/widget/survey/${hash}/${bookingId}/rating`, body, config);
	return config?.raw ? res.data : hydrateWidgetSurvey(res.data);
}

/**
 * GET /widget/{hash}/content
 */
export async function apiWidgetContent(hash: string, config: ApiConfig & { raw: true }): Promise<WidgetContentApiResponse>;
export async function apiWidgetContent(hash: string, config?: ApiConfig): Promise<WidgetContent>;
export async function apiWidgetContent(hash: string, config?: ApiConfig): Promise<WidgetContent | WidgetContentApiResponse> {
	const res = await getApi().get<WidgetContentApiResponse>(`/widget/${hash}/content`, config);
	return config?.raw ? res.data : hydrateWidgetContent(res.data);
}

/**
 * GET /widget/{hash}/prices
 */
export async function apiWidgetPrice(hash: string, params: WidgetPriceRequest | undefined, config: ApiConfig & { raw: true }): Promise<WidgetPriceListApiResponse>;
export async function apiWidgetPrice(hash: string, params?: WidgetPriceRequest, config?: ApiConfig): Promise<WidgetPriceList>;
export async function apiWidgetPrice(hash: string, params?: WidgetPriceRequest, config?: ApiConfig): Promise<WidgetPriceList | WidgetPriceListApiResponse> {
	const res = await getApi().get<WidgetPriceListApiResponse>(`/widget/${hash}/prices`, { params, ...config });
	return config?.raw ? res.data : hydrateWidgetPriceList(res.data);
}

/**
 * POST /widget/{hash}/register-giftcard-order
 */
export async function apiAppWidgetGiftcardBuygiftcard(hash: string, body: BuyGiftcardRequest, config: ApiConfig & { raw: true }): Promise<WidgetGiftcardOrderApiResponse>;
export async function apiAppWidgetGiftcardBuygiftcard(hash: string, body: BuyGiftcardRequest, config?: ApiConfig): Promise<WidgetGiftcardOrder>;
export async function apiAppWidgetGiftcardBuygiftcard(hash: string, body: BuyGiftcardRequest, config?: ApiConfig): Promise<WidgetGiftcardOrder | WidgetGiftcardOrderApiResponse> {
	const res = await getApi().post<WidgetGiftcardOrderApiResponse>(`/widget/${hash}/register-giftcard-order`, body, config);
	return config?.raw ? res.data : hydrateWidgetGiftcardOrder(res.data);
}

/**
 * GET /widget/{hash}/register-giftcard-order/{giftcardOrderId}/pay
 */
export async function apiAppWidgetGiftcardSetuppaymentintent(hash: string, giftcardOrderId: number, config: ApiConfig & { raw: true }): Promise<WidgetPaymentSetupApiResponse>;
export async function apiAppWidgetGiftcardSetuppaymentintent(hash: string, giftcardOrderId: number, config?: ApiConfig): Promise<WidgetPaymentSetup>;
export async function apiAppWidgetGiftcardSetuppaymentintent(hash: string, giftcardOrderId: number, config?: ApiConfig): Promise<WidgetPaymentSetup | WidgetPaymentSetupApiResponse> {
	const res = await getApi().get<WidgetPaymentSetupApiResponse>(`/widget/${hash}/register-giftcard-order/${giftcardOrderId}/pay`, config);
	return config?.raw ? res.data : hydrateWidgetPaymentSetup(res.data);
}

/**
 * GET /widget/{hash}/giftcards/{giftcardId}
 */
export async function apiAppWidgetGiftcardGetpublicgiftcard(hash: string, giftcardId: string, config: ApiConfig & { raw: true }): Promise<GiftcardPublicApiResponse>;
export async function apiAppWidgetGiftcardGetpublicgiftcard(hash: string, giftcardId: string, config?: ApiConfig): Promise<GiftcardPublic>;
export async function apiAppWidgetGiftcardGetpublicgiftcard(hash: string, giftcardId: string, config?: ApiConfig): Promise<GiftcardPublic | GiftcardPublicApiResponse> {
	const res = await getApi().get<GiftcardPublicApiResponse>(`/widget/${hash}/giftcards/${giftcardId}`, config);
	return config?.raw ? res.data : hydrateGiftcardPublic(res.data);
}

/**
 * GET /widget/{hash}/register-giftcard-order/{giftcardOrderId}
 */
export async function apiAppWidgetGiftcardGetgiftcardorder(hash: string, giftcardOrderId: number, config: ApiConfig & { raw: true }): Promise<WidgetGiftcardOrderApiResponse>;
export async function apiAppWidgetGiftcardGetgiftcardorder(hash: string, giftcardOrderId: number, config?: ApiConfig): Promise<WidgetGiftcardOrder>;
export async function apiAppWidgetGiftcardGetgiftcardorder(hash: string, giftcardOrderId: number, config?: ApiConfig): Promise<WidgetGiftcardOrder | WidgetGiftcardOrderApiResponse> {
	const res = await getApi().get<WidgetGiftcardOrderApiResponse>(`/widget/${hash}/register-giftcard-order/${giftcardOrderId}`, config);
	return config?.raw ? res.data : hydrateWidgetGiftcardOrder(res.data);
}

/**
 * POST /widget/{hash}/register-giftcard-order/{giftcardOrderId}/accept-terms
 */
export async function apiAppWidgetGiftcardAcceptterms(hash: string, giftcardOrderId: number, body: AcceptGiftcardOrderTermsRequest, config?: ApiConfig): Promise<void> {
	await getApi().post(`/widget/${hash}/register-giftcard-order/${giftcardOrderId}/accept-terms`, body, config);
}

/**
 * POST /widget/{hash}/register-giftcard-order/{giftcardOrderId}/confirm-free
 */
export async function apiAppWidgetGiftcardConfirmfreeorder(hash: string, giftcardOrderId: number, config: ApiConfig & { raw: true }): Promise<WidgetGiftcardOrderApiResponse>;
export async function apiAppWidgetGiftcardConfirmfreeorder(hash: string, giftcardOrderId: number, config?: ApiConfig): Promise<WidgetGiftcardOrder>;
export async function apiAppWidgetGiftcardConfirmfreeorder(hash: string, giftcardOrderId: number, config?: ApiConfig): Promise<WidgetGiftcardOrder | WidgetGiftcardOrderApiResponse> {
	const res = await getApi().post<WidgetGiftcardOrderApiResponse>(`/widget/${hash}/register-giftcard-order/${giftcardOrderId}/confirm-free`, config);
	return config?.raw ? res.data : hydrateWidgetGiftcardOrder(res.data);
}

/**
 * GET /widget/{hash}/customer-packages/{id}
 */
export async function apiAppWidgetPackageShow(hash: string, id: string, config: ApiConfig & { raw: true }): Promise<WidgetCustomerPackageDetailsApiResponse>;
export async function apiAppWidgetPackageShow(hash: string, id: string, config?: ApiConfig): Promise<WidgetCustomerPackageDetails>;
export async function apiAppWidgetPackageShow(hash: string, id: string, config?: ApiConfig): Promise<WidgetCustomerPackageDetails | WidgetCustomerPackageDetailsApiResponse> {
	const res = await getApi().get<WidgetCustomerPackageDetailsApiResponse>(`/widget/${hash}/customer-packages/${id}`, config);
	return config?.raw ? res.data : hydrateWidgetCustomerPackageDetails(res.data);
}

/**
 * POST /widget/{hash}/customer-packages/check-promo-code
 */
export async function apiAppWidgetPackageCheckpromocode(hash: string, body: CheckPromoCodeRequest, config: ApiConfig & { raw: true }): Promise<WidgetPackageCheckPromoCodeApiResponse>;
export async function apiAppWidgetPackageCheckpromocode(hash: string, body: CheckPromoCodeRequest, config?: ApiConfig): Promise<WidgetPackageCheckPromoCode>;
export async function apiAppWidgetPackageCheckpromocode(hash: string, body: CheckPromoCodeRequest, config?: ApiConfig): Promise<WidgetPackageCheckPromoCode | WidgetPackageCheckPromoCodeApiResponse> {
	const res = await getApi().post<WidgetPackageCheckPromoCodeApiResponse>(`/widget/${hash}/customer-packages/check-promo-code`, body, config);
	return config?.raw ? res.data : hydrateWidgetPackageCheckPromoCode(res.data);
}

/**
 * POST /widget/{hash}/customer-packages/order
 */
export async function apiAppWidgetPackageOrder(hash: string, body: OrderPackageRequest, config: ApiConfig & { raw: true }): Promise<WidgetPackageOrderApiResponse>;
export async function apiAppWidgetPackageOrder(hash: string, body: OrderPackageRequest, config?: ApiConfig): Promise<WidgetPackageOrder>;
export async function apiAppWidgetPackageOrder(hash: string, body: OrderPackageRequest, config?: ApiConfig): Promise<WidgetPackageOrder | WidgetPackageOrderApiResponse> {
	const res = await getApi().post<WidgetPackageOrderApiResponse>(`/widget/${hash}/customer-packages/order`, body, config);
	return config?.raw ? res.data : hydrateWidgetPackageOrder(res.data);
}

/**
 * GET /widget/{hash}/customer-packages/order/{orderId}/pay
 */
export async function apiAppWidgetPackageSetuppaymentintent(hash: string, orderId: string, config: ApiConfig & { raw: true }): Promise<WidgetPaymentSetupApiResponse>;
export async function apiAppWidgetPackageSetuppaymentintent(hash: string, orderId: string, config?: ApiConfig): Promise<WidgetPaymentSetup>;
export async function apiAppWidgetPackageSetuppaymentintent(hash: string, orderId: string, config?: ApiConfig): Promise<WidgetPaymentSetup | WidgetPaymentSetupApiResponse> {
	const res = await getApi().get<WidgetPaymentSetupApiResponse>(`/widget/${hash}/customer-packages/order/${orderId}/pay`, config);
	return config?.raw ? res.data : hydrateWidgetPaymentSetup(res.data);
}

/**
 * GET /widget/{hash}/customer-packages/order/{orderId}
 */
export async function apiAppWidgetPackageGetorder(hash: string, orderId: string, config: ApiConfig & { raw: true }): Promise<WidgetPackageGetOrderApiResponse>;
export async function apiAppWidgetPackageGetorder(hash: string, orderId: string, config?: ApiConfig): Promise<WidgetPackageGetOrder>;
export async function apiAppWidgetPackageGetorder(hash: string, orderId: string, config?: ApiConfig): Promise<WidgetPackageGetOrder | WidgetPackageGetOrderApiResponse> {
	const res = await getApi().get<WidgetPackageGetOrderApiResponse>(`/widget/${hash}/customer-packages/order/${orderId}`, config);
	return config?.raw ? res.data : hydrateWidgetPackageGetOrder(res.data);
}

/**
 * POST /widget/{hash}/customer-packages/order/{orderId}/confirm-free
 */
export async function apiAppWidgetPackageConfirmfreeorder(hash: string, orderId: string, config: ApiConfig & { raw: true }): Promise<WidgetPackageOrderApiResponse>;
export async function apiAppWidgetPackageConfirmfreeorder(hash: string, orderId: string, config?: ApiConfig): Promise<WidgetPackageOrder>;
export async function apiAppWidgetPackageConfirmfreeorder(hash: string, orderId: string, config?: ApiConfig): Promise<WidgetPackageOrder | WidgetPackageOrderApiResponse> {
	const res = await getApi().post<WidgetPackageOrderApiResponse>(`/widget/${hash}/customer-packages/order/${orderId}/confirm-free`, config);
	return config?.raw ? res.data : hydrateWidgetPackageOrder(res.data);
}

/**
 * POST /widget/{hash}/member/me
 */
export async function apiWidgetMemberUpdateMe(hash: string, body: UpdateWidgetMemberRequest, config: ApiConfig & { raw: true }): Promise<WidgetMemberProfileApiResponse>;
export async function apiWidgetMemberUpdateMe(hash: string, body: UpdateWidgetMemberRequest, config?: ApiConfig): Promise<WidgetMemberProfile>;
export async function apiWidgetMemberUpdateMe(hash: string, body: UpdateWidgetMemberRequest, config?: ApiConfig): Promise<WidgetMemberProfile | WidgetMemberProfileApiResponse> {
	const res = await getApi().post<WidgetMemberProfileApiResponse>(`/widget/${hash}/member/me`, body, config);
	return config?.raw ? res.data : hydrateWidgetMemberProfile(res.data);
}

/**
 * GET /widget/{hash}/member/me
 */
export async function apiWidgetMemberMe(hash: string, config: ApiConfig & { raw: true }): Promise<WidgetMemberApiResponse>;
export async function apiWidgetMemberMe(hash: string, config?: ApiConfig): Promise<WidgetMember>;
export async function apiWidgetMemberMe(hash: string, config?: ApiConfig): Promise<WidgetMember | WidgetMemberApiResponse> {
	const res = await getApi().get<WidgetMemberApiResponse>(`/widget/${hash}/member/me`, config);
	return config?.raw ? res.data : hydrateWidgetMember(res.data);
}

/**
 * GET /widget/{hash}/member/payment-methods/add
 */
export async function apiWidgetMemberAppWidgetWidgetmemberAddpaymentmethod(hash: string, config: ApiConfig & { raw: true }): Promise<BillingSetupIntentApiResponse>;
export async function apiWidgetMemberAppWidgetWidgetmemberAddpaymentmethod(hash: string, config?: ApiConfig): Promise<BillingSetupIntent>;
export async function apiWidgetMemberAppWidgetWidgetmemberAddpaymentmethod(hash: string, config?: ApiConfig): Promise<BillingSetupIntent | BillingSetupIntentApiResponse> {
	const res = await getApi().get<BillingSetupIntentApiResponse>(`/widget/${hash}/member/payment-methods/add`, config);
	return config?.raw ? res.data : hydrateBillingSetupIntent(res.data);
}

/**
 * PUT /booking/{id}
 */
export async function apiAppBookingBookingUpsert(id: string, body: UpsertBookingRequest, config: ApiConfig & { raw: true }): Promise<BookingApiResponse>;
export async function apiAppBookingBookingUpsert(id: string, body: UpsertBookingRequest, config?: ApiConfig): Promise<Booking>;
export async function apiAppBookingBookingUpsert(id: string, body: UpsertBookingRequest, config?: ApiConfig): Promise<Booking | BookingApiResponse> {
	const res = await getApi().put<BookingApiResponse>(`/booking/${id}`, body, config);
	return config?.raw ? res.data : hydrateBooking(res.data);
}

/**
 * PUT /booking/{id}/read
 */
export async function apiAppBookingBookingMarkasread(id: string, config: ApiConfig & { raw: true }): Promise<BookingApiResponse>;
export async function apiAppBookingBookingMarkasread(id: string, config?: ApiConfig): Promise<Booking>;
export async function apiAppBookingBookingMarkasread(id: string, config?: ApiConfig): Promise<Booking | BookingApiResponse> {
	const res = await getApi().put<BookingApiResponse>(`/booking/${id}/read`, config);
	return config?.raw ? res.data : hydrateBooking(res.data);
}

/**
 * PUT /booking/{id}/unread
 */
export async function apiAppBookingBookingMarkasunread(id: string, config: ApiConfig & { raw: true }): Promise<BookingApiResponse>;
export async function apiAppBookingBookingMarkasunread(id: string, config?: ApiConfig): Promise<Booking>;
export async function apiAppBookingBookingMarkasunread(id: string, config?: ApiConfig): Promise<Booking | BookingApiResponse> {
	const res = await getApi().put<BookingApiResponse>(`/booking/${id}/unread`, config);
	return config?.raw ? res.data : hydrateBooking(res.data);
}

/**
 * PUT /booking/{id}/status
 */
export async function apiAppBookingBookingUpdatestatus(id: string, body: UpdateBookingStatusRequest, config: ApiConfig & { raw: true }): Promise<BookingApiResponse>;
export async function apiAppBookingBookingUpdatestatus(id: string, body: UpdateBookingStatusRequest, config?: ApiConfig): Promise<Booking>;
export async function apiAppBookingBookingUpdatestatus(id: string, body: UpdateBookingStatusRequest, config?: ApiConfig): Promise<Booking | BookingApiResponse> {
	const res = await getApi().put<BookingApiResponse>(`/booking/${id}/status`, body, config);
	return config?.raw ? res.data : hydrateBooking(res.data);
}

/**
 * POST /booking/search
 */
export async function apiAppBookingBookingSearch(body: BookingSearchRequest, config: ApiConfig & { raw: true }): Promise<BookingSearchApiResponse>;
export async function apiAppBookingBookingSearch(body: BookingSearchRequest, config?: ApiConfig): Promise<BookingSearch>;
export async function apiAppBookingBookingSearch(body: BookingSearchRequest, config?: ApiConfig): Promise<BookingSearch | BookingSearchApiResponse> {
	const res = await getApi().post<BookingSearchApiResponse>(`/booking/search`, body, config);
	return config?.raw ? res.data : hydrateBookingSearch(res.data);
}

/**
 * POST /booking/agregate
 */
export async function apiAppBookingBookingGetaggregate(body: GetBookingAggregateRequest, config: ApiConfig & { raw: true }): Promise<BookingAggregateApiResponse>;
export async function apiAppBookingBookingGetaggregate(body: GetBookingAggregateRequest, config?: ApiConfig): Promise<BookingAggregate>;
export async function apiAppBookingBookingGetaggregate(body: GetBookingAggregateRequest, config?: ApiConfig): Promise<BookingAggregate | BookingAggregateApiResponse> {
	const res = await getApi().post<BookingAggregateApiResponse>(`/booking/agregate`, body, config);
	return config?.raw ? res.data : hydrateBookingAggregate(res.data);
}

/**
 * POST /booking/{id}/send-summary
 */
export async function apiAppBookingBookingSendsummary(id: string, config?: ApiConfig): Promise<void> {
	await getApi().post(`/booking/${id}/send-summary`, config);
}

/**
 * POST /booking/{id}/promo-code
 */
export async function apiAppBookingBookingApplypromocode(id: string, body: ApplyPromoCodeRequest, config: ApiConfig & { raw: true }): Promise<BookingApplyPromoCodeApiResponse>;
export async function apiAppBookingBookingApplypromocode(id: string, body: ApplyPromoCodeRequest, config?: ApiConfig): Promise<BookingApplyPromoCode>;
export async function apiAppBookingBookingApplypromocode(id: string, body: ApplyPromoCodeRequest, config?: ApiConfig): Promise<BookingApplyPromoCode | BookingApplyPromoCodeApiResponse> {
	const res = await getApi().post<BookingApplyPromoCodeApiResponse>(`/booking/${id}/promo-code`, body, config);
	return config?.raw ? res.data : hydrateBookingApplyPromoCode(res.data);
}

/**
 * DELETE /booking/{id}/promo-code
 */
export async function apiAppBookingBookingRemovepromocode(id: string, config: ApiConfig & { raw: true }): Promise<BookingRemovePromoCodeApiResponse>;
export async function apiAppBookingBookingRemovepromocode(id: string, config?: ApiConfig): Promise<BookingRemovePromoCode>;
export async function apiAppBookingBookingRemovepromocode(id: string, config?: ApiConfig): Promise<BookingRemovePromoCode | BookingRemovePromoCodeApiResponse> {
	const res = await getApi().delete<BookingRemovePromoCodeApiResponse>(`/booking/${id}/promo-code`, config);
	return config?.raw ? res.data : hydrateBookingRemovePromoCode(res.data);
}

/**
 * POST /guarantee/{bookingId}/ask
 */
export async function apiAppBookingGuaranteeAskguarantee(bookingId: string, body: AskGuaranteeRequest, config: ApiConfig & { raw: true }): Promise<BookingApiResponse>;
export async function apiAppBookingGuaranteeAskguarantee(bookingId: string, body: AskGuaranteeRequest, config?: ApiConfig): Promise<Booking>;
export async function apiAppBookingGuaranteeAskguarantee(bookingId: string, body: AskGuaranteeRequest, config?: ApiConfig): Promise<Booking | BookingApiResponse> {
	const res = await getApi().post<BookingApiResponse>(`/guarantee/${bookingId}/ask`, body, config);
	return config?.raw ? res.data : hydrateBooking(res.data);
}

/**
 * PUT /guarantee/{bookingId}/capture
 */
export async function apiAppBookingGuaranteeCaptureguarantee(bookingId: string, body: CaptureGuaranteeRequest, config: ApiConfig & { raw: true }): Promise<BookingApiResponse>;
export async function apiAppBookingGuaranteeCaptureguarantee(bookingId: string, body: CaptureGuaranteeRequest, config?: ApiConfig): Promise<Booking>;
export async function apiAppBookingGuaranteeCaptureguarantee(bookingId: string, body: CaptureGuaranteeRequest, config?: ApiConfig): Promise<Booking | BookingApiResponse> {
	const res = await getApi().put<BookingApiResponse>(`/guarantee/${bookingId}/capture`, body, config);
	return config?.raw ? res.data : hydrateBooking(res.data);
}

/**
 * PUT /guarantee/{bookingId}/pay
 */
export async function apiAppBookingGuaranteePayguarantee(bookingId: string, body: PayGuaranteeRequest, config: ApiConfig & { raw: true }): Promise<BookingApiResponse>;
export async function apiAppBookingGuaranteePayguarantee(bookingId: string, body: PayGuaranteeRequest, config?: ApiConfig): Promise<Booking>;
export async function apiAppBookingGuaranteePayguarantee(bookingId: string, body: PayGuaranteeRequest, config?: ApiConfig): Promise<Booking | BookingApiResponse> {
	const res = await getApi().put<BookingApiResponse>(`/guarantee/${bookingId}/pay`, body, config);
	return config?.raw ? res.data : hydrateBooking(res.data);
}

/**
 * DELETE /guarantee/{bookingId}
 */
export async function apiAppBookingGuaranteeCancelguarantee(bookingId: string, config: ApiConfig & { raw: true }): Promise<BookingApiResponse>;
export async function apiAppBookingGuaranteeCancelguarantee(bookingId: string, config?: ApiConfig): Promise<Booking>;
export async function apiAppBookingGuaranteeCancelguarantee(bookingId: string, config?: ApiConfig): Promise<Booking | BookingApiResponse> {
	const res = await getApi().delete<BookingApiResponse>(`/guarantee/${bookingId}`, config);
	return config?.raw ? res.data : hydrateBooking(res.data);
}

/**
 * PUT /payment/{id}/pay
 */
export async function apiAppBookingPaymentPay(id: string, body: PayBookingPaymentRequest, config: ApiConfig & { raw: true }): Promise<PaymentApiResponse>;
export async function apiAppBookingPaymentPay(id: string, body: PayBookingPaymentRequest, config?: ApiConfig): Promise<Payment>;
export async function apiAppBookingPaymentPay(id: string, body: PayBookingPaymentRequest, config?: ApiConfig): Promise<Payment | PaymentApiResponse> {
	const res = await getApi().put<PaymentApiResponse>(`/payment/${id}/pay`, body, config);
	return config?.raw ? res.data : hydratePayment(res.data);
}

/**
 * PUT /payment/{id}/refund
 */
export async function apiAppBookingPaymentRefund(id: string, body: RefundBookingPaymentRequest, config: ApiConfig & { raw: true }): Promise<PaymentApiResponse>;
export async function apiAppBookingPaymentRefund(id: string, body: RefundBookingPaymentRequest, config?: ApiConfig): Promise<Payment>;
export async function apiAppBookingPaymentRefund(id: string, body: RefundBookingPaymentRequest, config?: ApiConfig): Promise<Payment | PaymentApiResponse> {
	const res = await getApi().put<PaymentApiResponse>(`/payment/${id}/refund`, body, config);
	return config?.raw ? res.data : hydratePayment(res.data);
}

/**
 * PUT /payment/{id}/cancel
 */
export async function apiAppBookingPaymentCancel(id: string, config: ApiConfig & { raw: true }): Promise<PaymentApiResponse>;
export async function apiAppBookingPaymentCancel(id: string, config?: ApiConfig): Promise<Payment>;
export async function apiAppBookingPaymentCancel(id: string, config?: ApiConfig): Promise<Payment | PaymentApiResponse> {
	const res = await getApi().put<PaymentApiResponse>(`/payment/${id}/cancel`, config);
	return config?.raw ? res.data : hydratePayment(res.data);
}

/**
 * GET /payment/{id}
 */
export async function apiAppBookingPaymentGetpayment(id: string, config: ApiConfig & { raw: true }): Promise<PaymentApiResponse>;
export async function apiAppBookingPaymentGetpayment(id: string, config?: ApiConfig): Promise<Payment>;
export async function apiAppBookingPaymentGetpayment(id: string, config?: ApiConfig): Promise<Payment | PaymentApiResponse> {
	const res = await getApi().get<PaymentApiResponse>(`/payment/${id}`, config);
	return config?.raw ? res.data : hydratePayment(res.data);
}

/**
 * GET /payment/{id}/refunds
 */
export async function apiAppBookingPaymentListrefunds(id: string, config: ApiConfig & { raw: true }): Promise<PaymentRefundListApiResponse>;
export async function apiAppBookingPaymentListrefunds(id: string, config?: ApiConfig): Promise<PaymentRefundList>;
export async function apiAppBookingPaymentListrefunds(id: string, config?: ApiConfig): Promise<PaymentRefundList | PaymentRefundListApiResponse> {
	const res = await getApi().get<PaymentRefundListApiResponse>(`/payment/${id}/refunds`, config);
	return config?.raw ? res.data : hydratePaymentRefundList(res.data);
}
